import React from 'react'
import classes from './Icons.module.css'

export const WifiCirclePinkIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#F9ECE3" />
    <mask id="mask0_6085_2757" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24">
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6085_2757)">
      <path d="M24 32.7113C23.4347 32.7113 22.9568 32.5161 22.5663 32.1258C22.176 31.7355 21.9808 31.2575 21.9808 30.692C21.9808 30.1267 22.176 29.6489 22.5663 29.2585C22.9568 28.8682 23.4347 28.673 24 28.673C24.5654 28.673 25.0433 28.8682 25.4338 29.2585C25.8241 29.6489 26.0193 30.1267 26.0193 30.692C26.0193 31.2575 25.8241 31.7355 25.4338 32.1258C25.0433 32.5161 24.5654 32.7113 24 32.7113ZM24 22.769C25.2115 22.769 26.3574 22.969 27.4375 23.369C28.5177 23.769 29.4936 24.3223 30.3653 25.0288C30.6153 25.221 30.7445 25.47 30.7528 25.7758C30.7611 26.0816 30.6538 26.346 30.4308 26.569C30.218 26.7819 29.9561 26.8892 29.6453 26.891C29.3343 26.893 29.0538 26.803 28.8038 26.621C28.145 26.1172 27.4065 25.721 26.5885 25.4325C25.7705 25.144 24.9077 24.9998 24 24.9998C23.0924 24.9998 22.2295 25.144 21.4115 25.4325C20.5935 25.721 19.8551 26.1172 19.1963 26.621C18.9463 26.803 18.6658 26.8905 18.3548 26.8835C18.044 26.8764 17.7821 26.7664 17.5693 26.5535C17.3565 26.3305 17.2516 26.0661 17.2548 25.7603C17.2581 25.4546 17.3848 25.2056 17.6348 25.0133C18.5065 24.307 19.4824 23.7563 20.5625 23.3613C21.6427 22.9665 22.7885 22.769 24 22.769ZM24 16.769C26.0577 16.769 27.985 17.1155 29.7818 17.8085C31.5786 18.5015 33.1847 19.473 34.6 20.723C34.85 20.9357 34.9818 21.1991 34.9953 21.5133C35.0086 21.8275 34.9038 22.096 34.6808 22.319C34.4616 22.5382 34.195 22.644 33.8808 22.6363C33.5668 22.6286 33.2815 22.5203 33.025 22.3113C31.8059 21.264 30.428 20.4502 28.8913 19.87C27.3548 19.2899 25.7244 18.9998 24 18.9998C22.2757 18.9998 20.6453 19.2899 19.1088 19.87C17.5721 20.4502 16.1942 21.264 14.975 22.3113C14.7185 22.5203 14.4333 22.6286 14.1193 22.6363C13.8051 22.644 13.5385 22.5382 13.3193 22.319C13.0963 22.096 12.9915 21.8275 13.0048 21.5133C13.0183 21.1991 13.15 20.9357 13.4 20.723C14.8154 19.473 16.4215 18.5015 18.2183 17.8085C20.0151 17.1155 21.9424 16.769 24 16.769Z" fill="#FC9D91" />
    </g>
  </svg>
)

export const MeetCirclePinkIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#F9ECE3" />
    <path d="M30.0245 28.7701C30.0245 29.5697 30.0493 30.1141 30.02 30.6562C29.9568 31.7698 29.296 32.4746 28.1774 32.4814C23.9037 32.5062 19.63 32.5062 15.3563 32.4814C14.2355 32.4746 13.5318 31.7743 13.5206 30.6585C13.489 27.347 13.4958 24.0333 13.5273 20.7195C13.5296 20.401 13.7551 20.0193 13.9897 19.7753C15.2278 18.4901 16.4772 17.2116 17.7785 15.994C18.0874 15.7049 18.6152 15.5242 19.0459 15.5197C21.9439 15.479 25.2749 15.5129 28.1752 15.5197C29.8441 15.5242 30.0132 16.116 30.0267 17.7921C30.029 18.1851 30.0267 18.5759 30.0267 19.2174C30.9942 18.463 31.8963 17.6724 32.6586 17.0196C33.0014 16.7666 33.5178 16.5817 33.9057 16.6446C34.5076 16.7422 34.465 17.3923 34.4696 17.7989C34.5101 21.9303 34.5101 26.0617 34.4696 30.1932C34.465 30.5975 34.2034 31.2187 33.899 31.3429C33.5787 31.4717 32.9969 31.2187 32.6518 30.9657C31.8016 30.3377 31.0213 29.6149 30.0245 28.7701ZM18.9174 19.9719C20.5975 19.9719 22.2236 19.9719 23.8496 19.9719C24.9892 19.9719 25.5598 20.5268 25.5613 21.6366C25.5613 22.0252 25.5613 22.4114 25.5613 23.0123C26.3259 22.373 28.8518 20.383 29.075 20.1571C29.075 19.7054 29.0773 18.969 29.0773 17.3336C29.0773 16.6559 29.0074 16.3871 28.1752 16.3938C26.1297 16.4119 23.8135 16.3938 21.7657 16.3938C20.8163 16.3938 19.8646 16.3938 18.9151 16.3938V19.9741L18.9174 19.9719ZM25.5613 24.9617C25.5613 25.5761 25.5613 25.9036 25.5613 26.2311C25.5546 28.1986 25.744 28.0156 23.7526 28.0201C22.1334 28.0247 20.5163 28.0201 18.9264 28.0201V31.5959C22.0296 31.5959 25.0719 31.6049 28.1143 31.5823C28.3804 31.5823 29.0646 31.3384 29.075 30.8866C29.1021 29.7143 29.075 29.1925 29.075 28.176C28.2879 27.3854 26.7904 26.012 25.5613 24.9617ZM33.5178 30.5501V17.442C32.406 18.3884 30.2049 20.1571 30.0267 20.3069C30.0267 20.6089 30.0267 20.7874 30.0267 21.1527C30.0267 21.2238 30.0087 24.9436 30.047 26.8433C30.0538 27.2047 30.02 27.3854 30.0245 27.6113C30.8815 28.4019 32.406 29.6013 33.5201 30.5478L33.5178 30.5501ZM18.9444 20.9115V27.0353H24.6096V20.9115H18.9444ZM14.4655 20.8844V27.0466H17.8845V20.8844H14.4655ZM17.9183 31.5959V28.0811H14.4655C14.4458 29.6739 14.4655 31.1125 14.4655 31.5959C14.982 31.5959 16.3499 31.5959 17.9183 31.5959ZM29.075 26.7733V21.221C27.9226 22.2013 26.9032 23.0665 25.8184 23.9904C26.937 24.9458 27.9203 25.7839 29.075 26.771V26.7733ZM17.8935 19.9086V17.2974C17.0117 18.1738 16.166 19.0141 15.2661 19.9086H17.8935Z" fill="#FC9D91" stroke="#FC9D91" strokeWidth="0.5" />
  </svg>

)

export const ChairCirclePinkIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#F9ECE3" />
    <mask id="mask0_6085_2773" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24">
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6085_2773)">
      <path d="M17.019 32.1732C16.8063 32.1732 16.6283 32.1014 16.4848 31.9577C16.3411 31.8139 16.2693 31.6357 16.2693 31.4232V30.4232H16C15.3013 30.4232 14.71 30.1812 14.226 29.6972C13.742 29.2134 13.5 28.6221 13.5 27.9232V22.9232C13.5 22.1861 13.7516 21.5851 14.2548 21.1205C14.7581 20.6556 15.3398 20.4232 16 20.4232V18.6157C16 17.9169 16.242 17.3256 16.726 16.8417C17.21 16.3577 17.8013 16.1157 18.5 16.1157H29.5C30.1987 16.1157 30.79 16.3577 31.274 16.8417C31.758 17.3256 32 17.9169 32 18.6157V20.4232C32.6858 20.4232 33.274 20.6605 33.7645 21.135C34.2548 21.6093 34.5 22.2054 34.5 22.9232V27.9232C34.5 28.6221 34.258 29.2134 33.774 29.6972C33.29 30.1812 32.6987 30.4232 32 30.4232H31.7307V31.4232C31.7307 31.6357 31.6622 31.8139 31.525 31.9577C31.3878 32.1014 31.2129 32.1732 31.0002 32.1732C30.7878 32.1732 30.6096 32.1014 30.4657 31.9577C30.3219 31.8139 30.25 31.6357 30.25 31.4232V30.4232H17.7693V31.4232C17.7693 31.6361 17.6973 31.8143 17.5535 31.958C17.4097 32.1015 17.2315 32.1732 17.019 32.1732ZM16 28.9232H32C32.2833 28.9232 32.5208 28.8274 32.7125 28.6357C32.9042 28.4441 33 28.2066 33 27.9232V22.9232C33 22.6399 32.9042 22.4024 32.7125 22.2107C32.5208 22.0191 32.2833 21.9232 32 21.9232C31.7167 21.9232 31.4792 22.0191 31.2875 22.2107C31.0958 22.4024 31 22.6399 31 22.9232V26.6732H17V22.9232C17 22.6399 16.9042 22.4024 16.7125 22.2107C16.5208 22.0191 16.2833 21.9232 16 21.9232C15.7167 21.9232 15.4792 22.0191 15.2875 22.2107C15.0958 22.4024 15 22.6399 15 22.9232V27.9232C15 28.2066 15.0958 28.4441 15.2875 28.6357C15.4792 28.8274 15.7167 28.9232 16 28.9232ZM18.5 25.1732H29.5V22.9232C29.5 22.5182 29.5917 22.1484 29.775 21.8137C29.9583 21.4791 30.2 21.1989 30.5 20.9732V18.6157C30.5 18.3324 30.4042 18.0949 30.2125 17.9032C30.0208 17.7116 29.7833 17.6157 29.5 17.6157H18.5C18.2167 17.6157 17.9792 17.7116 17.7875 17.9032C17.5958 18.0949 17.5 18.3324 17.5 18.6157V20.9732C17.8 21.1989 18.0417 21.4791 18.225 21.8137C18.4083 22.1484 18.5 22.5182 18.5 22.9232V25.1732Z" fill="#FC9D91" />
    </g>
  </svg>

)

export const ConversationCirclePinkIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#F9ECE3" />
    <mask id="mask0_6085_2781" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24">
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6085_2781)">
      <path d="M17.2505 22.7499C16.9707 22.7499 16.734 22.6534 16.5405 22.4602C16.3468 22.2669 16.25 22.0303 16.25 21.7504C16.25 21.4706 16.3467 21.2339 16.54 21.0404C16.7332 20.8468 16.9697 20.7499 17.2495 20.7499C17.5293 20.7499 17.7661 20.8465 17.9598 21.0397C18.1533 21.233 18.25 21.4696 18.25 21.7494C18.25 22.0293 18.1534 22.2659 17.9603 22.4594C17.7669 22.6531 17.5303 22.7499 17.2505 22.7499ZM30.7505 22.7499C30.4707 22.7499 30.2339 22.6534 30.0403 22.4602C29.8468 22.2669 29.75 22.0303 29.75 21.7504C29.75 21.4706 29.8466 21.2339 30.0398 21.0404C30.2331 20.8468 30.4697 20.7499 30.7495 20.7499C31.0293 20.7499 31.266 20.8465 31.4595 21.0397C31.6532 21.233 31.75 21.4696 31.75 21.7494C31.75 22.0293 31.6533 22.2659 31.46 22.4594C31.2668 22.6531 31.0303 22.7499 30.7505 22.7499ZM16 31.4999V32.7499C16 32.9624 15.9281 33.1405 15.7843 33.2842C15.6404 33.428 15.4623 33.4999 15.2498 33.4999C15.0371 33.4999 14.859 33.428 14.7155 33.2842C14.5718 33.1405 14.5 32.9624 14.5 32.7499V30.9084C14.5 30.6476 14.5867 30.431 14.76 30.2587C14.9332 30.0862 15.1478 29.9999 15.404 29.9999H18.5C17.4642 29.9999 16.5803 29.6339 15.8482 28.9019C15.1161 28.1698 14.75 27.2858 14.75 26.2499C14.75 26.0374 14.8219 25.8594 14.9657 25.7157C15.1096 25.5719 15.2877 25.4999 15.5002 25.4999C15.7129 25.4999 15.8911 25.5719 16.0347 25.7157C16.1783 25.8594 16.25 26.0374 16.25 26.2499C16.25 26.8688 16.4703 27.3984 16.911 27.8389C17.3517 28.2796 17.8813 28.4999 18.5 28.4999V25.9037C18.5 25.6477 18.5867 25.433 18.76 25.2597C18.9332 25.0865 19.1478 24.9999 19.404 24.9999H21.2L20.25 21.1249C19.9038 19.7134 19.1776 18.5503 18.0713 17.6354C16.9648 16.7208 15.6807 16.191 14.2192 16.0462C14.0064 16.0257 13.8333 15.9406 13.7 15.7909C13.5667 15.6413 13.5 15.4605 13.5 15.2487C13.5 15.0367 13.5692 14.8589 13.7077 14.7154C13.8462 14.5718 14.0167 14.5102 14.2192 14.5307C16.0154 14.6755 17.601 15.3134 18.976 16.4442C20.351 17.575 21.2571 19.0135 21.6943 20.7597L22.8628 25.3742C22.9376 25.6594 22.883 25.9183 22.699 26.1509C22.515 26.3836 22.2756 26.4999 21.9808 26.4999H20V29.6922C20 30.1894 19.823 30.6149 19.469 30.9689C19.115 31.3229 18.6894 31.4999 18.1923 31.4999H16ZM32 31.4999H29.8078C29.3106 31.4999 28.885 31.3229 28.531 30.9689C28.177 30.6149 28 30.1894 28 29.6922V26.4999H26.0193C25.7244 26.4999 25.485 26.381 25.301 26.1432C25.117 25.9054 25.0686 25.639 25.1557 25.3442L26.3057 20.7597C26.7634 19.0237 27.6772 17.5904 29.047 16.4597C30.417 15.3289 31.9949 14.6859 33.7808 14.5307C33.9832 14.5102 34.1537 14.5719 34.2922 14.7157C34.4307 14.8595 34.5 15.0377 34.5 15.2502C34.5 15.4629 34.4333 15.6435 34.3 15.7922C34.1667 15.941 33.9936 16.0257 33.7808 16.0462C32.3294 16.191 31.0557 16.7234 29.9595 17.6432C28.8633 18.563 28.1319 19.7236 27.7653 21.1249L26.8 24.9999H28.596C28.8522 24.9999 29.0668 25.0865 29.24 25.2597C29.4133 25.433 29.5 25.6477 29.5 25.9037V28.4999C30.1268 28.4936 30.6586 28.2721 31.0953 27.8354C31.5318 27.3989 31.75 26.8704 31.75 26.2499C31.75 26.0374 31.8219 25.8594 31.9657 25.7157C32.1096 25.5719 32.2878 25.4999 32.5002 25.4999C32.7129 25.4999 32.891 25.5719 33.0345 25.7157C33.1782 25.8594 33.25 26.0374 33.25 26.2499C33.25 27.2858 32.8839 28.1681 32.1518 28.8969C31.4198 29.6259 30.5358 29.9936 29.5 29.9999H32.596C32.8522 29.9999 33.0668 30.0865 33.24 30.2597C33.4133 30.433 33.5 30.6477 33.5 30.9037V32.7499C33.5 32.9624 33.4281 33.1405 33.2843 33.2842C33.1404 33.428 32.9622 33.4999 32.7498 33.4999C32.5371 33.4999 32.359 33.428 32.2155 33.2842C32.0718 33.1405 32 32.9624 32 32.7499V31.4999Z" fill="#FC9D91" />
    </g>
  </svg>
)

export const MessageTextCirclePinkIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#F9ECE3" />
    <mask id="mask0_6085_5350" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24">
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6085_5350)">
      <path d="M18.0385 29.5L16.0365 31.5018C15.752 31.7864 15.4248 31.8509 15.0548 31.6952C14.6849 31.5394 14.5 31.2589 14.5 30.8538V16.3077C14.5 15.8026 14.675 15.375 15.025 15.025C15.375 14.675 15.8026 14.5 16.3077 14.5H31.6923C32.1974 14.5 32.625 14.675 32.975 15.025C33.325 15.375 33.5 15.8026 33.5 16.3077V27.6923C33.5 28.1974 33.325 28.625 32.975 28.975C32.625 29.325 32.1974 29.5 31.6923 29.5H18.0385ZM17.4 28H31.6923C31.7693 28 31.8398 27.9679 31.9038 27.9038C31.9679 27.8398 32 27.7692 32 27.6923V16.3077C32 16.2307 31.9679 16.1602 31.9038 16.0962C31.8398 16.0321 31.7693 16 31.6923 16H16.3077C16.2307 16 16.1603 16.0321 16.0963 16.0962C16.0321 16.1602 16 16.2307 16 16.3077V29.3848L17.4 28ZM19 25.75H25C25.2128 25.75 25.391 25.6782 25.5345 25.5345C25.6782 25.391 25.75 25.2128 25.75 25C25.75 24.7872 25.6782 24.609 25.5345 24.4655C25.391 24.3218 25.2128 24.25 25 24.25H19C18.7872 24.25 18.609 24.3218 18.4655 24.4655C18.3218 24.609 18.25 24.7872 18.25 25C18.25 25.2128 18.3218 25.391 18.4655 25.5345C18.609 25.6782 18.7872 25.75 19 25.75ZM19 22.75H29C29.2128 22.75 29.391 22.6782 29.5345 22.5345C29.6782 22.391 29.75 22.2128 29.75 22C29.75 21.7872 29.6782 21.609 29.5345 21.4655C29.391 21.3218 29.2128 21.25 29 21.25H19C18.7872 21.25 18.609 21.3218 18.4655 21.4655C18.3218 21.609 18.25 21.7872 18.25 22C18.25 22.2128 18.3218 22.391 18.4655 22.5345C18.609 22.6782 18.7872 22.75 19 22.75ZM19 19.75H29C29.2128 19.75 29.391 19.6782 29.5345 19.5345C29.6782 19.391 29.75 19.2128 29.75 19C29.75 18.7872 29.6782 18.609 29.5345 18.4655C29.391 18.3218 29.2128 18.25 29 18.25H19C18.7872 18.25 18.609 18.3218 18.4655 18.4655C18.3218 18.609 18.25 18.7872 18.25 19C18.25 19.2128 18.3218 19.391 18.4655 19.5345C18.609 19.6782 18.7872 19.75 19 19.75Z" fill="#FC9D91" />
    </g>
  </svg>
)

export const CellularCirclePinkIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4182_10734)">
      <circle cx="20" cy="19.9995" r="20" fill="#FCF0F6" />
      <mask id="mask0_4182_10734" maskUnits="userSpaceOnUse" x="8" y="8" width="24" height="24">
        <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4182_10734)">
        <path d="M15.3077 30.5C14.8091 30.5 14.3831 30.3234 14.0298 29.9703C13.6766 29.6169 13.5 29.1909 13.5 28.6923V11.3077C13.5 10.8026 13.675 10.375 14.025 10.025C14.375 9.675 14.8026 9.5 15.3077 9.5H24.7308C25.2294 9.5 25.6553 9.67658 26.0085 10.0298C26.3618 10.3831 26.5385 10.8091 26.5385 11.3077V14.4655C26.8128 14.5372 27.0417 14.6804 27.225 14.8952C27.4083 15.1099 27.5 15.3596 27.5 15.6443V17.5288C27.5 17.8134 27.4083 18.0632 27.225 18.278C27.0417 18.4927 26.8128 18.6359 26.5385 18.7078V28.6923C26.5385 29.1909 26.3618 29.6169 26.0085 29.9703C25.6553 30.3234 25.2294 30.5 24.7308 30.5H15.3077ZM15.3077 29H24.7308C24.8204 29 24.8942 28.9712 24.952 28.9135C25.0097 28.8558 25.0385 28.7821 25.0385 28.6923V11.3077C25.0385 11.2179 25.0097 11.1442 24.952 11.0865C24.8942 11.0288 24.8204 11 24.7308 11H15.3077C15.2179 11 15.1442 11.0288 15.0865 11.0865C15.0288 11.1442 15 11.2179 15 11.3077V28.6923C15 28.7821 15.0288 28.8558 15.0865 28.9135C15.1442 28.9712 15.2179 29 15.3077 29ZM20.0192 14.1538C20.2706 14.1538 20.4808 14.0692 20.65 13.9C20.8192 13.7308 20.9038 13.5206 20.9038 13.2693C20.9038 13.0179 20.8192 12.8077 20.65 12.6385C20.4808 12.4693 20.2706 12.3848 20.0192 12.3848C19.7679 12.3848 19.5577 12.4693 19.3885 12.6385C19.2193 12.8077 19.1348 13.0179 19.1348 13.2693C19.1348 13.5206 19.2193 13.7308 19.3885 13.9C19.5577 14.0692 19.7679 14.1538 20.0192 14.1538Z" fill="#707070" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4182_10734">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const WhatsAppCirclePinkIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4171_14990)">
      <circle cx="20" cy="19.9995" r="20" fill="#FCF0F6" />
      <path d="M10 30L11.4058 24.8642C10.5383 23.3608 10.0825 21.6567 10.0833 19.9092C10.0858 14.4458 14.5317 10 19.9941 10C22.645 10.0008 25.1333 11.0333 27.005 12.9067C28.8758 14.78 29.9058 17.27 29.905 19.9183C29.9025 25.3825 25.4566 29.8283 19.9941 29.8283C18.3358 29.8275 16.7017 29.4117 15.2542 28.6217L10 30ZM15.4975 26.8275C16.8942 27.6567 18.2275 28.1533 19.9908 28.1542C24.5308 28.1542 28.2291 24.4592 28.2316 19.9167C28.2333 15.365 24.5525 11.675 19.9975 11.6733C15.4542 11.6733 11.7583 15.3683 11.7567 19.91C11.7558 21.7642 12.2992 23.1525 13.2117 24.605L12.3792 27.645L15.4975 26.8275ZM24.9866 22.2742C24.925 22.1708 24.76 22.1092 24.5116 21.985C24.2641 21.8608 23.0466 21.2617 22.8191 21.1792C22.5925 21.0967 22.4275 21.055 22.2616 21.3033C22.0966 21.5508 21.6216 22.1092 21.4775 22.2742C21.3333 22.4392 21.1883 22.46 20.9408 22.3358C20.6933 22.2117 19.895 21.9508 18.9491 21.1067C18.2133 20.45 17.7158 19.6392 17.5716 19.3908C17.4275 19.1433 17.5566 19.0092 17.68 18.8858C17.7916 18.775 17.9275 18.5967 18.0516 18.4517C18.1775 18.3083 18.2183 18.205 18.3016 18.0392C18.3841 17.8742 18.3433 17.7292 18.2808 17.605C18.2183 17.4817 17.7233 16.2625 17.5175 15.7667C17.3158 15.2842 17.1117 15.3492 16.96 15.3417L16.485 15.3333C16.32 15.3333 16.0517 15.395 15.825 15.6433C15.5983 15.8917 14.9583 16.49 14.9583 17.7092C14.9583 18.9283 15.8458 20.1058 15.9692 20.2708C16.0933 20.4358 17.715 22.9375 20.1991 24.01C20.79 24.265 21.2516 24.4175 21.6108 24.5317C22.2041 24.72 22.7441 24.6933 23.1708 24.63C23.6466 24.5592 24.6358 24.0308 24.8425 23.4525C25.0491 22.8733 25.0491 22.3775 24.9866 22.2742Z" fill="#707070" />
    </g>
    <defs>
      <clipPath id="clip0_4171_14990">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const PinCirclePinkIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#FCF0F6" />
    <mask id="mask0_4171_10342" maskUnits="userSpaceOnUse" x="8" y="8" width="20" height="20">
      <rect x="8" y="8" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4171_10342)">
      <path d="M18.0009 24.2609C19.6312 22.8015 20.8788 21.4016 21.7436 20.0613C22.6085 18.7211 23.0409 17.5472 23.0409 16.5397C23.0409 15.0205 22.5583 13.7716 21.593 12.793C20.6277 11.8144 19.4304 11.3251 18.0009 11.3251C16.5715 11.3251 15.3741 11.8144 14.4089 12.793C13.4436 13.7716 12.9609 15.0205 12.9609 16.5397C12.9609 17.5472 13.3934 18.7211 14.2582 20.0613C15.1231 21.4016 16.3707 22.8015 18.0009 24.2609ZM18.0009 25.4499C17.8386 25.4499 17.6762 25.4219 17.5139 25.3659C17.3514 25.3098 17.2044 25.223 17.073 25.1055C16.3252 24.4163 15.6255 23.7066 14.9736 22.9763C14.322 22.2462 13.7555 21.5163 13.2743 20.7866C12.7929 20.0568 12.412 19.3336 12.1316 18.6168C11.8511 17.8998 11.7109 17.2075 11.7109 16.5397C11.7109 14.6166 12.333 13.0597 13.577 11.869C14.8211 10.6784 16.2958 10.083 18.0009 10.083C19.7061 10.083 21.1807 10.6784 22.4249 11.869C23.6689 13.0597 24.2909 14.6166 24.2909 16.5397C24.2909 17.2075 24.1507 17.8984 23.8703 18.6126C23.5899 19.3269 23.2104 20.0502 22.7318 20.7826C22.253 21.515 21.6878 22.2449 21.0361 22.9724C20.3845 23.7 19.6847 24.4084 18.9368 25.0974C18.8073 25.2149 18.6602 25.303 18.4953 25.3618C18.3306 25.4205 18.1658 25.4499 18.0009 25.4499ZM18.0024 17.8874C18.417 17.8874 18.7714 17.7397 19.0657 17.4445C19.3602 17.1492 19.5074 16.7943 19.5074 16.3797C19.5074 15.9651 19.3598 15.6106 19.0645 15.3161C18.7692 15.0218 18.4142 14.8747 17.9995 14.8747C17.5849 14.8747 17.2305 15.0223 16.9361 15.3176C16.6417 15.6129 16.4945 15.9679 16.4945 16.3826C16.4945 16.7972 16.6421 17.1516 16.9374 17.4459C17.2327 17.7402 17.5877 17.8874 18.0024 17.8874Z" fill="#707070" />
    </g>
  </svg>
)

export const PinCirclePrimaryIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="18" fill="#7B1646" />
    <mask id="mask0_4171_10329" maskUnits="userSpaceOnUse" x="8" y="8" width="20" height="20">
      <rect x="8" y="8" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4171_10329)">
      <path d="M18.0003 25.2005C17.8518 25.2005 17.7138 25.176 17.5861 25.127C17.4583 25.0778 17.3288 25.0014 17.1974 24.8978C16.7968 24.5559 16.2949 24.0892 15.6917 23.4978C15.0887 22.9066 14.5014 22.2426 13.9299 21.506C13.3582 20.7693 12.8731 19.98 12.4747 19.1382C12.0762 18.2963 11.877 17.4512 11.877 16.6028C11.877 14.902 12.4469 13.4458 13.5867 12.2343C14.7267 11.0228 16.1979 10.417 18.0003 10.417C19.7888 10.417 21.2565 11.0228 22.4034 12.2343C23.5502 13.4458 24.1236 14.902 24.1236 16.6028C24.1236 17.4512 23.9209 18.2984 23.5155 19.1445C23.1101 19.9907 22.6264 20.7835 22.0645 21.5228C21.5024 22.2621 20.9198 22.9226 20.3167 23.5043C19.7137 24.0861 19.2118 24.5479 18.8111 24.8897C18.6817 24.9933 18.5519 25.071 18.4217 25.1228C18.2917 25.1746 18.1513 25.2005 18.0003 25.2005ZM18.0017 17.888C18.3747 17.888 18.6909 17.7578 18.9505 17.4972C19.2102 17.2366 19.3401 16.9199 19.3401 16.547C19.3401 16.1741 19.2098 15.8578 18.9492 15.598C18.6887 15.3385 18.3719 15.2087 17.9988 15.2087C17.6259 15.2087 17.3097 15.3389 17.0501 15.5995C16.7904 15.86 16.6605 16.1769 16.6605 16.5499C16.6605 16.9228 16.7908 17.2391 17.0513 17.4987C17.3119 17.7582 17.6287 17.888 18.0017 17.888Z" fill="#F7EEEE" />
    </g>
  </svg>
)

export const PinCirclePinkBigIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#FCF0F6" />
    <mask id="mask0_5200_1605" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24">
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5200_1605)">
      <path d="M24.0011 31.5135C25.9575 29.7622 27.4545 28.0823 28.4924 26.474C29.5302 24.8657 30.0491 23.457 30.0491 22.248C30.0491 20.425 29.47 18.9263 28.3116 17.752C27.1533 16.5777 25.7165 15.9905 24.0011 15.9905C22.2858 15.9905 20.849 16.5777 19.6906 17.752C18.5323 18.9263 17.9531 20.425 17.9531 22.248C17.9531 23.457 18.472 24.8657 19.5099 26.474C20.5477 28.0823 22.0448 29.7622 24.0011 31.5135ZM24.0011 32.9403C23.8063 32.9403 23.6115 32.9067 23.4166 32.8395C23.2216 32.7722 23.0453 32.668 22.8876 32.527C21.9903 31.7 21.1505 30.8483 20.3684 29.972C19.5864 29.0958 18.9066 28.2199 18.3291 27.3443C17.7515 26.4686 17.2944 25.6007 16.9579 24.7405C16.6214 23.8802 16.4531 23.0493 16.4531 22.248C16.4531 19.9403 17.1995 18.0721 18.6924 16.6432C20.1854 15.2144 21.955 14.5 24.0011 14.5C26.0473 14.5 27.8169 15.2144 29.3099 16.6432C30.8027 18.0721 31.5491 19.9403 31.5491 22.248C31.5491 23.0493 31.3809 23.8785 31.0444 24.7355C30.7079 25.5927 30.2525 26.4607 29.6781 27.3395C29.1036 28.2183 28.4254 29.0942 27.6434 29.9672C26.8614 30.8404 26.0216 31.6904 25.1241 32.5173C24.9688 32.6583 24.7922 32.764 24.5944 32.8345C24.3967 32.905 24.199 32.9403 24.0011 32.9403ZM24.0029 23.8652C24.5004 23.8652 24.9257 23.6881 25.2789 23.3338C25.6322 22.9794 25.8089 22.5535 25.8089 22.056C25.8089 21.5585 25.6317 21.1331 25.2774 20.7798C24.923 20.4266 24.497 20.25 23.9994 20.25C23.5019 20.25 23.0765 20.4272 22.7234 20.7815C22.37 21.1358 22.1934 21.5618 22.1934 22.0595C22.1934 22.557 22.3705 22.9823 22.7249 23.3355C23.0792 23.6887 23.5052 23.8652 24.0029 23.8652Z" fill="#707070" />
    </g>
  </svg>

)

export const VideocamCirclePinkIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="24" fill="#FCF0F6" />
    <mask id="mask0_5200_18822" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24">
      <rect x="12" y="12" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5200_18822)">
      <path d="M16.548 31.5C16.043 31.5 15.6155 31.325 15.2655 30.975C14.9155 30.625 14.7405 30.1974 14.7405 29.6923V18.3077C14.7405 17.8026 14.9155 17.375 15.2655 17.025C15.6155 16.675 16.043 16.5 16.548 16.5H27.9327C28.4377 16.5 28.8652 16.675 29.2152 17.025C29.5652 17.375 29.7402 17.8026 29.7402 18.3077V22.8848L32.4865 20.1385C32.634 19.991 32.7996 19.9542 32.9835 20.028C33.1675 20.1017 33.2595 20.2423 33.2595 20.45V27.55C33.2595 27.7577 33.1675 27.8983 32.9835 27.972C32.7996 28.0458 32.634 28.009 32.4865 27.8615L29.7402 25.1152V29.6923C29.7402 30.1974 29.5652 30.625 29.2152 30.975C28.8652 31.325 28.4377 31.5 27.9327 31.5H16.548ZM16.548 30H27.9327C28.0224 30 28.0961 29.9712 28.1537 29.9135C28.2116 29.8558 28.2405 29.7821 28.2405 29.6923V18.3077C28.2405 18.2179 28.2116 18.1442 28.1537 18.0865C28.0961 18.0288 28.0224 18 27.9327 18H16.548C16.4583 18 16.3846 18.0288 16.327 18.0865C16.2693 18.1442 16.2405 18.2179 16.2405 18.3077V29.6923C16.2405 29.7821 16.2693 29.8558 16.327 29.9135C16.3846 29.9712 16.4583 30 16.548 30Z" fill="#707070" />
    </g>
  </svg>

)

export const AlarmClockIcon = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="72" height="72" rx="36" fill="#F7EEEE" />
    <mask id="mask0_6085_5284" maskUnits="userSpaceOnUse" x="12" y="12" width="48" height="48">
      <rect x="12" y="12" width="48" height="48" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6085_5284)">
      <path d="M37.2156 37.6223V29.1343C37.2156 28.8123 37.1061 28.5426 36.8871 28.3253C36.6681 28.1083 36.3962 27.9998 36.0716 27.9998C35.7469 27.9998 35.4782 28.1083 35.2656 28.3253C35.0526 28.5426 34.9461 28.8123 34.9461 29.1343V37.9653C34.9461 38.138 34.9794 38.308 35.0461 38.4753C35.1127 38.643 35.2217 38.8025 35.3731 38.9538L41.4501 45.0308C41.6731 45.2538 41.9334 45.3685 42.2311 45.3748C42.5284 45.3811 42.7951 45.2665 43.0311 45.0308C43.2667 44.7948 43.3846 44.5281 43.3846 44.2308C43.3846 43.9331 43.2667 43.6665 43.0311 43.4308L37.2156 37.6223ZM35.9641 54.9188C33.6351 54.9188 31.4382 54.4778 29.3736 53.5958C27.3092 52.7138 25.5104 51.5093 23.9771 49.9823C22.4437 48.4556 21.2309 46.6605 20.3386 44.5968C19.4462 42.5331 19.0001 40.3251 19.0001 37.9728C19.0001 35.6205 19.4462 33.4163 20.3386 31.3603C21.2309 29.3046 22.4437 27.505 23.9771 25.9613C25.5104 24.4176 27.3092 23.2048 29.3736 22.3228C31.4382 21.4408 33.6351 20.9998 35.9641 20.9998C38.2931 20.9998 40.4884 21.4408 42.5501 22.3228C44.6117 23.2048 46.4142 24.4176 47.9576 25.9613C49.5012 27.505 50.7141 29.3051 51.5961 31.3618C52.4781 33.4185 52.9191 35.6236 52.9191 37.9773C52.9191 40.3306 52.4781 42.5381 51.5961 44.5998C50.7141 46.6615 49.5012 48.4556 47.9576 49.9823C46.4142 51.5093 44.6117 52.7138 42.5501 53.5958C40.4884 54.4778 38.2931 54.9188 35.9641 54.9188ZM16.4346 25.8403C16.1989 25.598 16.0861 25.3281 16.0961 25.0308C16.1064 24.7331 16.2296 24.4665 16.4656 24.2308L22.3426 18.4958C22.5656 18.2935 22.8334 18.1975 23.1461 18.2078C23.4591 18.2178 23.7246 18.3305 23.9426 18.5458C24.1782 18.7691 24.2877 19.0326 24.2711 19.3363C24.2544 19.6403 24.1374 19.9026 23.9201 20.1233L18.0346 25.8613C17.7989 26.064 17.5239 26.1633 17.2096 26.1593C16.8956 26.1556 16.6372 26.0493 16.4346 25.8403ZM55.5041 25.8308C55.2884 26.0461 55.0267 26.1588 54.7191 26.1688C54.4114 26.1791 54.1397 26.0766 53.9041 25.8613L48.0271 20.1268C47.8041 19.9371 47.6842 19.682 47.6676 19.3613C47.6509 19.041 47.7604 18.7691 47.9961 18.5458C48.1987 18.3305 48.4539 18.2178 48.7616 18.2078C49.0692 18.1975 49.3411 18.2935 49.5771 18.4958L55.4541 24.2308C55.6771 24.4358 55.8001 24.6946 55.8231 25.0073C55.8461 25.3203 55.7397 25.5948 55.5041 25.8308ZM35.9636 52.6498C40.0442 52.6498 43.5122 51.222 46.3676 48.3663C49.2226 45.5106 50.6501 42.0441 50.6501 37.9668C50.6501 33.8841 49.2222 30.4138 46.3666 27.5558C43.5109 24.6981 40.0444 23.2693 35.9671 23.2693C31.8844 23.2693 28.4141 24.6981 25.5561 27.5558C22.6984 30.4135 21.2696 33.8826 21.2696 37.9633C21.2696 42.044 22.6984 45.512 25.5561 48.3673C28.4137 51.2223 31.8829 52.6498 35.9636 52.6498Z" fill="#7B1646" />
    </g>
  </svg>
)

export const EmergencySymptomsIcon = () => {
  return (
    <svg
      width='19'
      height='17'
      viewBox='0 0 19 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.5 3.57L16.0032 15.2105H2.99682L9.5 3.57ZM9.5 0L0 17H19L9.5 0ZM10.3636 12.5263H8.63636V14.3158H10.3636V12.5263ZM10.3636 7.15789H8.63636V10.7368H10.3636V7.15789Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const RadioUnChecked = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='15.5' cy='15.5' r='7.5' stroke='#424242' strokeWidth='2' />
    </svg>
  )
}

export const RadioChecked = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='15.5' cy='15.5' r='7.5' stroke='#7B1646' strokeWidth='2' />
      <circle
        cx='15.5'
        cy='15.5'
        r='3.5'
        fill='#7B1646'
        stroke='#7B1646'
        strokeWidth='2'
      />
    </svg>
  )
}

export const SuccessIconV2 = () => {
  return (
    <svg
      width='86'
      height='86'
      viewBox='0 0 86 86'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.70508 43.0004C3.70508 53.4222 7.84511 63.4171 15.2144 70.7865C22.5837 78.1558 32.5787 82.2958 43.0004 82.2958C53.4222 82.2958 63.4171 78.1558 70.7865 70.7865C78.1558 63.4171 82.2958 53.4222 82.2958 43.0004C82.2958 32.5787 78.1558 22.5837 70.7865 15.2144C63.4171 7.84511 53.4222 3.70508 43.0004 3.70508C32.5787 3.70508 22.5837 7.84511 15.2144 15.2144C7.84511 22.5837 3.70508 32.5787 3.70508 43.0004V43.0004Z'
        stroke='#167B2C'
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.6367 45.7669L34.7017 56.8319L62.3642 29.1694'
        stroke='#167B2C'
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const TimeLineIcon = () => {
  return (
    <svg
      width='14'
      height='178'
      viewBox='0 0 14 178'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 14L6.99999 164'
        stroke='#D9D9D9'
        strokeWidth='2'
        strokeDasharray='6 9'
      />
      <circle cx='7' cy='171' r='7' fill='#424242' />
      <path
        d='M5 171.5L6.66667 173L10 170'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='7' cy='7' r='7' fill='#D9D9D9' />
    </svg>
  )
}

export const ErrorIcon = () => {
  return (
    <svg
      width='88'
      height='88'
      viewBox='0 0 88 88'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.57812 44.0003C5.57813 54.1904 9.62616 63.9633 16.8317 71.1688C24.0373 78.3744 33.8101 82.4224 44.0003 82.4224C54.1904 82.4224 63.9633 78.3744 71.1688 71.1688C78.3744 63.9633 82.4224 54.1904 82.4224 44.0003C82.4224 33.8101 78.3744 24.0373 71.1688 16.8317C63.9633 9.62616 54.1904 5.57813 44.0003 5.57812C33.8101 5.57813 24.0373 9.62616 16.8317 16.8317C9.62616 24.0373 5.57813 33.8101 5.57812 44.0003V44.0003Z'
        stroke='#EA3F3F'
        strokeWidth='7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.1562 56.7043L54.8464 35.0142'
        stroke='#EA3F3F'
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M54.8464 56.7043L33.1562 35.0142'
        stroke='#EA3F3F'
        strokeWidth='6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const AbnormalSymptomsIcon = () => {
  return (
    <svg
      width='23'
      height='15'
      viewBox='0 0 23 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.5 2C15.4623 2 18.9959 4.13 20.7209 7.5C18.9959 10.87 15.4727 13 11.5 13C7.52727 13 4.00409 10.87 2.27909 7.5C4.00409 4.13 7.53773 2 11.5 2ZM11.5 0C6.27273 0 1.80864 3.11 0 7.5C1.80864 11.89 6.27273 15 11.5 15C16.7273 15 21.1914 11.89 23 7.5C21.1914 3.11 16.7273 0 11.5 0ZM11.5 5C12.9427 5 14.1136 6.12 14.1136 7.5C14.1136 8.88 12.9427 10 11.5 10C10.0573 10 8.88636 8.88 8.88636 7.5C8.88636 6.12 10.0573 5 11.5 5ZM11.5 3C8.90727 3 6.79545 5.02 6.79545 7.5C6.79545 9.98 8.90727 12 11.5 12C14.0927 12 16.2045 9.98 16.2045 7.5C16.2045 5.02 14.0927 3 11.5 3Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const SedentaryPerson = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 18.0918H14.3305'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
      <path
        d='M16.9006 21.2018V18.9029C16.9006 16.6625 15.0843 14.8462 12.8438 14.8462H11.2592C9.89389 14.8462 8.78711 13.7394 8.78711 12.3741V10.0415C8.78711 7.84074 10.5712 6.05664 12.772 6.05664V6.05664C13.6332 6.05664 14.3313 6.75476 14.3313 7.61594V10.0149C14.3313 10.4187 14.5162 10.8002 14.8331 11.0505L16.9006 12.6826'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
      <circle
        cx='17.5757'
        cy='4.16359'
        r='1.36359'
        stroke='currentColor'
        strokeWidth='1.6'
      />
    </svg>
  )
}

export const MinimallyActivePerson = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.7051 10.4492L17.5875 11.2943H21.9996'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 17.2118H6.85333L8.76525 15.3809'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.82227 10.1687L8.91075 7.21094H14.6465L10.3815 12.7039L14.0582 16.7884V21.9997'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.7012 4.25352C18.7012 5.02402 18.0388 5.70704 17.1481 5.70704C16.2573 5.70704 15.5949 5.02402 15.5949 4.25352C15.5949 3.48302 16.2573 2.8 17.1481 2.8C18.0388 2.8 18.7012 3.48302 18.7012 4.25352Z'
        stroke='currentColor'
        strokeWidth='1.6'
      />
      <path
        d='M10.9003 3.7062L10.6758 3.83162C11.7835 4.27364 13.04 4.1706 14.0584 3.54993C13.039 3.10618 11.8709 3.16399 10.9003 3.7062Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const ActivePerson = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1 20.1054H6.7011C7.42451 20.1054 8.09154 19.7147 8.44543 19.0838L13.9986 9.18334C14.4182 8.43534 13.7632 7.54086 12.9235 7.71495L9.39328 8.44679C8.68108 8.59443 8.35973 9.42882 8.78891 10.016L9.83597 11.4486'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.8184 15.0312H16.3453C17.4499 15.0312 18.3453 15.9267 18.3453 17.0312V21.0014'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.7437 3.38806C17.7437 4.26451 17.0324 4.97612 16.1537 4.97612C15.2749 4.97612 14.5637 4.26451 14.5637 3.38806C14.5637 2.51161 15.2749 1.8 16.1537 1.8C17.0324 1.8 17.7437 2.51161 17.7437 3.38806Z'
        stroke='currentColor'
        strokeWidth='1.6'
      />
    </svg>
  )
}

export const VeryActivePerson = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.84961 16.9472H10.8436C11.5623 16.9472 12.0464 16.2116 11.762 15.5515L10.3428 12.258C10.1542 11.8202 10.3007 11.3102 10.693 11.0393L15.7505 7.54722M15.7505 7.54722L12.7086 5.10349C12.4887 4.92688 12.2045 4.8513 11.926 4.89538L7.67346 5.56828M15.7505 7.54722L17.5734 11.0085C17.7358 11.317 18.0471 11.5186 18.395 11.5406L21.7432 11.7525'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.7973 19.4199L8.71289 21.8936'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
      <path
        d='M21.2001 4.57915C21.2001 5.46488 20.4314 6.25284 19.3946 6.25284C18.3578 6.25284 17.5891 5.46488 17.5891 4.57915C17.5891 3.69343 18.3578 2.90547 19.3946 2.90547C20.4314 2.90547 21.2001 3.69343 21.2001 4.57915Z'
        stroke='currentColor'
        strokeWidth='1.6'
      />
      <path
        d='M6.37036 13.2363H2.72266'
        stroke='currentColor'
        strokeLinecap='round'
      />
      <path
        d='M5.84692 11.0098H2.19922'
        stroke='currentColor'
        strokeLinecap='round'
      />
      <path
        d='M6.37036 9.03125H2.72266'
        stroke='currentColor'
        strokeLinecap='round'
      />
      <path
        d='M12.9374 2.35019L12.6892 2.41757C13.6571 3.11445 14.9012 3.31843 16.0395 2.96258C15.1578 2.2854 14.0103 2.05889 12.9374 2.35019Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const Lightning = () => {
  return (
    <svg
      width='16'
      height='22'
      viewBox='0 0 16 22'
      fill='inherit'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.222 1L1.46641 11.1956C1.39764 11.2764 1.35346 11.3752 1.3391 11.4804C1.32473 11.5855 1.34079 11.6926 1.38536 11.7889C1.42993 11.8852 1.50115 11.9667 1.5906 12.0238C1.68005 12.0809 1.78399 12.1112 1.89011 12.1111H5.77752V21L14.5331 10.8044C14.6018 10.7237 14.6459 10.625 14.6603 10.52C14.6748 10.415 14.6588 10.308 14.6144 10.2118C14.57 10.1155 14.499 10.034 14.4098 9.97677C14.3206 9.91956 14.2168 9.88906 14.1109 9.88889H10.222V1Z'
        stroke='inherit'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const PdfIcon = () => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M43.2 0H14.4C11.76 0 9.6 2.16 9.6 4.8V33.6C9.6 36.24 11.76 38.4 14.4 38.4H43.2C45.84 38.4 48 36.24 48 33.6V4.8C48 2.16 45.84 0 43.2 0ZM22.8 18C22.8 19.992 21.192 21.6 19.2 21.6H16.8V26.4H13.2V12H19.2C21.192 12 22.8 13.608 22.8 15.6V18ZM34.8 22.8C34.8 24.792 33.192 26.4 31.2 26.4H25.2V12H31.2C33.192 12 34.8 13.608 34.8 15.6V22.8ZM44.4 15.6H40.8V18H44.4V21.6H40.8V26.4H37.2V12H44.4V15.6ZM16.8 18H19.2V15.6H16.8V18ZM4.8 9.6H0V43.2C0 45.84 2.16 48 4.8 48H38.4V43.2H4.8V9.6ZM28.8 22.8H31.2V15.6H28.8V22.8Z'
        fill='#DBDBDB'
      />
    </svg>
  )
}

export const LocationIcon = () => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 13 18'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.99653 9.58212L2.99482 9.57945C2.3377 8.55061 2 7.45329 2 6.3C2 3.98003 3.95162 2 6.5 2C9.04838 2 11 3.98003 11 6.3C11 7.45263 10.6628 8.54662 10.0013 9.57108L9.99612 9.57905L9.99105 9.58707C9.61637 10.1796 9.17215 10.7445 8.65257 11.3977C8.63224 11.4233 8.61178 11.449 8.5912 11.4748C8.10746 12.0827 7.55604 12.7756 7.06824 13.5291L7.06762 13.5301C6.8532 13.8617 6.66662 14.1827 6.49679 14.4977C6.32523 14.1817 6.13785 13.8624 5.92438 13.5321C5.42872 12.7617 4.86842 12.0575 4.37814 11.4412L4.33815 11.391C3.81662 10.7353 3.37206 10.1721 2.99653 9.58212ZM2.17857 6.525C2.17857 8.93003 4.17338 10.775 6.5 10.775C8.82662 10.775 10.8214 8.93003 10.8214 6.525C10.8214 4.11997 8.82662 2.275 6.5 2.275C4.17338 2.275 2.17857 4.11997 2.17857 6.525Z'
        fill='#424242'
        stroke='#707070'
        strokeWidth='4'
      />
    </svg>
  )
}

export const LocationPinIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M7.66671 2C5.27099 2 3.33337 3.878 3.33337 6.2C3.33337 7.244 3.6429 8.222 4.20623 9.104C4.79433 10.028 5.56814 10.82 6.16242 11.744C6.45337 12.194 6.66385 12.614 6.88671 13.1C7.04766 13.43 7.17766 14 7.66671 14C8.15576 14 8.28576 13.43 8.44052 13.1C8.66956 12.614 8.87385 12.194 9.1648 11.744C9.75909 10.826 10.5329 10.034 11.121 9.104C11.6905 8.222 12 7.244 12 6.2C12 3.878 10.0624 2 7.66671 2ZM7.66671 7.85C6.81242 7.85 6.11909 7.178 6.11909 6.35C6.11909 5.522 6.81242 4.85 7.66671 4.85C8.52099 4.85 9.21433 5.522 9.21433 6.35C9.21433 7.178 8.52099 7.85 7.66671 7.85Z'
        fill='CurrentColor'
      />
    </svg>
  )
}

export const CameraIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M11.7886 6.54477C11.6206 6.71276 11.3333 6.59378 11.3333 6.35621V4.66667C11.3333 4.3 11.0333 4 10.6667 4H2.66667C2.3 4 2 4.3 2 4.66667V11.3333C2 11.7 2.3 12 2.66667 12H10.6667C11.0333 12 11.3333 11.7 11.3333 11.3333V9.64379C11.3333 9.40622 11.6206 9.28724 11.7886 9.45523L13.5448 11.2114C13.7128 11.3794 14 11.2605 14 11.0229V4.97712C14 4.73955 13.7128 4.62057 13.5448 4.78856L11.7886 6.54477Z'
        fill='CurrentColor'
      />
    </svg>
  )
}

export const PhoneIconOutlined = () => {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.1631 17.0162L11.1718 17.0223C11.9272 17.5033 12.8241 17.7121 13.7142 17.6144C14.6044 17.5166 15.4346 17.1181 16.0676 16.4846L16.6175 15.9347C16.7393 15.813 16.836 15.6684 16.9019 15.5092C16.9679 15.35 17.0018 15.1794 17.0018 15.0072C17.0018 14.8349 16.9679 14.6643 16.9019 14.5051C16.836 14.346 16.7393 14.2014 16.6175 14.0796L14.2981 11.762C14.1763 11.6401 14.0317 11.5435 13.8726 11.4775C13.7134 11.4115 13.5428 11.3776 13.3705 11.3776C13.1982 11.3776 13.0276 11.4115 12.8685 11.4775C12.7093 11.5435 12.5647 11.6401 12.443 11.762C12.197 12.0078 11.8635 12.1459 11.5158 12.1459C11.1681 12.1459 10.8346 12.0078 10.5887 11.762L6.88015 8.05257C6.63431 7.80666 6.4962 7.47317 6.4962 7.12544C6.4962 6.77771 6.63431 6.44422 6.88015 6.19831C7.00201 6.07653 7.09868 5.93192 7.16464 5.77277C7.23059 5.61361 7.26454 5.44302 7.26454 5.27074C7.26454 5.09845 7.23059 4.92786 7.16464 4.76871C7.09868 4.60955 7.00201 4.46495 6.88015 4.34317L4.56166 2.02555C4.31574 1.77971 3.98225 1.6416 3.63453 1.6416C3.2868 1.6416 2.95331 1.77971 2.70739 2.02555L2.15662 2.57545C1.52331 3.20856 1.12495 4.03878 1.02735 4.92894C0.929749 5.81909 1.13876 6.71591 1.61984 7.4712L1.62508 7.47995C4.16579 11.239 7.40354 14.4762 11.1631 17.0162V17.0162Z'
        stroke='#707070'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const HeartIcon = () => {
  return (
    <svg
      width='30'
      height='26'
      viewBox='0 0 30 26'
      fill='inherit'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.0018 24.667L3.63871 12.8156C2.64003 11.8178 1.98089 10.5308 1.75476 9.13721C1.52864 7.74365 1.74701 6.31427 2.3789 5.05179V5.05179C2.8554 4.09908 3.55144 3.27323 4.40969 2.64227C5.26795 2.01131 6.26384 1.59332 7.31531 1.42272C8.36679 1.25212 9.44375 1.33381 10.4575 1.66105C11.4712 1.98829 12.3926 2.55171 13.1459 3.3049L15.0018 5.15964L16.8578 3.3049C17.611 2.55171 18.5325 1.98829 19.5462 1.66105C20.5599 1.33381 21.6369 1.25212 22.6883 1.42272C23.7398 1.59332 24.7357 2.01131 25.594 2.64227C26.4522 3.27323 27.1483 4.09908 27.6247 5.05179C28.2558 6.31378 28.4738 7.74231 28.2479 9.13508C28.022 10.5278 27.3637 11.8142 26.3661 12.8121L15.0018 24.667Z'
        stroke='inherit'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const HomeIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.6623 9.28792L12.0031 2L2.33507 9.28792C2.1352 9.47236 2.01502 9.72738 2 9.99893V21.1281C2.0007 21.3584 2.09251 21.5791 2.25536 21.742C2.41822 21.9048 2.6389 21.9966 2.86922 21.9973H8.66578V17.334C8.66578 16.45 9.01692 15.6023 9.64196 14.9772C10.267 14.3522 11.1147 14.0011 11.9987 14.0011C12.8826 14.0011 13.7303 14.3522 14.3554 14.9772C14.9804 15.6023 15.3316 16.45 15.3316 17.334V22H21.1272C21.3576 21.9993 21.5784 21.9075 21.7414 21.7447C21.9044 21.5819 21.9964 21.3612 21.9973 21.1308V9.99893C21.9819 9.72748 21.8618 9.47258 21.6623 9.28792Z'
        stroke='#707070'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const CloudIcon = () => {
  return (
    <svg
      width='43'
      height='25'
      viewBox='0 0 43 25'
      fill='inherit'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.00026 24.9982H33.9917C36.6094 24.9994 39.098 23.8718 40.8091 21.9089C42.5205 19.946 43.2852 17.342 42.9039 14.7758C42.5226 12.2093 41.0329 9.93435 38.8233 8.5437C38.7201 6.13477 37.6373 3.86958 35.8218 2.26457C34.0065 0.659559 31.6125 -0.149238 29.1857 0.0227442C26.7588 0.194727 24.5055 1.33286 22.9389 3.17749C21.7362 2.3997 20.3298 1.98808 18.8936 1.9939C17.2398 1.99881 15.6345 2.54775 14.3294 3.55409C13.0244 4.56074 12.0935 5.9679 11.6825 7.55545C9.17692 6.78228 6.45558 7.13062 4.23053 8.50957C2.00549 9.8885 0.498053 12.1608 0.102783 14.7318C-0.292446 17.3026 0.463604 19.9168 2.17317 21.8898C3.88304 23.8625 6.37622 24.9984 9.00051 25L9.00026 24.9982Z'
        fill='inherit'
        stroke='inherit'
      />
    </svg>
  )
}

export const CreditCardIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19.5 4.5H4.5C3.11929 4.5 2 5.61929 2 7V17C2 18.3807 3.11929 19.5 4.5 19.5H19.5C20.8807 19.5 22 18.3807 22 17V7C22 5.61929 20.8807 4.5 19.5 4.5Z'
        stroke='#707070'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 9.5H22'
        stroke='#707070'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17 14.5H14.5'
        stroke='#707070'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const MegaPhoneIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 9.33203V14.6654'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22 2.66602V21.3327'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 10.6667L22 4'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2 13.332L22 19.9987'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.89062 14.6289V14.6654C5.92855 15.8883 6.34165 17.07 7.07391 18.0501C7.80617 19.0303 8.82216 19.7616 9.98411 20.1448C11.1461 20.528 12.3978 20.5446 13.5695 20.1924C14.7412 19.8401 15.7762 19.136 16.5342 18.1756'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const Pencil = () => {
  return (
    <svg
      width='8'
      height='8'
      viewBox='0 0 8 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 6.33356V8H1.66644L6.58131 3.08513L4.91487 1.41869L0 6.33356ZM7.87002 1.79642C8.04333 1.62311 8.04333 1.34315 7.87002 1.16984L6.83016 0.129982C6.65685 -0.0433273 6.37689 -0.0433273 6.20358 0.129982L5.39036 0.943202L7.0568 2.60964L7.87002 1.79642Z'
        fill='white'
      />
    </svg>
  )
}

export const SettingsIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.7076 3.13615C10.8708 3.31733 11.0702 3.46219 11.293 3.56134C11.5158 3.6605 11.7569 3.71174 12.0008 3.71174C12.2446 3.71174 12.4858 3.6605 12.7086 3.56134C12.9313 3.46219 13.1308 3.31733 13.294 3.13615L14.1354 2.21292C14.3766 1.94604 14.6944 1.76033 15.0453 1.68128C15.3962 1.60222 15.7629 1.6337 16.0952 1.77139C16.4275 1.90908 16.7091 2.14624 16.9012 2.45031C17.0933 2.75438 17.1867 3.11046 17.1684 3.46969L17.1052 4.71489C17.093 4.9578 17.1318 5.20057 17.2191 5.42757C17.3064 5.65457 17.4403 5.86077 17.6122 6.03287C17.7841 6.20498 17.9901 6.33918 18.2169 6.42683C18.4438 6.51448 18.6865 6.55363 18.9294 6.54177L20.1746 6.47862C20.5336 6.46093 20.8893 6.55468 21.1929 6.74704C21.4966 6.93941 21.7333 7.22096 21.8706 7.55311C22.008 7.88527 22.0392 8.25177 21.9601 8.60239C21.881 8.953 21.6954 9.27057 21.4287 9.51158L20.502 10.3476C20.321 10.5111 20.1764 10.7107 20.0773 10.9335C19.9783 11.1563 19.9272 11.3975 19.9272 11.6413C19.9272 11.8852 19.9783 12.1263 20.0773 12.3491C20.1764 12.572 20.321 12.7715 20.502 12.935L21.4287 13.7711C21.6956 14.0122 21.8813 14.33 21.9604 14.6809C22.0394 15.0318 22.008 15.3986 21.8703 15.7309C21.7326 16.0632 21.4954 16.3447 21.1914 16.5368C20.8873 16.729 20.5312 16.8223 20.172 16.804L18.9268 16.7409C18.6833 16.7283 18.44 16.7671 18.2124 16.8545C17.9849 16.942 17.7783 17.0763 17.6059 17.2486C17.4335 17.421 17.2992 17.6276 17.2118 17.8552C17.1243 18.0827 17.0856 18.3261 17.0981 18.5695L17.1613 19.8147C17.1772 20.1721 17.0827 20.5258 16.8906 20.8276C16.6986 21.1295 16.4182 21.3649 16.0877 21.5019C15.7572 21.6389 15.3925 21.6708 15.0433 21.5933C14.694 21.5158 14.377 21.3327 14.1354 21.0688L13.2985 20.1429C13.1351 19.962 12.9356 19.8174 12.7128 19.7184C12.4901 19.6194 12.249 19.5682 12.0052 19.5682C11.7615 19.5682 11.5204 19.6194 11.2976 19.7184C11.0749 19.8174 10.8754 19.962 10.712 20.1429L9.8715 21.0688C9.6303 21.3339 9.3132 21.5182 8.96343 21.5966C8.61367 21.6749 8.24826 21.6434 7.91702 21.5065C7.58578 21.3696 7.30483 21.1338 7.11246 20.8314C6.9201 20.529 6.82569 20.1746 6.8421 19.8165L6.90614 18.5713C6.91867 18.3279 6.87994 18.0845 6.79247 17.857C6.705 17.6294 6.57074 17.4228 6.39837 17.2504C6.226 17.078 6.01936 16.9438 5.79182 16.8563C5.56429 16.7688 5.32092 16.7301 5.07748 16.7426L3.83228 16.8058C3.4732 16.8245 3.11712 16.7317 2.81294 16.5399C2.50875 16.3482 2.27136 16.067 2.13336 15.735C1.99537 15.403 1.96353 15.0364 2.04222 14.6855C2.1209 14.3347 2.30626 14.0168 2.57285 13.7755L3.49874 12.9394C3.67969 12.776 3.82434 12.5764 3.92335 12.3536C4.02235 12.1307 4.0735 11.8896 4.0735 11.6458C4.0735 11.4019 4.02235 11.1608 3.92335 10.938C3.82434 10.7151 3.67969 10.5155 3.49874 10.3521L2.57285 9.51158C2.30713 9.27054 2.12233 8.95333 2.04373 8.60329C1.96512 8.25326 1.99653 7.88749 2.13366 7.55599C2.2708 7.22448 2.50697 6.94342 2.8099 6.75121C3.11282 6.55901 3.46771 6.46505 3.82605 6.48218L5.07125 6.54533C5.31516 6.55816 5.55904 6.51953 5.78704 6.43196C6.01505 6.3444 6.22209 6.20985 6.39471 6.03706C6.56733 5.86427 6.70168 5.6571 6.78902 5.42901C6.87637 5.20092 6.91476 4.957 6.9017 4.71311L6.8421 3.46702C6.8253 3.10881 6.91943 2.75415 7.11164 2.45142C7.30385 2.14868 7.58479 1.91263 7.91612 1.77547C8.24745 1.63831 8.61304 1.60672 8.96298 1.68501C9.31293 1.7633 9.6302 1.94765 9.8715 2.21292L10.7076 3.13615Z'
        stroke='#7B1646'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.0024 15.6435C14.2129 15.6435 16.0049 13.8516 16.0049 11.6411C16.0049 9.43062 14.2129 7.63867 12.0024 7.63867C9.79195 7.63867 8 9.43062 8 11.6411C8 13.8516 9.79195 15.6435 12.0024 15.6435Z'
        stroke='#7B1646'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const SupportIcon = ({ className }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M3.66667 13.2672H3.13333C2.56754 13.2672 2.02492 13.0424 1.62484 12.6423C1.22476 12.2423 1 11.6996 1 11.1339V9.00052C1 8.43473 1.22476 7.8921 1.62484 7.49203C2.02492 7.09195 2.56754 6.86719 3.13333 6.86719H3.66667C3.80812 6.86719 3.94377 6.92338 4.04379 7.0234C4.14381 7.12342 4.2 7.25907 4.2 7.40052V12.7339C4.2 12.8753 4.14381 13.011 4.04379 13.111C3.94377 13.211 3.80812 13.2672 3.66667 13.2672Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.8635 13.2672H14.3302C14.1888 13.2672 14.0531 13.211 13.9531 13.111C13.8531 13.011 13.7969 12.8753 13.7969 12.7339V7.40052C13.7969 7.25907 13.8531 7.12342 13.9531 7.0234C14.0531 6.92338 14.1888 6.86719 14.3302 6.86719H14.8635C15.4293 6.86719 15.972 7.09195 16.372 7.49203C16.7721 7.8921 16.9969 8.43473 16.9969 9.00052V11.1339C16.9969 11.6996 16.7721 12.2423 16.372 12.6423C15.972 13.0424 15.4293 13.2672 14.8635 13.2672Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.13281 6.86667C3.13281 5.31073 3.75091 3.81852 4.85112 2.71831C5.95133 1.61809 7.44354 1 8.99948 1V1C10.5554 1 12.0476 1.61809 13.1478 2.71831C14.2481 3.81852 14.8661 5.31073 14.8661 6.86667'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.1328 15.9342H12.7328C13.2986 15.9342 13.8412 15.7095 14.2413 15.3094C14.6414 14.9093 14.8661 14.3667 14.8661 13.8009V13.2676'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.063 17.0005H8.99635C8.71346 17.0005 8.44215 16.8881 8.24211 16.6881C8.04207 16.4881 7.92969 16.2168 7.92969 15.9339C7.92969 15.651 8.04207 15.3796 8.24211 15.1796C8.44215 14.9796 8.71346 14.8672 8.99635 14.8672H10.063C10.3459 14.8672 10.6172 14.9796 10.8173 15.1796C11.0173 15.3796 11.1297 15.651 11.1297 15.9339C11.1297 16.2168 11.0173 16.4881 10.8173 16.6881C10.6172 16.8881 10.3459 17.0005 10.063 17.0005Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const Eye = () => {
  return (
    <svg
      width='10'
      height='6'
      viewBox='0 0 10 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 0C2.20309 0 0 3 0 3C0 3 2.20309 6 5 6C7.14062 6 10 3 10 3C10 3 7.14068 0 5 0ZM5 4.86885C4.01564 4.86885 3.21878 4.03279 3.21878 3C3.21878 1.96721 4.01564 1.13115 5 1.13115C5.98436 1.13115 6.78122 1.96721 6.78122 3C6.78122 4.03279 5.98436 4.86885 5 4.86885ZM5 1.98351C4.4688 1.98351 4.03123 2.44249 4.03123 2.99994C4.03123 3.55728 4.46869 4.01637 5 4.01637C5.53121 4.01637 5.96877 3.5574 5.96877 2.99994C5.96877 2.4426 5.53121 1.98351 5 1.98351Z'
        fill='white'
      />
    </svg>
  )
}

export const CloseIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 18L18 6'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 18L6 6'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const LogoPlennaPregnancy = () => {
  return (
    <svg
      width='116'
      height='24'
      viewBox='0 0 116 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_785_42449)'>
        <path
          d='M43.7677 16.6849C43.7677 18.0315 42.7749 18.8464 41.1317 18.8464H39.5698V20.7248H38.667V14.5234H41.1317C42.7749 14.5234 43.7677 15.3383 43.7677 16.6849ZM42.8649 16.6849C42.8649 15.799 42.2595 15.2942 41.1044 15.2942H39.5698V18.0757H41.1044C42.2595 18.0757 42.8649 17.5708 42.8649 16.6849Z'
          fill='#573377'
        />
        <path
          d='M46.4521 14.5234H47.3549V19.954H50.7762V20.7248H46.4521V14.5234Z'
          fill='#573377'
        />
        <path
          d='M57.7591 19.954V20.7248H53.1729V14.5234H57.6329V15.2942H54.0756V17.1984H57.2446V17.9519H54.0756V19.954H57.7591Z'
          fill='#573377'
        />
        <path
          d='M66.0143 14.5234V20.7248H65.2739L61.4819 16.1004V20.7248H60.5791V14.5234H61.3195L65.1105 19.1478V14.5234H66.0133H66.0143Z'
          fill='#573377'
        />
        <path
          d='M74.7037 14.5234V20.7248H73.9633L70.1713 16.1004V20.7248H69.2686V14.5234H70.009L73.8 19.1478V14.5234H74.7028H74.7037Z'
          fill='#573377'
        />
        <path
          d='M81.9843 19.1747H78.6265L77.9311 20.7248H77.001L79.8628 14.5234H80.7558L83.6265 20.7248H82.6787L81.9833 19.1747H81.9843ZM81.6684 18.4663L80.3049 15.4276L78.9415 18.4663H81.6674H81.6684Z'
          fill='#573377'
        />
        <path
          d='M44.2002 10.067L44.1904 5.99065L42.1531 9.34902H41.4313L39.4037 6.078V10.067H37.9004V3.27344H39.2257L41.8166 7.49467L44.3684 3.27344H45.6839L45.7035 10.067H44.2002Z'
          fill='#573377'
        />
        <path
          d='M52.7458 8.61093H49.5318L48.9186 10.067H47.2764L50.3622 3.27344H51.9447L55.0403 10.067H53.359L52.7458 8.61093ZM52.2411 7.41693L51.1437 4.81585L50.0463 7.41693H52.2421H52.2411Z'
          fill='#573377'
        />
        <path
          d='M57.69 4.55478H55.4746V3.27344H61.5074V4.55478H59.292V10.067H57.69V4.55478Z'
          fill='#573377'
        />
        <path
          d='M68.5688 8.80481V10.066H63.209V3.27344H68.4407V4.53463H64.8013V6.00985H68.0153V7.23265H64.8013V8.80481H68.5698H68.5688Z'
          fill='#573377'
        />
        <path
          d='M75.0967 10.067L73.7616 8.17422H72.2876V10.067H70.6855V3.27344H73.6824C74.2956 3.27344 74.8277 3.37422 75.2796 3.57386C75.7314 3.77446 76.0787 4.05952 76.3232 4.42809C76.5667 4.79665 76.689 5.23337 76.689 5.73822C76.689 6.24308 76.5657 6.67788 76.3183 7.04356C76.0708 7.40925 75.7197 7.68855 75.2649 7.8834L76.8171 10.067H75.0967ZM74.6908 4.86C74.4404 4.65652 74.0746 4.55382 73.5934 4.55382H72.2876V6.92167H73.5934C74.0746 6.92167 74.4404 6.81801 74.6908 6.61069C74.9412 6.40337 75.0664 6.11255 75.0664 5.73726C75.0664 5.36198 74.9412 5.06252 74.6908 4.85904V4.86Z'
          fill='#573377'
        />
        <path
          d='M85.1446 3.27344V10.067H83.8291L80.3775 5.94266V10.067H78.7949V3.27344H80.1202L83.5621 7.39773V3.27344H85.1446Z'
          fill='#573377'
        />
        <path
          d='M87.627 3.27344H89.229V10.067H87.627V3.27344Z'
          fill='#573377'
        />
        <path
          d='M91.71 3.27344H94.8555C95.6066 3.27344 96.2707 3.41453 96.8478 3.69575C97.4249 3.97698 97.8728 4.37338 98.1927 4.88496C98.5125 5.39653 98.6719 5.99161 98.6719 6.67116C98.6719 7.3507 98.5115 7.94578 98.1927 8.45736C97.8728 8.96894 97.4249 9.36438 96.8478 9.64656C96.2707 9.92779 95.6066 10.0689 94.8555 10.0689H91.71V3.27344ZM94.7762 8.77602C95.4687 8.77602 96.0204 8.58693 96.4331 8.20781C96.8449 7.82965 97.0512 7.31615 97.0512 6.66924C97.0512 6.02233 96.8449 5.50979 96.4331 5.13067C96.0213 4.7525 95.4687 4.56246 94.7762 4.56246H93.3121V8.7741H94.7762V8.77602Z'
          fill='#573377'
        />
        <path
          d='M105.18 8.61093H101.966L101.353 10.067H99.7109L102.797 3.27344H104.379L107.475 10.067H105.794L105.18 8.61093ZM104.676 7.41693L103.578 4.81585L102.481 7.41693H104.677H104.676Z'
          fill='#573377'
        />
        <path
          d='M109.037 3.27344H112.183C112.934 3.27344 113.598 3.41453 114.175 3.69575C114.752 3.97698 115.2 4.37338 115.52 4.88496C115.84 5.39653 115.999 5.99161 115.999 6.67116C115.999 7.3507 115.839 7.94578 115.52 8.45736C115.2 8.96894 114.752 9.36438 114.175 9.64656C113.598 9.92779 112.934 10.0689 112.183 10.0689H109.037V3.27344ZM112.103 8.77602C112.796 8.77602 113.347 8.58693 113.76 8.20781C114.172 7.82965 114.378 7.31615 114.378 6.66924C114.378 6.02233 114.172 5.50979 113.76 5.13067C113.348 4.7525 112.796 4.56246 112.103 4.56246H110.639V8.7741H112.103V8.77602Z'
          fill='#573377'
        />
        <path
          d='M5.26388 14.2456C6.77697 15.3868 8.39373 16.4177 10.0711 17.3132C10.0252 17.485 9.98017 17.6568 9.93714 17.8295C9.57427 19.2846 8.60891 23.1488 11.1265 23.9243C11.2898 23.9752 11.459 24.0001 11.6292 24.0001C12.3285 24.0001 13.0455 23.5797 13.7047 22.785C14.3483 22.0076 14.9107 20.9144 15.3391 19.6129C18.7643 20.7982 22.2775 21.4432 25.78 21.5306C25.8749 21.5373 25.9708 21.5018 26.0441 21.4355C26.1175 21.3693 26.1615 21.2752 26.1634 21.1773C26.1654 21.0814 26.1292 20.9892 26.0617 20.9192C25.9942 20.8491 25.9023 20.8088 25.8035 20.8069C22.3607 20.7205 18.912 20.0841 15.5493 18.917C15.7978 18.0157 15.9699 17.079 16.0609 16.1297C16.324 13.3904 15.9191 10.7423 14.8882 8.46469C15.1601 8.05677 15.4418 7.65461 15.7274 7.26781C17.8488 4.39318 21.0667 0.635534 24.5124 1.19318C25.8231 1.40434 26.9938 2.44765 27.4956 3.84993C28.0492 5.39618 27.743 7.00002 27.389 8.07309C26.4559 10.8988 24.487 13.7273 21.1919 16.9753C21.1224 17.0444 21.0843 17.1356 21.0843 17.2316C21.0843 17.3285 21.1234 17.4197 21.1929 17.4878C21.3366 17.628 21.5704 17.628 21.7142 17.4869C25.0944 14.1544 27.121 11.2347 28.0912 8.29768C28.4805 7.11904 28.814 5.34819 28.192 3.61094C27.6022 1.96295 26.2045 0.733434 24.6318 0.480045C20.7821 -0.143831 17.3656 3.81442 15.1298 6.84453C14.9214 7.12768 14.715 7.41754 14.5145 7.70932C14.4666 7.62102 14.4187 7.53367 14.3698 7.44729C13.914 6.64777 12.2356 3.88544 9.79043 1.91688C7.36088 -0.0401713 4.98513 -0.509518 2.91943 0.558749C0.0331252 2.04933 -0.634902 6.16115 0.571068 8.91868C1.60587 11.2846 3.62267 13.0084 5.26388 14.2456ZM10.6541 18.0023C10.6824 17.889 10.7118 17.7748 10.7411 17.6616C12.0077 18.3046 13.3203 18.8776 14.6495 19.3671C14.2534 20.5851 13.7301 21.6064 13.1306 22.3291C12.7726 22.762 12.0654 23.4569 11.3475 23.2342C9.68382 22.7207 10.1553 20.0025 10.6541 18.0023ZM14.406 9.21046C15.5396 12.0179 15.7078 15.5116 14.8559 18.6703C13.5257 18.1779 12.2092 17.5982 10.9387 16.9465C11.7241 14.2341 12.89 11.6349 14.406 9.21046ZM13.7243 7.8005C13.8377 7.99918 13.9463 8.20362 14.047 8.40902C12.3941 10.9611 11.1245 13.7148 10.2736 16.5971C8.6852 15.7391 7.15255 14.7562 5.7138 13.6726C4.14301 12.4892 2.21619 10.846 1.24888 8.63457C0.718758 7.42234 0.59552 5.86937 0.919263 4.47956C1.27235 2.96403 2.10469 1.79882 3.26372 1.20086C3.88382 0.881244 4.53619 0.719037 5.2052 0.719037C6.48746 0.719037 7.87144 1.31028 9.32095 2.47741C11.6674 4.36631 13.2841 7.02977 13.7243 7.80146V7.8005Z'
          fill='#573377'
        />
      </g>
      <defs>
        <clipPath id='clip0_785_42449'>
          <rect width='116' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const SexIcon = () => {
  return (
    <svg
      width='13'
      height='18'
      viewBox='0 0 13 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.75758 5.02258C8.38303 5.65862 8.77477 6.52719 8.77477 7.49134C8.77477 8.45836 8.3886 9.33301 7.75874 9.95894L7.75759 9.9601C7.12612 10.5945 6.2648 10.9798 5.30401 10.9798C4.34486 10.9798 3.48281 10.5882 2.84988 9.95954C2.22584 9.33213 1.83323 8.45668 1.83323 7.49134C1.83323 6.52433 2.21942 5.64968 2.84928 5.02374L2.84928 5.02374L2.85044 5.02258C3.48191 4.38814 4.34322 4.00286 5.30401 4.00286C6.26288 4.00286 7.1247 4.39421 7.75758 5.02258ZM2.04458 4.23964L2.04456 4.23966C1.21338 5.07262 0.7 6.22621 0.7 7.49883C0.7 8.77145 1.21338 9.92505 2.04456 10.758C2.68246 11.3981 3.50361 11.8483 4.42114 12.027C4.61504 12.0647 4.73739 12.2173 4.73739 12.3677V14.049C4.73739 14.2147 4.60307 14.349 4.43739 14.349H3.44833C3.13792 14.349 2.88628 14.6007 2.88628 14.9111C2.88628 15.2215 3.13792 15.4731 3.44833 15.4731H4.43739C4.60307 15.4731 4.73739 15.6075 4.73739 15.7731V16.7334C4.73739 17.0463 4.99107 17.3 5.30401 17.3C5.61695 17.3 5.87064 17.0463 5.87064 16.7334V15.7731C5.87064 15.6075 6.00495 15.4731 6.17064 15.4731H7.24347C7.55388 15.4731 7.80552 15.2215 7.80552 14.9111C7.80552 14.6007 7.55388 14.349 7.24347 14.349H6.17064C6.00495 14.349 5.87064 14.2147 5.87064 14.049V12.3677C5.87064 12.2173 5.99298 12.0647 6.18688 12.027C7.10441 11.8483 7.92556 11.3981 8.56346 10.758C9.39464 9.92505 9.90802 8.77145 9.90802 7.49883C9.90802 6.58334 9.63997 5.72508 9.17758 5.006C9.07175 4.84141 9.09565 4.64955 9.20194 4.54509L10.6565 3.1155C10.8462 2.92903 11.1667 3.06344 11.1667 3.32946V4.08012C11.1667 4.39306 11.4204 4.64675 11.7334 4.64675C12.0463 4.64675 12.3 4.39306 12.3 4.08012V1.6C12.3 1.10294 11.8971 0.7 11.4 0.7H8.85692C8.54651 0.7 8.29488 0.951638 8.29488 1.26205C8.29488 1.57246 8.54651 1.8241 8.85692 1.8241H9.61944C9.88796 1.8241 10.0212 2.14983 9.82973 2.33805L8.42897 3.7148C8.32023 3.82167 8.12176 3.84027 7.95802 3.72388C7.20656 3.18969 6.2902 2.87876 5.30401 2.87876C4.03157 2.87876 2.88229 3.40031 2.04458 4.23964Z'
        fill='#7F759B'
        stroke='#7F759B'
        strokeWidth='0.6'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const PlennaHeartIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.1297 7.6146C10.4828 7.17235 10.8142 6.73513 11.1692 6.3162C11.7798 5.59651 12.4477 4.93406 13.2874 4.45974C13.7529 4.19661 14.2467 4.01908 14.791 3.98781C15.7691 3.93137 16.5051 4.33361 17.0282 5.11557C17.4791 5.78995 17.5719 6.54223 17.4524 7.32048C17.2759 8.46758 16.7346 9.46841 16.0779 10.4157C15.4627 11.3034 14.7334 12.0989 13.9548 12.8535C13.8066 12.9972 13.65 13.0094 13.5259 12.8917C13.4017 12.7741 13.4192 12.609 13.5684 12.4619C14.4251 11.619 15.2308 10.7348 15.873 9.72227C16.3281 9.0047 16.7046 8.25268 16.8707 7.41693C16.9709 6.91346 16.9695 6.41 16.8033 5.91634C16.4214 4.77692 15.3601 4.26074 14.1924 4.64894C13.492 4.88159 12.9281 5.31695 12.4062 5.80902C11.6737 6.49983 11.0628 7.28762 10.4901 8.10456C10.4728 8.13142 10.4614 8.16152 10.4567 8.19291C10.452 8.2243 10.4541 8.2563 10.4628 8.28686C11.1506 9.95068 11.1995 11.6521 10.7921 13.3817C10.784 13.4172 10.7771 13.4529 10.7649 13.5141C11.1283 13.6231 11.487 13.7383 11.8504 13.8377C13.1728 14.1991 14.5195 14.4143 15.8948 14.4485C15.9274 14.449 15.96 14.4516 15.9922 14.4562C16.1587 14.4827 16.261 14.6008 16.2462 14.7505C16.2315 14.9003 16.1112 14.9978 15.9409 14.9933C14.1913 14.9485 12.4902 14.6403 10.8314 14.1032C10.7698 14.0833 10.7076 14.0645 10.6454 14.0462C10.6308 14.0449 10.6162 14.0454 10.6017 14.0476C10.5199 14.2415 10.4413 14.4421 10.3513 14.6374C10.133 15.1125 9.86454 15.5577 9.45584 15.9064C8.93747 16.3494 8.31406 16.3661 7.85435 15.9443C7.55778 15.6722 7.44756 15.315 7.41537 14.9326C7.35889 14.2609 7.48494 13.6077 7.66391 12.9648C7.7062 12.813 7.66801 12.7486 7.53296 12.6734C6.37617 12.0374 5.28295 11.3116 4.30787 10.4298C3.63726 9.82296 3.06678 9.13957 2.75276 8.29163C2.3929 7.32445 2.41636 6.35382 2.82915 5.40546C3.44737 3.98542 4.91327 3.39796 6.39773 3.96237C7.10898 4.23292 7.69856 4.67782 8.23767 5.19162C8.94702 5.86838 9.53496 6.63815 10.0383 7.46913C10.0662 7.51524 10.0951 7.55922 10.1297 7.6146ZM7.84944 12.2571C7.88136 12.1718 7.89773 12.1331 7.91055 12.0931C8.3302 10.7668 8.92549 9.49911 9.68147 8.32184C9.76714 8.18935 9.76005 8.09502 9.68693 7.96809C9.20375 7.13048 8.63272 6.35621 7.93811 5.67282C7.42792 5.17068 6.87026 4.72764 6.1841 4.46371C5.04723 4.02676 3.94201 4.43457 3.40127 5.49714C3.09133 6.1066 3.01713 6.75421 3.10116 7.42249C3.19446 8.15437 3.5535 8.76807 4.01786 9.33168C4.6249 10.0686 5.3779 10.6494 6.16719 11.1866C6.70957 11.5533 7.27268 11.8914 7.84944 12.2571ZM10.0615 8.78344C10.0398 8.80521 10.0197 8.82841 10.0012 8.85286C9.32356 9.96335 8.78595 11.149 8.4 12.3843C8.37272 12.4714 8.39291 12.5189 8.47967 12.5565C9.0286 12.795 9.57589 13.0356 10.1245 13.2746C10.1627 13.2868 10.2018 13.2956 10.2416 13.3011C10.6134 11.7793 10.5832 10.2872 10.0615 8.78344ZM8.2093 13.0523C8.15473 13.304 8.09362 13.5478 8.04751 13.7942C7.96866 14.215 7.91328 14.639 7.99813 15.0661C8.05269 15.3476 8.1771 15.5924 8.48458 15.6851C8.77187 15.7718 8.97349 15.6056 9.15901 15.4308C9.50004 15.1096 9.71858 14.7097 9.90164 14.2913C9.96385 14.1482 10.0168 14.0012 10.0719 13.8618L8.2093 13.0523Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export const BeautyIcon = () => {
  return (
    <svg
      width='15'
      height='18'
      viewBox='0 0 15 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='1.47031'
        y='10.65'
        width='6.06364'
        height='6.06364'
        rx='1.35'
        stroke='#BAA28E'
        strokeWidth='1.3'
        strokeLinejoin='round'
      />
      <rect
        x='8.01719'
        y='3.28672'
        width='6.06364'
        height='13.4273'
        rx='1.35'
        stroke='#BAA28E'
        strokeWidth='1.3'
        strokeLinejoin='round'
      />
      <path d='M1.22656 12.4551H7.77202' stroke='#BAA28E' strokeWidth='1.3' />
      <path
        d='M9 1.6C9 1.26863 9.26863 1 9.6 1H12.4909C12.8223 1 13.0909 1.26863 13.0909 1.6V2.63636H9V1.6Z'
        stroke='#BAA28E'
        strokeWidth='1.3'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const StethoscopeIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.2931 3.33736C16.2944 3.33856 16.2935 3.34073 16.2918 3.34073H14.7672C14.5463 3.34073 14.3672 3.51981 14.3672 3.74073V4.28976C14.3672 4.51068 14.5463 4.68976 14.7672 4.68976H15.6547C15.8756 4.68976 16.0547 4.86885 16.0547 5.08976V6.71332C16.0752 7.10462 16.0092 7.49569 15.8605 7.86282C15.7117 8.22996 15.4835 8.56551 15.1895 8.84914C14.8956 9.13276 14.542 9.35856 14.1503 9.51284C13.7586 9.66712 13.3369 9.74667 12.9108 9.74667C12.4847 9.74667 12.063 9.66712 11.6713 9.51284C11.2796 9.35856 10.9261 9.13276 10.6321 8.84914C10.3382 8.56551 10.1099 8.22996 9.96121 7.86282C9.8125 7.49569 9.74643 7.10462 9.767 6.71332V5.08976C9.767 4.86885 9.94608 4.68976 10.167 4.68976H11.0545C11.2754 4.68976 11.4545 4.51068 11.4545 4.28976V3.74073C11.4545 3.51981 11.2754 3.34073 11.0545 3.34073H9.53221C9.21115 3.34073 8.90322 3.45798 8.67619 3.6667C8.44916 3.87542 8.32162 4.15851 8.32162 4.45369V6.67285C8.32183 7.67683 8.71118 8.64789 9.41977 9.41183C10.0532 10.0947 10.9046 10.5721 11.8484 10.7792C12.0422 10.8217 12.1881 10.9884 12.1881 11.1868V12.4602C12.1671 13.1919 11.8451 13.8891 11.2872 14.4113C10.7293 14.9335 9.97688 15.2419 9.18149 15.2744C8.38611 15.3069 7.60687 15.0611 7.00077 14.5864C6.47949 14.1782 6.1196 13.6268 5.97081 13.0179C5.92787 12.8422 6.03341 12.6719 6.19127 12.5835C6.59305 12.3587 6.91721 12.0301 7.12128 11.6359C7.37026 11.155 7.42402 10.6081 7.27286 10.0939C7.1217 9.57974 6.77561 9.13218 6.29701 8.83203C5.8184 8.53189 5.23884 8.39894 4.66297 8.45718C4.08709 8.51541 3.55283 8.761 3.15664 9.14961C2.76045 9.53822 2.52842 10.0442 2.50244 10.5763C2.47647 11.1084 2.65827 11.6315 3.015 12.0512C3.30632 12.3939 3.69865 12.6492 4.142 12.7888C4.31841 12.8443 4.45193 12.9955 4.47211 13.1793C4.51378 13.5589 4.60104 13.8457 4.80577 14.2449C5.0631 14.7466 5.42541 15.1968 5.87199 15.5698C6.31858 15.9428 6.8407 16.2313 7.40855 16.4187C7.97639 16.6062 8.57883 16.689 9.18149 16.6625C9.78415 16.6359 10.3752 16.5005 10.9209 16.2639C11.4667 16.0273 11.9564 15.6942 12.3621 15.2836C12.7678 14.8731 13.0816 14.393 13.2855 13.871C13.4894 13.3489 13.6262 12.7165 13.6262 12.4602V11.1869C13.6262 10.9884 13.7722 10.8217 13.966 10.7793C14.9105 10.5724 15.7628 10.0952 16.3973 9.41239C17.1071 8.64859 17.498 7.67745 17.5 6.67285V4.44694C17.5 4.15176 17.3725 3.86868 17.1454 3.65996C16.9196 3.45232 16.6137 3.3352 16.2944 3.33399C16.2927 3.33399 16.2918 3.33616 16.2931 3.33736ZM3.95624 10.72C3.95624 10.5439 4.01301 10.3717 4.11942 10.2253C4.22584 10.0789 4.3771 9.96475 4.55406 9.89736C4.73102 9.82997 4.92577 9.81235 5.11364 9.8467C5.3015 9.88106 5.47405 9.96585 5.60949 10.0904C5.74493 10.2149 5.83718 10.3735 5.87455 10.5463C5.91191 10.719 5.89272 10.898 5.81942 11.0607C5.74612 11.2234 5.62201 11.3624 5.46275 11.4603C5.30348 11.5581 5.11621 11.6103 4.92466 11.6103C4.79754 11.6109 4.67165 11.5878 4.55442 11.5426C4.43719 11.4974 4.33103 11.431 4.24234 11.3473C4.15194 11.2653 4.08014 11.1676 4.03102 11.0599C3.98191 10.9523 3.95649 10.8367 3.95624 10.72Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const nutritionIcon = () => {
  return (
    <svg
      width='19'
      height='18'
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.3914 8.20646C16.2495 8.20646 16.129 8.09299 16.129 7.94407V7.92988C16.129 7.13561 15.7035 6.40516 15.0227 6.00802C14.3348 5.61089 13.4909 5.61089 12.803 6.00802C12.1151 6.40516 11.6967 7.13561 11.6967 7.92988C11.6967 8.0008 11.6683 8.06463 11.6187 8.11427C11.569 8.16391 11.5052 8.19228 11.4343 8.19228C11.2924 8.19228 11.1719 8.07881 11.1719 7.92988C11.1719 6.95123 11.6896 6.04348 12.5335 5.55416C13.3774 5.06483 14.427 5.05774 15.278 5.54706C16.129 6.03639 16.6538 6.93704 16.6538 7.9157C16.6609 7.98662 16.6396 8.06463 16.5899 8.11427C16.5332 8.17809 16.4623 8.20646 16.3914 8.20646Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M10.4558 8.21362C10.3353 8.22072 10.2218 8.13562 10.1935 8.01506C10.1509 7.83776 10.0587 7.67465 9.93106 7.547C9.73959 7.35553 9.4772 7.24915 9.20772 7.24915C9.10843 7.24915 9.01623 7.19242 8.97368 7.10022C8.93113 7.00803 8.94531 6.90166 9.01623 6.82365C9.22189 6.58253 9.29989 6.25631 9.23607 5.94427C9.17224 5.63224 8.9666 5.36984 8.67584 5.22801C8.39217 5.08617 8.05886 5.08617 7.7681 5.22801C7.64045 5.28474 7.49151 5.2351 7.42769 5.10745C7.37804 5.00816 7.31423 4.92306 7.23622 4.84506C7.05892 4.66776 6.8178 4.56139 6.56249 4.5472C6.30719 4.53302 6.05899 4.61103 5.86042 4.76705C5.80369 4.81669 5.72567 4.83087 5.65475 4.81669C5.58384 4.8025 5.51292 4.75996 5.47746 4.69613C5.41364 4.60394 5.34273 4.51175 5.26472 4.43374C4.98814 4.15716 4.61936 4.00823 4.23641 4.00114C3.84636 4.00114 3.4776 4.15716 3.20102 4.42664C2.92445 4.70322 2.77552 5.07199 2.77552 5.45494C2.77552 5.50459 2.77552 5.55423 2.77552 5.59678C2.80388 5.93009 2.95281 6.24922 3.19393 6.49034C3.27903 6.57544 3.37121 6.64635 3.47049 6.71018C3.53432 6.74564 3.58398 6.80946 3.59816 6.88747C3.61234 6.95839 3.59106 7.0364 3.54851 7.10022C3.36413 7.32716 3.28613 7.62501 3.33577 7.90868C3.35704 8.05051 3.26483 8.19235 3.11591 8.21362C2.97407 8.2349 2.83224 8.14271 2.81097 7.99378C2.75423 7.64629 2.81806 7.2917 2.98826 6.98676C2.93153 6.94421 2.88188 6.89456 2.83224 6.84492C2.50602 6.5187 2.30745 6.0932 2.25781 5.63224V5.44076C2.25781 4.91597 2.46348 4.40537 2.83934 4.0366C3.2152 3.66074 3.71872 3.45508 4.24351 3.45508C4.7683 3.45508 5.27889 3.66783 5.64766 4.04369C5.6973 4.09333 5.73985 4.14297 5.7824 4.19971C6.07316 4.0366 6.41358 3.97987 6.74689 4.02242C7.0802 4.07206 7.38513 4.22098 7.62625 4.4621C7.68299 4.51884 7.73973 4.58266 7.78937 4.65358C8.17232 4.53302 8.58363 4.56848 8.9453 4.74577C9.30698 4.92306 9.58357 5.2351 9.71122 5.61096C9.84597 5.98682 9.82468 6.40523 9.66157 6.76691C10.1793 6.92293 10.5764 7.34844 10.7041 7.88032C10.7395 8.02215 10.6544 8.15689 10.5126 8.19944L10.4558 8.21362Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M6.72025 8.21312C6.64933 8.21312 6.5855 8.18475 6.53586 8.13511L4.46509 6.06433C4.3658 5.96504 4.3658 5.79484 4.46509 5.69556C4.56437 5.59627 4.73457 5.59627 4.83385 5.69556L6.90464 7.76634C6.95428 7.81598 6.98264 7.87981 6.98264 7.95073C6.98264 8.02164 6.95428 8.08547 6.90464 8.13511C6.855 8.18475 6.79117 8.21312 6.72025 8.21312Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M7.08974 8.21286C6.99046 8.21286 6.89828 8.15613 6.85573 8.07103C6.30966 6.98599 6.6075 6.31937 6.955 5.9506C7.05428 5.84423 7.21741 5.83714 7.32378 5.94351C7.43016 6.0428 7.43724 6.20591 7.33086 6.31228C6.99046 6.66687 6.98337 7.18456 7.31668 7.837C7.38051 7.96465 7.33087 8.12067 7.20321 8.1845C7.17485 8.20577 7.13229 8.21286 7.08974 8.21286Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M12.462 16.6531H6.56164C5.69645 16.6531 4.85962 16.3198 4.22846 15.7312C1.32795 12.9867 0.604605 9.71034 1.58326 8.12179C1.6329 8.04378 1.718 7.99414 1.8031 7.99414H17.2063C17.2985 7.99414 17.3836 8.04378 17.4262 8.12179C18.4048 9.70324 17.6886 12.9867 14.7809 15.7312C14.164 16.3269 13.3272 16.6531 12.462 16.6531ZM1.95912 8.51893C1.00883 10.3131 2.55481 13.4193 4.58305 15.3483C5.11493 15.8518 5.8241 16.1354 6.55455 16.1283H12.4549C13.1924 16.1283 13.8945 15.8518 14.4264 15.3483C16.4617 13.4264 18.0006 10.3131 17.0503 8.51893H1.95912Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M11.9248 5.24856C11.3361 5.24856 10.0242 5.14218 9.18027 4.29826C8.08105 3.19196 8.22997 1.32683 8.23706 1.24882C8.25124 1.12117 8.34345 1.02189 8.4711 1.0077C8.54911 1.0077 10.4284 0.851687 11.5205 1.94381C12.6197 3.04303 12.4708 4.91524 12.4637 4.99325C12.4496 5.1209 12.3503 5.22019 12.2226 5.23437C12.2084 5.24146 12.095 5.24856 11.9248 5.24856ZM8.74766 1.5254C8.74766 2.02182 8.82567 3.21323 9.54903 3.92949C10.2724 4.64576 11.4354 4.70959 11.946 4.70959H11.9602C11.9602 4.21316 11.8822 3.02176 11.1589 2.30549C10.4355 1.59632 9.25117 1.51831 8.74766 1.5254Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
    </svg>
  )
}

export const ProfileIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.0013 1.66602C5.4013 1.66602 1.66797 5.39935 1.66797 9.99935C1.66797 14.5993 5.4013 18.3327 10.0013 18.3327C14.6013 18.3327 18.3346 14.5993 18.3346 9.99935C18.3346 5.39935 14.6013 1.66602 10.0013 1.66602ZM15.3013 14.0243C14.1096 12.5743 11.218 12.0827 10.0013 12.0827C8.78464 12.0827 5.89297 12.5743 4.7013 14.0243C3.8513 12.9077 3.33464 11.516 3.33464 9.99935C3.33464 6.32435 6.3263 3.33268 10.0013 3.33268C13.6763 3.33268 16.668 6.32435 16.668 9.99935C16.668 11.516 16.1513 12.9077 15.3013 14.0243ZM7.08464 7.91602C7.08464 6.29935 8.38464 4.99935 10.0013 4.99935C11.618 4.99935 12.918 6.29935 12.918 7.91602C12.918 9.53268 11.618 10.8327 10.0013 10.8327C8.38464 10.8327 7.08464 9.53268 7.08464 7.91602Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const MentalIcon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.15407 6.16207L4.79219 5.67958L3.82722 4.40333L3.18909 4.88582L4.15407 6.16207ZM4.90335 2.16452L5.45265 2.74614L4.90335 2.16452ZM4.78559 8.10528C5.09801 8.4177 5.60454 8.4177 5.91696 8.10528C6.22938 7.79286 6.22938 7.28633 5.91696 6.97391L4.78559 8.10528ZM9.84662 4.29216V3.49216H8.24662V4.29216H9.84662ZM6.43338 9.32927C5.99936 9.41194 5.71453 9.83081 5.7972 10.2648C5.87987 10.6989 6.29874 10.9837 6.73276 10.901L6.43338 9.32927ZM2.91381 13.837L3.69834 13.6804L2.91381 13.837ZM2.78636 13.6058L3.33366 13.0223L2.78636 13.6058ZM8.78134 16.9223L8.5474 16.1572L8.78134 16.9223ZM8.81201 1.17447L8.55365 1.9316L8.81201 1.17447ZM8.24662 1.52181V16.5533H9.84662V1.52181H8.24662ZM8.5474 16.1572C7.73444 16.4058 6.63197 16.5236 5.6947 16.2146C4.82691 15.9285 4.01236 15.2536 3.69834 13.6804L2.12929 13.9936C2.55343 16.1185 3.76579 17.2634 5.19379 17.7342C6.55232 18.182 8.01453 17.9933 9.01527 17.6873L8.5474 16.1572ZM3.33366 13.0223C2.7079 12.4354 1.95577 11.4245 1.8213 10.2542C1.69606 9.16436 2.08433 7.72699 4.15407 6.16207L3.18909 4.88582C0.778042 6.70881 0.0275055 8.65935 0.231758 10.4369C0.426774 12.1341 1.47243 13.4702 2.23906 14.1893L3.33366 13.0223ZM9.07036 0.417333C8.03445 0.0638508 6.07507 -0.0424875 4.35405 1.58291L5.45265 2.74614C6.64615 1.61894 7.94271 1.72313 8.55365 1.9316L9.07036 0.417333ZM4.35405 1.58291C3.1513 2.71885 2.82961 4.00608 3.08444 5.22565C3.32537 6.37866 4.06017 7.37986 4.78559 8.10528L5.91696 6.97391C5.29861 6.35556 4.80162 5.62105 4.65062 4.89839C4.51352 4.24228 4.63975 3.51387 5.45265 2.74614L4.35405 1.58291ZM8.24662 4.29216C8.24662 6.48626 8.09272 7.69261 7.78811 8.38472C7.64886 8.7011 7.48768 8.88462 7.30551 9.01106C7.11203 9.14535 6.84264 9.25132 6.43338 9.32927L6.73276 10.901C7.26414 10.7998 7.77301 10.6342 8.21782 10.3255C8.67393 10.0089 9.01106 9.57793 9.25254 9.02925C9.70938 7.99127 9.84662 6.4653 9.84662 4.29216H8.24662ZM3.69834 13.6804C3.64924 13.4344 3.52479 13.2016 3.33366 13.0223L2.23906 14.1893C2.17878 14.1327 2.14327 14.0636 2.12929 13.9936L3.69834 13.6804ZM8.24662 16.5533C8.24662 16.3962 8.34772 16.2183 8.5474 16.1572L9.01527 17.6873C9.53714 17.5277 9.84662 17.0472 9.84662 16.5533H8.24662ZM9.84662 1.52181C9.84662 1.07674 9.587 0.593625 9.07036 0.417333L8.55365 1.9316C8.3296 1.85515 8.24662 1.65773 8.24662 1.52181H9.84662Z'
        fill='#E0BCBC'
      />
      <path
        d='M14.0491 6.16207L13.4109 5.67958L14.3759 4.40333L15.014 4.88582L14.0491 6.16207ZM13.2998 2.16452L12.7505 2.74614L13.2998 2.16452ZM13.4175 8.10528C13.1051 8.4177 12.5986 8.4177 12.2862 8.10528C11.9737 7.79286 11.9737 7.28633 12.2862 6.97391L13.4175 8.10528ZM8.35651 3.95622V3.15622H9.95651V3.95622H8.35651ZM11.1335 11.8005C11.5633 11.9028 11.8288 12.3342 11.7264 12.764C11.6241 13.1938 11.1927 13.4593 10.7629 13.357L11.1335 11.8005ZM15.2893 13.837L14.5048 13.6804L15.2893 13.837ZM15.4168 13.6058L15.9641 14.1893L15.4168 13.6058ZM9.42179 16.9223L9.18786 17.6873L9.42179 16.9223ZM9.95651 1.52181V16.5533H8.35651V1.52181H9.95651ZM9.65572 16.1572C10.4687 16.4058 11.5712 16.5236 12.5084 16.2146C13.3762 15.9285 14.1908 15.2536 14.5048 13.6804L16.0738 13.9936C15.6497 16.1185 14.4373 17.2634 13.0093 17.7342C11.6508 18.182 10.1886 17.9933 9.18786 17.6873L9.65572 16.1572ZM14.8695 13.0223C15.4952 12.4354 16.2474 11.4245 16.3818 10.2542C16.5071 9.16436 16.1188 7.72699 14.0491 6.16207L15.014 4.88582C17.4251 6.70881 18.1756 8.65935 17.9714 10.4369C17.7764 12.1341 16.7307 13.4702 15.9641 14.1893L14.8695 13.0223ZM9.13277 0.417333C10.1687 0.0638508 12.1281 -0.0424875 13.8491 1.58291L12.7505 2.74614C11.557 1.61894 10.2604 1.72313 9.64948 1.9316L9.13277 0.417333ZM13.8491 1.58291C15.0518 2.71885 15.3735 4.00608 15.1187 5.22565C14.8778 6.37866 14.143 7.37986 13.4175 8.10528L12.2862 6.97391C12.9045 6.35556 13.4015 5.62105 13.5525 4.89839C13.6896 4.24228 13.5634 3.51387 12.7505 2.74614L13.8491 1.58291ZM9.95651 3.95622C9.95651 6.06188 9.81749 7.95857 9.96673 9.49173C10.0399 10.2436 10.1769 10.8026 10.3814 11.1846C10.5684 11.5338 10.8007 11.7212 11.1335 11.8005L10.7629 13.357C9.9199 13.1562 9.3403 12.6298 8.97086 11.9397C8.61897 11.2824 8.45504 10.4766 8.37426 9.64674C8.21556 8.01646 8.35651 5.88186 8.35651 3.95622H9.95651ZM14.5048 13.6804C14.5539 13.4344 14.6783 13.2016 14.8695 13.0223L15.9641 14.1893C16.0243 14.1327 16.0599 14.0636 16.0738 13.9936L14.5048 13.6804ZM9.95651 16.5533C9.95651 16.3962 9.85541 16.2183 9.65572 16.1572L9.18786 17.6873C8.66599 17.5277 8.35651 17.0472 8.35651 16.5533H9.95651ZM8.35651 1.52181C8.35651 1.07674 8.61612 0.593625 9.13277 0.417333L9.64948 1.9316C9.87353 1.85515 9.95651 1.65773 9.95651 1.52181H8.35651Z'
        fill='#E0BCBC'
      />
    </svg>
  )
}

export const CalendarIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.332 3.78788H15.0654C14.8444 3.78788 14.6654 3.60879 14.6654 3.38788V2.9C14.6654 2.67909 14.4863 2.5 14.2654 2.5H13.732C13.5111 2.5 13.332 2.67909 13.332 2.9V3.38788C13.332 3.60879 13.1529 3.78788 12.932 3.78788H7.06536C6.84445 3.78788 6.66536 3.60879 6.66536 3.38788V2.9C6.66536 2.67909 6.48628 2.5 6.26536 2.5H5.73203C5.51112 2.5 5.33203 2.67909 5.33203 2.9V3.38788C5.33203 3.60879 5.15295 3.78788 4.93203 3.78788H4.66536C3.93203 3.78788 3.33203 4.36742 3.33203 5.07576V15.3788C3.33203 16.0871 3.93203 16.6667 4.66536 16.6667H15.332C16.0654 16.6667 16.6654 16.0871 16.6654 15.3788V5.07576C16.6654 4.36742 16.0654 3.78788 15.332 3.78788ZM15.332 14.9788C15.332 15.1997 15.1529 15.3788 14.932 15.3788H5.06536C4.84445 15.3788 4.66536 15.1997 4.66536 14.9788V8.69545C4.66536 8.47454 4.84445 8.29545 5.06536 8.29545H14.932C15.1529 8.29545 15.332 8.47454 15.332 8.69545V14.9788ZM15.332 6.60758C15.332 6.82849 15.1529 7.00758 14.932 7.00758H5.06536C4.84445 7.00758 4.66536 6.82849 4.66536 6.60758V5.47576C4.66536 5.25484 4.84445 5.07576 5.06536 5.07576H14.932C15.1529 5.07576 15.332 5.25484 15.332 5.47576V6.60758Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const MyGuideIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <g clipPath='url(#clip0_1291_72819)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.62433 0.00012207C1.21405 0.00012207 0.0625 1.15631 0.0625 2.56662V17.4383V17.451V17.4522V17.4555C0.0625 18.8563 1.20632 20.0001 2.60717 20.0001H14.7388C14.7411 19.9998 14.7435 19.9994 14.7457 19.999C14.7606 19.9991 14.7755 20.0001 14.7905 20.0001C17.6259 20.0001 19.9362 17.6898 19.9362 14.8545C19.9362 12.2188 17.9395 10.0376 15.381 9.74331V1.52464C15.381 0.690526 14.6907 0.00015962 13.8565 0.00015962H11.5164L2.62433 0.00012207ZM11.5243 1.17656H13.8565C14.0592 1.17656 14.2046 1.32187 14.2046 1.52467L14.2047 9.74217C11.644 10.0344 9.64502 12.2173 9.64502 14.8545C9.64502 14.8718 9.64599 14.8889 9.64619 14.9062H2.60735C2.10449 14.9062 1.63464 15.055 1.23912 15.3094V2.56662C1.23912 1.78797 1.84595 1.17768 2.6246 1.17768H11.5166L11.5165 1.17762C11.5192 1.17729 11.5219 1.1769 11.5245 1.17651L11.5243 1.17656ZM5.00817 3.21339C4.18843 3.21339 3.51012 3.89171 3.51012 4.71144V6.64377C3.51012 7.46351 4.18843 8.14182 5.00817 8.14182H10.426C11.2457 8.14182 11.9241 7.46351 11.9241 6.64377V4.71144C11.9241 3.89171 11.2457 3.21339 10.426 3.21339H5.00817ZM5.00817 4.38982H10.426C10.6144 4.38982 10.7522 4.52316 10.7522 4.71151V6.64384C10.7522 6.83219 10.6143 6.96552 10.426 6.96552H5.00817C4.81982 6.96552 4.68648 6.83219 4.68648 6.64384V4.71151C4.68648 4.52316 4.81982 4.38982 5.00817 4.38982ZM14.7905 10.8865C16.9902 10.8865 18.7632 12.655 18.7632 14.8545C18.7632 17.0542 16.9902 18.8225 14.7905 18.8225C12.5908 18.8225 10.8213 17.054 10.8213 14.8545C10.8213 12.6548 12.591 10.8865 14.7905 10.8865ZM14.7893 12.2697C14.6169 12.2699 14.4516 12.3386 14.3295 12.4604C14.2074 12.5822 14.1385 12.7474 14.138 12.9199C14.1374 13.0932 14.2057 13.2596 14.3279 13.3824C14.4501 13.5052 14.6161 13.5744 14.7893 13.5748C14.9632 13.5753 15.1302 13.5066 15.2531 13.3836C15.376 13.2607 15.4448 13.0938 15.4442 12.9199C15.4436 12.7468 15.3742 12.5811 15.2515 12.4592C15.1287 12.3372 14.9625 12.269 14.7893 12.2697L14.7893 12.2697ZM14.7905 13.8861C14.6345 13.8867 14.4851 13.9492 14.3753 14.06C14.2654 14.1707 14.204 14.3206 14.2046 14.4766V16.8524C14.2052 17.0076 14.2671 17.1563 14.3769 17.266C14.4866 17.3758 14.6353 17.4377 14.7905 17.4383C14.9465 17.4389 15.0964 17.3775 15.2071 17.2677C15.3178 17.1578 15.3804 17.0084 15.381 16.8524V14.4766C15.3816 14.3198 15.3196 14.1692 15.2087 14.0584C15.0979 13.9475 14.9473 13.8854 14.7905 13.8861ZM2.60717 16.0838H9.79433C10.063 17.1738 10.6796 18.1288 11.5198 18.8226H2.60717C1.8377 18.8226 1.23893 18.2249 1.23893 17.4555H1.23887C1.23893 17.4524 1.23893 17.4494 1.23887 17.4464V17.4384C1.24779 16.6772 1.84349 16.0839 2.6071 16.0839L2.60717 16.0838Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1291_72819'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const SyntomsIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='5'
      y='3'
      width='14'
      height='18'
      rx='1'
      stroke='currentColor'
      strokeWidth='1.5'
    />
    <path d='M12 6V10' stroke='currentColor' strokeLinecap='round' />
    <path d='M10 8L14 8' stroke='currentColor' strokeLinecap='round' />
    <path
      d='M8 12H16'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 15H16'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 18H12'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const RecIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='12' cy='12' r='9' fill='#EA3F3F' fillOpacity='0.14' />
      <circle cx='12' cy='12' r='5' fill='#EA3F3F' />
    </svg>
  )
}

export const ReadIcon = () => {
  return (
    <svg
      width='12'
      height='14'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.52526 2.55523C8.31332 2.55523 8.11007 2.63942 7.96021 2.78928C7.81035 2.93914 7.72616 3.14239 7.72616 3.35433V12.2243C7.72613 12.2956 7.70703 12.3656 7.67085 12.427C7.63466 12.4884 7.5827 12.539 7.52036 12.5736C7.45802 12.6081 7.38757 12.6254 7.31632 12.6236C7.24506 12.6217 7.17559 12.6009 7.11512 12.5631L4.52977 10.9458L1.94442 12.5615C1.88406 12.5992 1.81474 12.6201 1.74361 12.622C1.67249 12.6239 1.60216 12.6067 1.53987 12.5724C1.47758 12.538 1.4256 12.4876 1.38929 12.4264C1.35299 12.3652 1.33369 12.2955 1.33337 12.2243V3.35433C1.33337 2.71852 1.58595 2.10876 2.03553 1.65918C2.48511 1.2096 3.09487 0.957031 3.73067 0.957031H8.52526C9.16106 0.957031 9.77082 1.2096 10.2204 1.65918C10.67 2.10876 10.9226 2.71852 10.9226 3.35433V5.35207C10.9226 5.45804 10.8805 5.55966 10.8055 5.63459C10.7306 5.70952 10.629 5.75162 10.523 5.75162H7.72616'
        stroke='currentColor'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const AudioBookIcon = () => {
  return (
    <svg
      width='12'
      height='10'
      viewBox='0 0 12 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        y='3.59961'
        width='0.957072'
        height='2.8'
        rx='0.478536'
        fill='currentColor'
      />
      <rect
        x='5.52197'
        y='3.59961'
        width='0.957072'
        height='2.8'
        rx='0.478536'
        fill='currentColor'
      />
      <rect
        x='11.043'
        y='3.46484'
        width='0.957072'
        height='3.06667'
        rx='0.478536'
        fill='currentColor'
      />
      <rect
        x='1.84106'
        y='1.93164'
        width='0.957072'
        height='6.2'
        rx='0.478536'
        fill='currentColor'
      />
      <rect
        x='7.36206'
        y='1.26562'
        width='0.957072'
        height='7.46667'
        rx='0.478536'
        fill='currentColor'
      />
      <rect
        x='3.68103'
        y='0.199219'
        width='0.957072'
        height='9.6'
        rx='0.478536'
        fill='currentColor'
      />
      <rect
        x='9.203'
        y='0.199219'
        width='0.957072'
        height='9.6'
        rx='0.478536'
        fill='currentColor'
      />
    </svg>
  )
}

export const PlayIcon = () => {
  return (
    <svg
      width='11'
      height='13'
      viewBox='0 0 11 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.14198 11.5152C2.47635 11.9407 1.60339 11.4626 1.60339 10.6726V2.65793C1.60339 1.86796 2.47628 1.3899 3.14192 1.81532L9.41156 5.82232C10.0268 6.21555 10.0269 7.11422 9.41163 7.5075L3.14198 11.5152Z'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const ClockIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.33325 7.00065C2.33325 8.23833 2.82492 9.42531 3.70009 10.3005C4.57526 11.1757 5.76224 11.6673 6.99992 11.6673C8.2376 11.6673 9.42458 11.1757 10.2998 10.3005C11.1749 9.42531 11.6666 8.23833 11.6666 7.00065C11.6666 5.76297 11.1749 4.57599 10.2998 3.70082C9.42458 2.82565 8.2376 2.33398 6.99992 2.33398C5.76224 2.33398 4.57526 2.82565 3.70009 3.70082C2.82492 4.57599 2.33325 5.76297 2.33325 7.00065V7.00065Z'
        stroke='currentColor'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 7.00065V5.33398'
        stroke='currentColor'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7 7L9.08311 9.08356'
        stroke='currentColor'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const FacebookIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.96107 13.2992V7.55177H9.98736L10.2907 5.31187H7.96101V3.88179C7.96101 3.23329 8.15014 2.79137 9.12695 2.79137L10.3727 2.79081V0.787469C10.1573 0.760221 9.4177 0.699219 8.55742 0.699219C6.7612 0.699219 5.53148 1.74304 5.53148 3.66003V5.31187H3.5V7.55177H5.53148V13.2992H7.96107V13.2992Z'
        fill='white'
      />
    </svg>
  )
}

export const TwitterIcon = () => {
  return (
    <svg
      width='15'
      height='14'
      viewBox='0 0 15 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.61889 2.10188V2.09961H10.2097L10.4256 2.14272C10.5695 2.17071 10.7001 2.2074 10.8175 2.25278C10.9349 2.29816 11.0486 2.35111 11.1584 2.41162C11.2682 2.47213 11.3678 2.53378 11.4572 2.59656C11.5458 2.65859 11.6254 2.72439 11.6958 2.79398C11.7655 2.86432 11.8742 2.88248 12.0219 2.84844C12.1696 2.8144 12.3286 2.76712 12.499 2.70661C12.6695 2.64611 12.838 2.57803 13.0046 2.50239C13.1713 2.42675 13.2728 2.37872 13.3091 2.3583C13.3447 2.33712 13.3637 2.32578 13.3659 2.32426L13.3682 2.32085L13.3796 2.31518L13.3909 2.30951L13.4023 2.30384L13.4137 2.29816L13.4159 2.29476L13.4193 2.29249L13.4228 2.29022L13.425 2.28682L13.4364 2.28341L13.4477 2.28114L13.4455 2.29816L13.4421 2.31518L13.4364 2.3322L13.4307 2.34922L13.425 2.36056L13.4193 2.37191L13.4137 2.38893C13.4099 2.40028 13.4061 2.4154 13.4023 2.43431C13.3985 2.45323 13.3625 2.52886 13.2944 2.66123C13.2262 2.7936 13.141 2.92786 13.0387 3.06401C12.9365 3.20016 12.8448 3.30302 12.7638 3.37262C12.682 3.44296 12.6278 3.49212 12.6013 3.52011C12.5748 3.54885 12.5426 3.57532 12.5047 3.59954L12.4479 3.63698L12.4366 3.64265L12.4252 3.64832L12.4229 3.65173L12.4195 3.654L12.4161 3.65627L12.4138 3.65967L12.4025 3.66534L12.3911 3.67101L12.3889 3.67442L12.3854 3.67669L12.382 3.67896L12.3798 3.68236L12.3775 3.68576L12.3741 3.68803L12.3707 3.6903L12.3684 3.69371H12.4252L12.7433 3.62563C12.9554 3.58025 13.158 3.52541 13.3512 3.46112L13.6579 3.359L13.692 3.34766L13.7091 3.34198L13.7204 3.33631L13.7318 3.33064L13.7431 3.32497L13.7545 3.31929L13.7772 3.31589L13.8 3.31362V3.33631L13.7943 3.33858L13.7886 3.34198L13.7863 3.34539L13.7829 3.34766L13.7795 3.34993L13.7772 3.35333L13.775 3.35673L13.7715 3.359L13.7681 3.36127L13.7659 3.36468L13.7636 3.36808L13.7602 3.37035L13.7545 3.38169L13.7488 3.39304L13.7454 3.39531C13.7439 3.39758 13.6958 3.46186 13.6011 3.58819C13.5064 3.71526 13.4553 3.77955 13.4477 3.78107C13.4402 3.78334 13.4296 3.79468 13.4159 3.81511C13.4031 3.83628 13.3228 3.92062 13.1751 4.06812C13.0274 4.21562 12.8827 4.34684 12.7411 4.46182C12.5987 4.57755 12.5267 4.71975 12.5252 4.88843C12.5229 5.05635 12.5142 5.24621 12.499 5.45799C12.4839 5.66979 12.4555 5.89859 12.4138 6.14442C12.3722 6.39025 12.3078 6.66822 12.2207 6.97834C12.1336 7.28846 12.0275 7.59102 11.9026 7.88601C11.7776 8.181 11.6469 8.44574 11.5106 8.68022C11.3743 8.91471 11.2493 9.11326 11.1357 9.27588C11.022 9.4385 10.9065 9.59167 10.7891 9.73539C10.6717 9.87911 10.5233 10.041 10.3438 10.221C10.1635 10.4003 10.065 10.4986 10.0484 10.516C10.0309 10.5326 9.95672 10.5947 9.82567 10.7021C9.6954 10.8102 9.55526 10.9184 9.40529 11.0266C9.25608 11.134 9.11898 11.2236 8.994 11.2955C8.86902 11.3673 8.7183 11.4494 8.54181 11.5417C8.36609 11.6347 8.17597 11.7209 7.97146 11.8003C7.76695 11.8798 7.55108 11.9535 7.32385 12.0216C7.09661 12.0897 6.87696 12.1426 6.66487 12.1804C6.4528 12.2182 6.21231 12.2504 5.94341 12.2769L5.54008 12.3166V12.3223H4.80157V12.3166L4.705 12.3109C4.64063 12.3071 4.5876 12.3033 4.54594 12.2996C4.50429 12.2958 4.34711 12.275 4.07443 12.2372C3.80175 12.1993 3.58778 12.1615 3.4325 12.1237C3.27724 12.0859 3.04621 12.014 2.73945 11.9081C2.43268 11.8022 2.17023 11.6952 1.95209 11.587C1.73471 11.4796 1.59837 11.4116 1.54307 11.3828C1.48854 11.3548 1.42718 11.32 1.35901 11.2784L1.25676 11.216L1.2545 11.2126L1.25108 11.2104L1.24767 11.2081L1.2454 11.2047L1.23404 11.199L1.22267 11.1933L1.22041 11.1899L1.21699 11.1877L1.21359 11.1854L1.21131 11.182L1.20905 11.1786L1.20563 11.1763H1.19995V11.1536L1.21131 11.1559L1.22267 11.1593L1.2738 11.165C1.30789 11.1688 1.40068 11.1744 1.55216 11.182C1.70366 11.1896 1.8646 11.1896 2.03503 11.182C2.20545 11.1744 2.37967 11.1574 2.55766 11.1309C2.73566 11.1045 2.94585 11.0591 3.18823 10.9948C3.43062 10.9305 3.6533 10.8541 3.8563 10.7656C4.05854 10.6764 4.20244 10.6098 4.28804 10.5659C4.37287 10.5228 4.50239 10.4426 4.6766 10.3254L4.93791 10.1495L4.94019 10.1461L4.94359 10.1438L4.94701 10.1416L4.94927 10.1382L4.95155 10.1348L4.95496 10.1325L4.95838 10.1302L4.96064 10.1268L4.972 10.1234L4.98336 10.1212L4.98563 10.1098L4.98904 10.0985L4.99246 10.0962L4.99472 10.0928L4.90383 10.0871C4.84324 10.0833 4.78453 10.0795 4.72772 10.0758C4.67092 10.072 4.58192 10.055 4.46073 10.0247C4.33954 9.99445 4.20889 9.94907 4.06875 9.88856C3.92863 9.82805 3.79229 9.75619 3.65973 9.67299C3.52719 9.58979 3.43137 9.52057 3.37229 9.46536C3.31397 9.41089 3.23822 9.33375 3.14505 9.2339C3.05265 9.13331 2.97236 9.03005 2.90419 8.92416C2.83602 8.81827 2.77088 8.6961 2.70878 8.55769L2.61447 8.35119L2.60879 8.33417L2.60311 8.31716L2.5997 8.30581L2.59743 8.29446L2.61447 8.29673L2.63151 8.30014L2.75649 8.31716C2.83981 8.3285 2.97047 8.33228 3.14846 8.3285C3.32647 8.32472 3.44955 8.31716 3.51771 8.30581C3.58588 8.29446 3.62755 8.2869 3.64269 8.28312L3.66542 8.27744L3.69382 8.27177L3.72222 8.2661L3.7245 8.2627L3.7279 8.26043L3.73132 8.25816L3.73359 8.25475L3.71086 8.24908L3.68814 8.24341L3.66542 8.23773L3.64269 8.23206L3.61997 8.22639C3.60482 8.22261 3.57832 8.21504 3.54044 8.2037C3.50257 8.19235 3.40032 8.15074 3.23368 8.07889C3.06705 8.00704 2.93449 7.93707 2.83602 7.86899C2.7373 7.80072 2.64318 7.72606 2.55425 7.64548C2.46563 7.56379 2.36831 7.45865 2.26226 7.33006C2.15622 7.20148 2.06155 7.05209 1.97822 6.8819C1.89491 6.71171 1.83242 6.54909 1.79075 6.39403C1.74926 6.23988 1.72188 6.08228 1.70896 5.92317L1.6885 5.68491L1.69986 5.68718L1.71122 5.69058L1.72258 5.69626L1.73395 5.70193L1.74531 5.7076L1.75667 5.71327L1.93277 5.7927C2.05018 5.84565 2.19599 5.89103 2.37019 5.92885C2.54441 5.96666 2.64855 5.98747 2.68264 5.99125L2.73377 5.99692H2.83602L2.83376 5.99352L2.83034 5.99125L2.82693 5.98898L2.82466 5.98558L2.8224 5.98217L2.81898 5.9799L2.81557 5.97763L2.8133 5.97423L2.80193 5.96856L2.79057 5.96288L2.78831 5.95948L2.78489 5.95721L2.78148 5.95494L2.77921 5.95154L2.76785 5.94586L2.75649 5.94019L2.75423 5.93679C2.75196 5.93527 2.71938 5.91107 2.65651 5.86417C2.59439 5.81652 2.52926 5.75488 2.46109 5.67924C2.39292 5.60359 2.32475 5.52417 2.25658 5.44097C2.18828 5.35758 2.12745 5.26836 2.07479 5.17434C2.02178 5.0798 1.96572 4.95952 1.90664 4.81355C1.84832 4.66832 1.80401 4.52196 1.77371 4.37446C1.74342 4.22696 1.72638 4.08136 1.72258 3.93764C1.7188 3.79392 1.72258 3.67101 1.73395 3.5689C1.74531 3.46679 1.76803 3.35144 1.80212 3.22285C1.8362 3.09427 1.88544 2.95812 1.94982 2.8144L2.04639 2.59883L2.05207 2.58181L2.05775 2.56479L2.06117 2.56252L2.06343 2.55912L2.0657 2.55571L2.06911 2.55344L2.07253 2.55571L2.07479 2.55912L2.07707 2.56252L2.08047 2.56479L2.08389 2.56706L2.08615 2.57046L2.08843 2.57387L2.09184 2.57614L2.09752 2.58748L2.1032 2.59883L2.10662 2.6011L2.10888 2.6045L2.26226 2.77469C2.36451 2.88815 2.48571 3.01485 2.62583 3.15478C2.76596 3.29471 2.8436 3.36732 2.85874 3.37262C2.8739 3.37867 2.89283 3.39606 2.91555 3.42481C2.93827 3.4528 3.01402 3.51974 3.14278 3.62563C3.27155 3.73152 3.44008 3.85444 3.64837 3.99437C3.85668 4.1343 4.08769 4.27235 4.34143 4.4085C4.59518 4.54465 4.86786 4.66756 5.15946 4.77724C5.45108 4.88692 5.65559 4.95877 5.77299 4.99281C5.8904 5.02685 6.09111 5.07034 6.37515 5.12329C6.65919 5.17624 6.87318 5.21028 7.01708 5.2254C7.161 5.24053 7.25947 5.24923 7.31248 5.2515L7.39202 5.25377L7.38976 5.23675L7.38634 5.21973L7.36361 5.0779C7.34847 4.98336 7.34089 4.85099 7.34089 4.6808C7.34089 4.51061 7.35415 4.35366 7.38065 4.20994C7.40717 4.06623 7.44694 3.92062 7.49995 3.77313C7.55298 3.62563 7.60486 3.50725 7.6556 3.418C7.70712 3.3295 7.77453 3.22853 7.85784 3.11507C7.94117 3.00161 8.0491 2.88437 8.18165 2.76334C8.3142 2.64232 8.46569 2.53453 8.63611 2.43999C8.80653 2.34544 8.96371 2.27358 9.10762 2.22441C9.25153 2.17525 9.37273 2.1431 9.47119 2.12797C9.56966 2.11285 9.61889 2.10415 9.61889 2.10188Z'
        fill='white'
      />
    </svg>
  )
}

export const WhatsAppIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Isolation_Mode' clipPath='url(#clip0_1_11920)'>
        <path
          id='Vector'
          d='M11.8972 2.04652C11.228 1.39523 10.4692 0.892721 9.6208 0.536194C8.7724 0.179667 7.8876 0 6.9692 0C5.712 0 4.5528 0.314417 3.486 0.943252C2.4192 1.57209 1.5708 2.4227 0.9408 3.49228C0.3136 4.56186 0 5.72689 0 6.98456C0 8.24223 0.2968 9.3455 0.8904 10.3898C0.9212 10.446 0.9324 10.5133 0.9128 10.5751L0.0504 13.6968C0 13.8765 0.1624 14.0421 0.3416 13.9944L3.5504 13.1494C3.6092 13.1354 3.6708 13.141 3.724 13.1718C4.7264 13.708 5.8072 13.9775 6.9692 13.9775C8.2236 13.9775 9.3912 13.6631 10.4692 13.0343C11.5472 12.4055 12.404 11.5548 13.0424 10.4853C13.6808 9.41568 14 8.25065 14 6.99298C14 6.06938 13.818 5.18227 13.4512 4.33447C13.0844 3.48386 12.5664 2.72589 11.8972 2.05214V2.04652ZM12.0372 9.89854C11.5024 10.7913 10.7856 11.4987 9.8868 12.0237C8.988 12.5486 8.0136 12.8097 6.9664 12.8097C5.9192 12.8097 4.914 12.5374 4.0152 11.99L3.8808 11.9114C3.8276 11.8805 3.7632 11.8721 3.7016 11.8861L1.7584 12.3858C1.6856 12.4055 1.6212 12.3381 1.6436 12.2679L2.1672 10.3842C2.184 10.3224 2.1756 10.2551 2.1448 10.1989L2.0692 10.067C1.4616 9.12372 1.1592 8.09344 1.1592 6.98175C1.1592 5.93182 1.4196 4.9633 1.9432 4.07058C2.4668 3.17786 3.1724 2.47042 4.0628 1.94546C4.9532 1.42049 5.9192 1.15941 6.9664 1.15941C7.7392 1.15941 8.4784 1.30539 9.1784 1.60016C9.8784 1.89493 10.5084 2.31883 11.0628 2.87467C11.6172 3.43052 12.0512 4.06497 12.3648 4.77802C12.6784 5.49108 12.8352 6.22659 12.8352 6.98175C12.8352 8.03168 12.5692 9.0002 12.0344 9.89292L12.0372 9.89854Z'
          fill='#5D3881'
        />
        <path
          id='Vector_2'
          d='M10.382 8.97812L10.2868 8.89952C9.64558 8.48404 9.23678 8.23138 9.06318 8.14155C8.97358 8.10786 8.89798 8.08821 8.82798 8.07979C8.76078 8.07137 8.69918 8.11067 8.64318 8.1977C8.51158 8.34368 8.27918 8.57107 7.94878 8.87987C7.84518 8.98374 7.70798 8.98093 7.53718 8.86864C6.93798 8.48123 6.49278 8.14436 6.20158 7.85801C5.80958 7.4678 5.48478 6.96248 5.23278 6.33646C5.17118 6.26066 5.15718 6.19609 5.18518 6.14275C5.21318 6.08941 5.27758 6.02204 5.37838 5.94063C5.57998 5.7778 5.75078 5.58971 5.88798 5.37636C5.94398 5.29214 5.94398 5.17423 5.89078 5.03106L5.46798 3.56846C5.43718 3.42809 5.39518 3.33545 5.34198 3.29615C5.28878 3.25685 5.21598 3.23158 5.12638 3.22035L4.71758 3.17544C4.53558 3.15579 4.35638 3.21755 4.17998 3.35791L4.14078 3.38879C3.68438 3.7762 3.42398 4.26467 3.35958 4.8542C3.29518 5.44654 3.47158 6.12029 3.89438 6.88107L3.95598 6.95687C4.75678 8.42789 5.70878 9.47502 6.80918 10.1039C7.34678 10.4183 7.78358 10.626 8.11678 10.7327C8.40518 10.8113 8.71318 10.845 9.03518 10.8337C9.24238 10.8337 9.49718 10.7523 9.80238 10.5923C10.1076 10.4323 10.3092 10.2583 10.41 10.073C10.5108 9.88769 10.5752 9.70522 10.6088 9.52555C10.6396 9.34588 10.648 9.23078 10.6284 9.18306C10.6116 9.13533 10.5248 9.06796 10.3764 8.98093L10.382 8.97812Z'
          fill='#5D3881'
        />
      </g>
      <defs>
        <clipPath id='clip0_1_11920'>
          <rect width='14' height='14' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const WhatsAppWhiteIcon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      className={classes.modeColorWhite}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0 18L1.26525 13.3778C0.484499 12.0247 0.0742498 10.491 0.0749998 8.91825C0.0772498 4.00125 4.07849 0 8.99473 0C11.3805 0.00075 13.62 0.93 15.3045 2.616C16.9882 4.302 17.9152 6.543 17.9145 8.9265C17.9122 13.8443 13.911 17.8455 8.99473 17.8455C7.50223 17.8448 6.03149 17.4705 4.72874 16.7595L0 18ZM4.94774 15.1448C6.20474 15.891 7.40473 16.338 8.99173 16.3387C13.0777 16.3387 16.4062 13.0133 16.4085 8.925C16.41 4.8285 13.0972 1.5075 8.99773 1.506C4.90874 1.506 1.5825 4.8315 1.581 8.919C1.58025 10.5878 2.06925 11.8372 2.89049 13.1445L2.14125 15.8805L4.94774 15.1448ZM13.488 11.0468C13.4325 10.9537 13.284 10.8982 13.0605 10.7865C12.8377 10.6748 11.742 10.1355 11.5372 10.0612C11.3332 9.987 11.1847 9.9495 11.0355 10.173C10.887 10.3958 10.4595 10.8982 10.3297 11.0468C10.2 11.1953 10.0695 11.214 9.84673 11.1023C9.62398 10.9905 8.90548 10.7557 8.05423 9.996C7.39198 9.405 6.94423 8.67525 6.81449 8.45175C6.68474 8.229 6.80099 8.10825 6.91198 7.99725C7.01248 7.8975 7.13473 7.737 7.24648 7.6065C7.35973 7.4775 7.39648 7.3845 7.47148 7.23525C7.54573 7.08675 7.50898 6.95625 7.45273 6.8445C7.39648 6.7335 6.95098 5.63625 6.76574 5.19C6.58424 4.75575 6.40049 4.81425 6.26399 4.8075L5.83649 4.8C5.68799 4.8 5.44649 4.8555 5.24249 5.079C5.03849 5.3025 4.46249 5.841 4.46249 6.93825C4.46249 8.0355 5.26124 9.09525 5.37224 9.24375C5.48399 9.39225 6.94348 11.6438 9.17923 12.609C9.71098 12.8385 10.1265 12.9757 10.4497 13.0785C10.9837 13.248 11.4697 13.224 11.8537 13.167C12.282 13.1032 13.1722 12.6277 13.3582 12.1073C13.5442 11.586 13.5442 11.1398 13.488 11.0468Z' />
    </svg>
  )
}

export const VaccinesIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='4' fill='#ECF6F5' />
      <path
        d='M10.4121 6.43945L8.42846 14.6745L10.5123 18.0807L13.9185 15.9969L15.9021 7.76189L10.4121 6.43945Z'
        stroke='#6EA09B'
        strokeLinejoin='round'
      />
      <path
        d='M13.1583 7.10115L13.7461 4.66113'
        stroke='#6EA09B'
        strokeLinejoin='round'
      />
      <path
        d='M15.7287 5.13868L11.7637 4.18359'
        stroke='#6EA09B'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.5133 20.1C9.44863 20.3684 9.61384 20.6385 9.8823 20.7031C10.1508 20.7678 10.4208 20.6026 10.4855 20.3341L9.5133 20.1ZM10.0276 17.9649L9.5133 20.1L10.4855 20.3341L10.9998 18.1991L10.0276 17.9649Z'
        fill='#6EA09B'
      />
      <path
        d='M11.578 12.9836C11.3096 12.919 11.0395 13.0842 10.9748 13.3526C10.9102 13.6211 11.0754 13.8912 11.3438 13.9558L11.578 12.9836ZM14.4755 13.6816L11.578 12.9836L11.3438 13.9558L14.2414 14.6538L14.4755 13.6816Z'
        fill='#6EA09B'
      />
      <path
        d='M12.3144 9.93285C12.0459 9.86818 11.7758 10.0334 11.7112 10.3019C11.6465 10.5703 11.8117 10.8404 12.0802 10.905L12.3144 9.93285ZM15.2119 10.6308L12.3144 9.93285L12.0802 10.905L14.9777 11.603L15.2119 10.6308Z'
        fill='#6EA09B'
      />
    </svg>
  )
}

export const VaccinesOutlinedIcon = () => {
  return (
    <svg
      width='13'
      height='24'
      viewBox='0 0 13 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.93359 4.47656L2.30074 15.4067L5.06652 19.9278L9.58753 17.162L12.2204 6.2318L4.93359 4.47656Z'
        stroke='#707070'
        strokeWidth='1.4'
        strokeLinejoin='round'
      />
      <path
        d='M8.57732 5.35381L9.35742 2.11523'
        stroke='#707070'
        strokeWidth='1.4'
        strokeLinejoin='round'
      />
      <path
        d='M11.9892 2.75009L6.72656 1.48242'
        stroke='#707070'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.70426 22.5976C3.61372 22.9734 3.84502 23.3515 4.22086 23.442C4.59671 23.5326 4.97479 23.3013 5.06533 22.9254L3.70426 22.5976ZM4.38685 19.7638L3.70426 22.5976L5.06533 22.9254L5.74792 20.0917L4.38685 19.7638Z'
        fill='#707070'
      />
      <path
        d='M6.49108 13.1261C6.11523 13.0356 5.73715 13.2669 5.64661 13.6427C5.55608 14.0186 5.78737 14.3966 6.16322 14.4872L6.49108 13.1261ZM10.3369 14.0525L6.49108 13.1261L6.16322 14.4872L10.009 15.4136L10.3369 14.0525Z'
        fill='#707070'
      />
      <path
        d='M7.46568 9.07728C7.08984 8.98674 6.71176 9.21804 6.62122 9.59389C6.53069 9.96973 6.76198 10.3478 7.13783 10.4383L7.46568 9.07728ZM11.3115 10.0037L7.46568 9.07728L7.13783 10.4383L10.9836 11.3647L11.3115 10.0037Z'
        fill='#707070'
      />
    </svg>
  )
}

export const LabsIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='4' fill='#FCF0E6' />
      <path
        d='M11.1641 4.33398L16.4783 5.85844L13.4031 16.5785C12.9824 18.0452 11.4504 18.8942 9.98375 18.4734C8.51714 18.0527 7.66815 16.5207 8.08886 15.0541L11.1641 4.33398Z'
        stroke='#BAA28E'
        strokeWidth='1.3'
        strokeMiterlimit='10'
      />
      <path
        d='M17.643 6.1925L10 4'
        stroke='#BAA28E'
        strokeWidth='1.3'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M9.3934 10.9657C9.89565 11.872 11.0373 12.1995 11.9436 11.6973C12.8499 11.195 13.9916 11.5225 14.4938 12.4288'
        stroke='#BAA28E'
        strokeWidth='1.3'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
    </svg>
  )
}

export const PregnancyIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='4' fill='#EAE7EE' />
      <path
        d='M10.9856 16.5286C11.029 16.9054 10.957 17.2963 10.7543 17.6475C10.2446 18.5302 9.10136 18.8247 8.20058 18.3047C7.29979 17.7846 6.98301 16.6476 7.49287 15.7645C7.69004 15.4229 7.98215 15.1696 8.31795 15.0172'
        stroke='#76698B'
        strokeWidth='0.9'
        strokeMiterlimit='10'
      />
      <path
        d='M8.67188 13.8965L11.7467 15.6717L11.5489 16.0143C11.1888 16.6381 10.3795 16.8463 9.74323 16.479L8.97452 16.0352C8.33824 15.6678 8.11396 14.8628 8.4741 14.239L8.67188 13.8965Z'
        stroke='#76698B'
        strokeWidth='0.9'
        strokeMiterlimit='10'
      />
      <mask
        id='path-4-outside-1_4044_38402'
        maskUnits='userSpaceOnUse'
        x='8.15155'
        y='2.50214'
        width='11.4282'
        height='11.7942'
        fill='black'
      >
        <rect
          fill='white'
          x='8.15155'
          y='2.50214'
          width='11.4282'
          height='11.7942'
        />
        <path d='M15.3418 5.89515C16.4984 6.56289 16.9066 8.02811 16.2519 9.16196C15.9683 9.65317 15.5148 10.0248 14.974 10.2086C14.2859 10.4425 13.7134 10.9072 13.3616 11.5166L13.2056 11.7869L11.3075 10.691L11.4511 10.4424C11.8146 9.81274 11.9361 9.08268 11.7933 8.38592C11.6738 7.80216 11.7771 7.20187 12.0844 6.69553C12.4005 6.17466 12.9068 5.80198 13.5099 5.64592C14.1129 5.48985 14.7455 5.56825 15.2907 5.86659C15.3081 5.87613 15.325 5.88547 15.3421 5.89536M15.6388 5.38153C15.6178 5.36943 15.5969 5.35732 15.5752 5.3457C14.1638 4.57379 12.3852 5.03356 11.567 6.38217C11.1672 7.04064 11.0595 7.79283 11.2033 8.49517C11.3191 9.06034 11.2133 9.64463 10.9274 10.14L10.4871 10.9025L13.4334 12.6035L13.8861 11.8194C14.1717 11.3248 14.6332 10.9586 15.1788 10.773C15.832 10.551 16.4076 10.1036 16.7764 9.46476C17.5954 8.04537 17.0861 6.21711 15.6385 5.38133L15.6388 5.38153Z' />
      </mask>
      <path
        d='M15.3418 5.89515C16.4984 6.56289 16.9066 8.02811 16.2519 9.16196C15.9683 9.65317 15.5148 10.0248 14.974 10.2086C14.2859 10.4425 13.7134 10.9072 13.3616 11.5166L13.2056 11.7869L11.3075 10.691L11.4511 10.4424C11.8146 9.81274 11.9361 9.08268 11.7933 8.38592C11.6738 7.80216 11.7771 7.20187 12.0844 6.69553C12.4005 6.17466 12.9068 5.80198 13.5099 5.64592C14.1129 5.48985 14.7455 5.56825 15.2907 5.86659C15.3081 5.87613 15.325 5.88547 15.3421 5.89536M15.6388 5.38153C15.6178 5.36943 15.5969 5.35732 15.5752 5.3457C14.1638 4.57379 12.3852 5.03356 11.567 6.38217C11.1672 7.04064 11.0595 7.79283 11.2033 8.49517C11.3191 9.06034 11.2133 9.64463 10.9274 10.14L10.4871 10.9025L13.4334 12.6035L13.8861 11.8194C14.1717 11.3248 14.6332 10.9586 15.1788 10.773C15.832 10.551 16.4076 10.1036 16.7764 9.46476C17.5954 8.04537 17.0861 6.21711 15.6385 5.38133L15.6388 5.38153Z'
        fill='#76698B'
      />
      <path
        d='M14.974 10.2086L14.9096 10.0192L14.9096 10.0192L14.974 10.2086ZM13.2056 11.7869L13.1056 11.9601L13.2788 12.0601L13.3788 11.8869L13.2056 11.7869ZM11.3075 10.691L11.1343 10.591L11.0343 10.7643L11.2075 10.8643L11.3075 10.691ZM11.7933 8.38592L11.5974 8.42604L11.5974 8.42608L11.7933 8.38592ZM12.0844 6.69553L11.9134 6.59177L11.9134 6.59178L12.0844 6.69553ZM15.2907 5.86659L15.3873 5.69142L15.3867 5.69114L15.2907 5.86659ZM15.5752 5.3457L15.4792 5.52118L15.4808 5.52203L15.5752 5.3457ZM11.567 6.38217L11.7379 6.48595L11.7379 6.48591L11.567 6.38217ZM11.2033 8.49517L11.0074 8.53528L11.0074 8.53532L11.2033 8.49517ZM10.4871 10.9025L10.3139 10.8025L10.2139 10.9757L10.3871 11.0757L10.4871 10.9025ZM13.4334 12.6035L13.3334 12.7767L13.5066 12.8767L13.6066 12.7035L13.4334 12.6035ZM15.1788 10.773L15.1144 10.5837L15.1143 10.5837L15.1788 10.773ZM16.7764 9.46476L16.9496 9.56476L16.9496 9.56472L16.7764 9.46476ZM15.2418 6.06836C16.306 6.68275 16.6763 8.02699 16.0787 9.06196L16.4252 9.26196C17.1369 8.02923 16.6908 6.44304 15.4418 5.72195L15.2418 6.06836ZM16.0787 9.06196C15.8195 9.5109 15.4048 9.85094 14.9096 10.0192L15.0384 10.398C15.6248 10.1987 16.1171 9.79545 16.4252 9.26196L16.0787 9.06196ZM14.9096 10.0192C14.1772 10.2683 13.5653 10.7638 13.1884 11.4166L13.5348 11.6166C13.8616 11.0506 14.3946 10.6168 15.0384 10.398L14.9096 10.0192ZM13.1884 11.4166L13.0324 11.6869L13.3788 11.8869L13.5348 11.6166L13.1884 11.4166ZM13.3056 11.6137L11.4075 10.5178L11.2075 10.8643L13.1056 11.9601L13.3056 11.6137ZM11.4807 10.791L11.6243 10.5424L11.2779 10.3424L11.1343 10.591L11.4807 10.791ZM11.6243 10.5424C12.0117 9.87141 12.1421 9.0916 11.9892 8.34576L11.5974 8.42608C11.7301 9.07375 11.6176 9.75408 11.2779 10.3424L11.6243 10.5424ZM11.9892 8.3458C11.8797 7.8111 11.9745 7.26224 12.2554 6.79928L11.9134 6.59178C11.5798 7.1415 11.4678 7.79323 11.5974 8.42604L11.9892 8.3458ZM12.2554 6.79929C12.5437 6.32412 13.0061 5.98288 13.56 5.83954L13.4598 5.4523C12.8076 5.62108 12.2572 6.0252 11.9134 6.59177L12.2554 6.79929ZM13.56 5.83954C14.1139 5.69618 14.6942 5.76818 15.1947 6.04204L15.3867 5.69114C14.7968 5.36832 14.1119 5.28352 13.4598 5.4523L13.56 5.83954ZM15.1942 6.04176C15.2119 6.05149 15.2271 6.05985 15.2421 6.06856L15.4421 5.72215C15.423 5.71109 15.4042 5.70077 15.3873 5.69142L15.1942 6.04176ZM15.7388 5.20832C15.7183 5.19647 15.6946 5.18276 15.6695 5.16937L15.4808 5.52203C15.4992 5.53189 15.5174 5.54238 15.5388 5.55473L15.7388 5.20832ZM15.6711 5.17023C14.169 4.34867 12.2715 4.83539 11.396 6.27842L11.7379 6.48591C12.4989 5.23173 14.1586 4.7989 15.4792 5.52117L15.6711 5.17023ZM11.396 6.27838C10.9688 6.98209 10.854 7.78603 11.0074 8.53528L11.3992 8.45506C11.2651 7.79962 11.3656 7.09919 11.7379 6.48595L11.396 6.27838ZM11.0074 8.53532C11.1129 9.05011 11.017 9.58477 10.7542 10.04L11.1006 10.24C11.4097 9.70448 11.5254 9.07056 11.3992 8.45502L11.0074 8.53532ZM10.7542 10.04L10.3139 10.8025L10.6603 11.0025L11.1006 10.24L10.7542 10.04ZM10.3871 11.0757L13.3334 12.7767L13.5334 12.4303L10.5871 10.7293L10.3871 11.0757ZM13.6066 12.7035L14.0593 11.9194L13.7129 11.7194L13.2602 12.5035L13.6066 12.7035ZM14.0593 11.9194C14.3193 11.4691 14.7409 11.1333 15.2432 10.9624L15.1143 10.5837C14.5255 10.784 14.024 11.1804 13.7129 11.7194L14.0593 11.9194ZM15.2431 10.9624C15.9401 10.7255 16.5554 10.2475 16.9496 9.56476L16.6032 9.36476C16.2597 9.95969 15.7239 10.3765 15.1144 10.5837L15.2431 10.9624ZM16.9496 9.56472C17.8257 8.04647 17.2785 6.09726 15.7385 5.20812L15.5385 5.55453C16.8937 6.33696 17.3652 8.04426 16.6032 9.3648L16.9496 9.56472ZM15.5385 5.55453L15.5388 5.55473L15.7388 5.20832L15.7385 5.20812L15.5385 5.55453Z'
        fill='#76698B'
        mask='url(#path-4-outside-1_4044_38402)'
      />
      <path
        d='M7.3522 9.09071L16.5743 14.4151C17.104 14.7209 17.0713 15.4835 16.5203 15.7295C15.3217 16.2642 13.1659 16.6414 10.1473 14.8986C7.12869 13.1559 6.37706 11.1001 6.2409 9.79465C6.17801 9.19427 6.82249 8.78489 7.3522 9.09071Z'
        stroke='#76698B'
        strokeWidth='0.9'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export const NutriIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='4' fill='#E6EDE6' />
      <path
        d='M19.3914 11.2055C19.2495 11.2055 19.129 11.092 19.129 10.9431V10.9289C19.129 10.1346 18.7035 9.40418 18.0227 9.00705C17.3348 8.60991 16.4909 8.60991 15.803 9.00705C15.1151 9.40418 14.6967 10.1346 14.6967 10.9289C14.6967 10.9998 14.6683 11.0636 14.6187 11.1133C14.569 11.1629 14.5052 11.1913 14.4343 11.1913C14.2924 11.1913 14.1719 11.0778 14.1719 10.9289C14.1719 9.95025 14.6896 9.04251 15.5335 8.55318C16.3774 8.06385 17.427 8.05676 18.278 8.54609C19.129 9.03542 19.6538 9.93607 19.6538 10.9147C19.6609 10.9856 19.6396 11.0636 19.5899 11.1133C19.5332 11.1771 19.4623 11.2055 19.3914 11.2055Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M13.4558 11.2126C13.3353 11.2197 13.2218 11.1346 13.1935 11.0141C13.1509 10.8368 13.0587 10.6737 12.9311 10.546C12.7396 10.3546 12.4772 10.2482 12.2077 10.2482C12.1084 10.2482 12.0162 10.1914 11.9737 10.0992C11.9311 10.0071 11.9453 9.90068 12.0162 9.82267C12.2219 9.58155 12.2999 9.25533 12.2361 8.9433C12.1722 8.63126 11.9666 8.36887 11.6758 8.22703C11.3922 8.0852 11.0589 8.0852 10.7681 8.22703C10.6404 8.28377 10.4915 8.23412 10.4277 8.10647C10.378 8.00719 10.3142 7.92209 10.2362 7.84408C10.0589 7.66679 9.8178 7.56041 9.56249 7.54623C9.30719 7.53204 9.05899 7.61005 8.86042 7.76607C8.80369 7.81571 8.72567 7.82989 8.65475 7.81571C8.58384 7.80153 8.51292 7.75898 8.47746 7.69515C8.41364 7.60296 8.34273 7.51077 8.26472 7.43276C7.98814 7.15618 7.61936 7.00726 7.23641 7.00016C6.84636 7.00016 6.4776 7.15618 6.20102 7.42567C5.92445 7.70224 5.77552 8.07101 5.77552 8.45397C5.77552 8.50361 5.77552 8.55325 5.77552 8.5958C5.80388 8.92911 5.95281 9.24824 6.19393 9.48936C6.27903 9.57446 6.37121 9.64538 6.47049 9.7092C6.53432 9.74466 6.58398 9.80849 6.59816 9.8865C6.61234 9.95741 6.59106 10.0354 6.54851 10.0992C6.36413 10.3262 6.28613 10.624 6.33577 10.9077C6.35704 11.0495 6.26483 11.1914 6.11591 11.2126C5.97407 11.2339 5.83224 11.1417 5.81097 10.9928C5.75423 10.6453 5.81806 10.2907 5.98826 9.98578C5.93153 9.94323 5.88188 9.89359 5.83224 9.84394C5.50602 9.51773 5.30745 9.09222 5.25781 8.63126V8.43978C5.25781 7.915 5.46348 7.40439 5.83934 7.03562C6.2152 6.65976 6.71872 6.4541 7.24351 6.4541C7.7683 6.4541 8.27889 6.66685 8.64766 7.04271C8.6973 7.09236 8.73985 7.142 8.7824 7.19873C9.07316 7.03562 9.41358 6.97889 9.74689 7.02144C10.0802 7.07108 10.3851 7.22001 10.6263 7.46113C10.683 7.51786 10.7397 7.58168 10.7894 7.6526C11.1723 7.53204 11.5836 7.5675 11.9453 7.7448C12.307 7.92209 12.5836 8.23413 12.7112 8.60999C12.846 8.98585 12.8247 9.40426 12.6616 9.76594C13.1793 9.92195 13.5764 10.3475 13.7041 10.8793C13.7395 11.0212 13.6544 11.1559 13.5126 11.1985L13.4558 11.2126Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M9.7183 11.2131C9.64738 11.2131 9.58355 11.1848 9.53391 11.1351L7.46313 9.06433C7.36385 8.96504 7.36385 8.79484 7.46313 8.69556C7.56242 8.59627 7.73261 8.59627 7.8319 8.69556L9.90269 10.7663C9.95233 10.816 9.98069 10.8798 9.98069 10.9507C9.98069 11.0216 9.95233 11.0855 9.90269 11.1351C9.85305 11.1848 9.78921 11.2131 9.7183 11.2131Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M10.0858 11.2129C9.98655 11.2129 9.89437 11.1561 9.85182 11.071C9.30576 9.98599 9.6036 9.31937 9.95109 8.9506C10.0504 8.84423 10.2135 8.83714 10.3199 8.94351C10.4263 9.0428 10.4333 9.20591 10.327 9.31228C9.98655 9.66687 9.97947 10.1846 10.3128 10.837C10.3766 10.9647 10.327 11.1207 10.1993 11.1845C10.1709 11.2058 10.1284 11.2129 10.0858 11.2129Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M15.462 19.6522H9.56164C8.69645 19.6522 7.85962 19.3188 7.22846 18.7302C4.32795 15.9857 3.6046 12.7094 4.58326 11.1208C4.6329 11.0428 4.718 10.9932 4.8031 10.9932H20.2063C20.2985 10.9932 20.3836 11.0428 20.4262 11.1208C21.4048 12.7023 20.6886 15.9857 17.7809 18.7302C17.164 19.3259 16.3272 19.6522 15.462 19.6522ZM4.95912 11.518C4.00883 13.3122 5.55481 16.4183 7.58305 18.3473C8.11493 18.8508 8.8241 19.1345 9.55455 19.1274H15.4549C16.1924 19.1274 16.8945 18.8508 17.4264 18.3473C19.4617 16.4254 21.0006 13.3122 20.0503 11.518H4.95912Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
      <path
        d='M14.9228 8.24856C14.3342 8.24856 13.0222 8.14218 12.1783 7.29826C11.0791 6.19196 11.228 4.32683 11.2351 4.24882C11.2493 4.12117 11.3415 4.02189 11.4691 4.0077C11.5472 4.0077 13.4265 3.85169 14.5186 4.94381C15.6178 6.04303 15.4689 7.91524 15.4618 7.99325C15.4476 8.1209 15.3483 8.22019 15.2207 8.23437C15.2065 8.24146 15.093 8.24856 14.9228 8.24856ZM11.7457 4.5254C11.7457 5.02182 11.8237 6.21323 12.5471 6.92949C13.2704 7.64576 14.4335 7.70959 14.9441 7.70959H14.9583C14.9583 7.21316 14.8803 6.02176 14.1569 5.30549C13.4336 4.59632 12.2492 4.51831 11.7457 4.5254Z'
        stroke='#68968D'
        strokeWidth='0.9'
      />
    </svg>
  )
}

export const PsicoIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='4' fill='#FFF1F1' />
      <path
        d='M7.15407 9.16207L7.79219 8.67958L6.82722 7.40333L6.18909 7.88582L7.15407 9.16207ZM7.90335 5.16452L8.45265 5.74614L7.90335 5.16452ZM7.78559 11.1053C8.09801 11.4177 8.60454 11.4177 8.91696 11.1053C9.22938 10.7929 9.22938 10.2863 8.91696 9.97391L7.78559 11.1053ZM12.8466 7.29216V6.49216H11.2466V7.29216H12.8466ZM9.43338 12.3293C8.99936 12.4119 8.71453 12.8308 8.7972 13.2648C8.87987 13.6989 9.29874 13.9837 9.73276 13.901L9.43338 12.3293ZM5.91381 16.837L6.69834 16.6804L5.91381 16.837ZM5.78636 16.6058L6.33366 16.0223L5.78636 16.6058ZM11.7813 19.9223L11.5474 19.1572L11.7813 19.9223ZM11.812 4.17447L11.5536 4.9316L11.812 4.17447ZM11.2466 4.52181V19.5533H12.8466V4.52181H11.2466ZM11.5474 19.1572C10.7344 19.4058 9.63197 19.5236 8.6947 19.2146C7.82691 18.9285 7.01236 18.2536 6.69834 16.6804L5.12929 16.9936C5.55343 19.1185 6.76579 20.2634 8.19379 20.7342C9.55232 21.182 11.0145 20.9933 12.0153 20.6873L11.5474 19.1572ZM6.33366 16.0223C5.7079 15.4354 4.95577 14.4245 4.8213 13.2542C4.69606 12.1644 5.08433 10.727 7.15407 9.16207L6.18909 7.88582C3.77804 9.70881 3.02751 11.6594 3.23176 13.4369C3.42677 15.1341 4.47243 16.4702 5.23906 17.1893L6.33366 16.0223ZM12.0704 3.41733C11.0344 3.06385 9.07507 2.95751 7.35405 4.58291L8.45265 5.74614C9.64615 4.61894 10.9427 4.72313 11.5536 4.9316L12.0704 3.41733ZM7.35405 4.58291C6.1513 5.71885 5.82961 7.00608 6.08444 8.22565C6.32537 9.37866 7.06017 10.3799 7.78559 11.1053L8.91696 9.97391C8.29861 9.35556 7.80162 8.62105 7.65062 7.89839C7.51352 7.24228 7.63975 6.51387 8.45265 5.74614L7.35405 4.58291ZM11.2466 7.29216C11.2466 9.48626 11.0927 10.6926 10.7881 11.3847C10.6489 11.7011 10.4877 11.8846 10.3055 12.0111C10.112 12.1454 9.84264 12.2513 9.43338 12.3293L9.73276 13.901C10.2641 13.7998 10.773 13.6342 11.2178 13.3255C11.6739 13.0089 12.0111 12.5779 12.2525 12.0293C12.7094 10.9913 12.8466 9.4653 12.8466 7.29216H11.2466ZM6.69834 16.6804C6.64924 16.4344 6.52479 16.2016 6.33366 16.0223L5.23906 17.1893C5.17878 17.1327 5.14327 17.0636 5.12929 16.9936L6.69834 16.6804ZM11.2466 19.5533C11.2466 19.3962 11.3477 19.2183 11.5474 19.1572L12.0153 20.6873C12.5371 20.5277 12.8466 20.0472 12.8466 19.5533H11.2466ZM12.8466 4.52181C12.8466 4.07674 12.587 3.59363 12.0704 3.41733L11.5536 4.9316C11.3296 4.85515 11.2466 4.65773 11.2466 4.52181H12.8466Z'
        fill='#E0BCBC'
      />
      <path
        d='M17.051 9.16207L16.4129 8.67958L17.3779 7.40333L18.016 7.88582L17.051 9.16207ZM16.3017 5.16452L15.7524 5.74614L16.3017 5.16452ZM16.4195 11.1053C16.1071 11.4177 15.6005 11.4177 15.2881 11.1053C14.9757 10.7929 14.9757 10.2863 15.2881 9.97391L16.4195 11.1053ZM11.3585 6.95622V6.15622H12.9585V6.95622H11.3585ZM14.1354 14.8005C14.5652 14.9028 14.8307 15.3342 14.7284 15.764C14.626 16.1938 14.1946 16.4593 13.7648 16.357L14.1354 14.8005ZM18.2913 16.837L17.5067 16.6804L18.2913 16.837ZM18.4187 16.6058L18.966 17.1893L18.4187 16.6058ZM12.4237 19.9223L12.1898 20.6873L12.4237 19.9223ZM12.9585 4.52181V19.5533H11.3585V4.52181H12.9585ZM12.6577 19.1572C13.4706 19.4058 14.5731 19.5236 15.5104 19.2146C16.3782 18.9285 17.1927 18.2536 17.5067 16.6804L19.0758 16.9936C18.6516 19.1185 17.4393 20.2634 16.0113 20.7342C14.6528 21.182 13.1905 20.9933 12.1898 20.6873L12.6577 19.1572ZM17.8714 16.0223C18.4972 15.4354 19.2493 14.4245 19.3838 13.2542C19.509 12.1644 19.1207 10.727 17.051 9.16207L18.016 7.88582C20.427 9.70881 21.1776 11.6594 20.9733 13.4369C20.7783 15.1341 19.7327 16.4702 18.966 17.1893L17.8714 16.0223ZM12.1347 3.41733C13.1706 3.06385 15.13 2.95751 16.851 4.58291L15.7524 5.74614C14.5589 4.61894 13.2624 4.72313 12.6514 4.9316L12.1347 3.41733ZM16.851 4.58291C18.0538 5.71885 18.3755 7.00608 18.1206 8.22565C17.8797 9.37866 17.1449 10.3799 16.4195 11.1053L15.2881 9.97391C15.9065 9.35556 16.4035 8.62105 16.5545 7.89839C16.6916 7.24228 16.5653 6.51387 15.7524 5.74614L16.851 4.58291ZM12.9585 6.95622C12.9585 9.06188 12.8194 10.9586 12.9687 12.4917C13.0419 13.2436 13.1789 13.8026 13.3834 14.1846C13.5703 14.5338 13.8026 14.7212 14.1354 14.8005L13.7648 16.357C12.9219 16.1562 12.3423 15.6298 11.9728 14.9397C11.6209 14.2824 11.457 13.4766 11.3762 12.6467C11.2175 11.0165 11.3585 8.88186 11.3585 6.95622H12.9585ZM17.5067 16.6804C17.5558 16.4344 17.6803 16.2016 17.8714 16.0223L18.966 17.1893C19.0263 17.1327 19.0618 17.0636 19.0758 16.9936L17.5067 16.6804ZM12.9585 19.5533C12.9585 19.3962 12.8574 19.2183 12.6577 19.1572L12.1898 20.6873C11.6679 20.5277 11.3585 20.0472 11.3585 19.5533H12.9585ZM11.3585 4.52181C11.3585 4.07674 11.6181 3.59363 12.1347 3.41733L12.6514 4.9316C12.8755 4.85515 12.9585 4.65773 12.9585 4.52181H11.3585Z'
        fill='#E0BCBC'
      />
    </svg>
  )
}

export const ObstetricsIcon = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.8676 20.7352C16.3173 20.7352 20.7352 16.3173 20.7352 10.8676C20.7352 5.41788 16.3173 1 10.8676 1C5.41788 1 1 5.41788 1 10.8676C1 16.3173 5.41788 20.7352 10.8676 20.7352Z'
        stroke='#707070'
        strokeWidth='1.6'
        strokeMiterlimit='10'
      />
      <path
        d='M13.9578 13.7676C13.9447 13.7687 13.9317 13.7698 13.9191 13.7714C13.9175 13.7719 13.9159 13.7719 13.9142 13.7719C13.906 13.773 13.8973 13.7736 13.8886 13.7747C13.8684 13.7758 13.8504 13.7774 13.8379 13.7785C13.8788 13.7725 13.9186 13.7692 13.9578 13.7676Z'
        fill='#707070'
      />
      <path
        d='M13.9578 13.7676C13.9447 13.7687 13.9317 13.7698 13.9191 13.7714C13.9175 13.7719 13.9159 13.7719 13.9142 13.7719C13.906 13.773 13.8973 13.7736 13.8886 13.7747C13.8684 13.7758 13.8504 13.7774 13.8379 13.7785C13.8788 13.7725 13.9186 13.7692 13.9578 13.7676Z'
        fill='#707070'
      />
      <path
        d='M13.3755 14.1933C14.5935 14.1933 15.3736 14.709 15.1708 15.9095C15.0901 16.3887 14.8753 16.8543 14.5204 17.1917C13.4301 18.2275 11.7242 18.3366 10.5406 18.3366C8.84079 18.3366 7.37537 17.4201 6.1749 16.399C5.16143 15.5371 4.2897 14.6071 3.90917 13.2954C3.85901 13.1231 3.80668 13.0097 3.77015 12.832L3.7358 12.7224C3.63713 12.3271 3.53027 11.4227 3.53027 10.9969C3.53027 10.6186 3.57171 10.2495 3.64967 9.89513C3.70691 9.46172 3.85574 9.05666 4.07545 8.70011C4.19211 8.50985 4.33004 8.33321 4.48487 8.17293C5.05948 7.57924 5.87342 7.21834 6.77078 7.24341C8.40629 7.28975 9.43285 8.42371 9.61385 10.05C9.66837 10.5406 9.55933 11.7945 8.08737 12.8849C9.55933 11.7945 11.5514 13.249 11.6855 14.4113C11.6855 14.4113 12.5033 14.1933 13.3755 14.1933Z'
        stroke='#707070'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.7041 12.9937C10.7041 12.9937 14.2684 11.7458 14.8747 9.64087C15.3381 8.03261 12.9846 5.80449 16.574 2.81641'
        stroke='#707070'
        strokeWidth='1.6'
        strokeMiterlimit='10'
      />
    </svg>
  )
}

export const InfoIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='18'
      viewBox='0 0 17 18'
      fill='none'
    >
      <path
        d='M8.5 16.5C12.6421 16.5 16 13.1421 16 9C16 4.85786 12.6421 1.5 8.5 1.5C4.35786 1.5 1 4.85786 1 9C1 13.1421 4.35786 16.5 8.5 16.5Z'
        stroke='#9274B4'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.5 12.75V9'
        stroke='#9274B4'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.50007 5.49756C8.41662 5.49756 8.33504 5.52231 8.26565 5.56867C8.19626 5.61503 8.14218 5.68093 8.11024 5.75803C8.07831 5.83513 8.06995 5.91997 8.08623 6.00182C8.10251 6.08367 8.1427 6.15885 8.20171 6.21786C8.26072 6.27687 8.3359 6.31706 8.41775 6.33334C8.4996 6.34962 8.58444 6.34127 8.66154 6.30933C8.73864 6.27739 8.80454 6.22331 8.8509 6.15392C8.89727 6.08454 8.92201 6.00296 8.92201 5.9195C8.92216 5.86405 8.91135 5.80912 8.8902 5.75786C8.86904 5.7066 8.83797 5.66002 8.79876 5.62081C8.75955 5.5816 8.71297 5.55053 8.66171 5.52938C8.61045 5.50822 8.55552 5.49741 8.50007 5.49756Z'
        fill='#9274B4'
        stroke='#9274B4'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const EggIcon = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1434_47245)'>
        <path
          d='M28.3519 0.903902L29.2517 1.42514C29.6932 1.68109 30.1939 1.81538 30.7035 1.81538H31.7422C32.7796 1.81538 33.7381 2.37077 34.2566 3.27242L34.7759 4.17547C35.0309 4.61858 35.3974 4.98635 35.8389 5.24229L36.7387 5.76353C37.6371 6.28384 38.1905 7.24585 38.1905 8.28693V9.32941C38.1905 9.84083 38.3248 10.3434 38.5794 10.7865L39.0987 11.6895C39.6172 12.5912 39.6172 13.702 39.0987 14.6036L38.5794 15.5067C38.3243 15.9498 38.1905 16.4523 38.1905 16.9637V18.0062C38.1905 19.0473 37.6371 20.0093 36.7387 20.5296L35.8389 21.0508C35.3974 21.3068 35.0309 21.6745 34.7759 22.1176L34.2566 23.0207C33.7381 23.9223 32.7796 24.4777 31.7422 24.4777H30.7035C30.1939 24.4777 29.6932 24.6125 29.2517 24.868L28.3519 25.3892C27.4534 25.9095 26.3466 25.9095 25.4482 25.3892L24.5484 24.868C24.1069 24.612 23.6062 24.4777 23.0966 24.4777H22.0579C21.0205 24.4777 20.062 23.9223 19.5435 23.0207L19.0241 22.1176C18.7691 21.6745 18.4027 21.3068 17.9612 21.0508L17.0613 20.5296C16.1629 20.0093 15.6095 19.0473 15.6095 18.0062V16.9637C15.6095 16.4523 15.4753 15.9498 15.2207 15.5067L14.7013 14.6036C14.1829 13.702 14.1829 12.5912 14.7013 11.6895L15.2207 10.7865C15.4757 10.3434 15.6095 9.84083 15.6095 9.32941V8.28693C15.6095 7.24585 16.1629 6.28384 17.0613 5.76353L17.9612 5.24229C18.4027 4.98635 18.7691 4.61858 19.0241 4.17547L19.5435 3.27242C20.062 2.37077 21.0205 1.81538 22.0579 1.81538H23.0966C23.6062 1.81538 24.1069 1.68062 24.5484 1.42514L25.4482 0.903902C26.3466 0.383595 27.4534 0.383595 28.3519 0.903902Z'
          fill='#EAE6FF'
        />
        <path
          d='M26.9001 26.2936C26.3094 26.2936 25.7187 26.1411 25.1919 25.8356L24.2921 25.3143C23.9293 25.1042 23.5158 24.9929 23.0967 24.9929H22.0579C20.8411 24.9929 19.7077 24.3359 19.0993 23.2785L18.5799 22.3754C18.3706 22.0114 18.068 21.7077 17.7048 21.4972L16.805 20.9759C15.7513 20.3653 15.0968 19.2278 15.0968 18.0066V16.9637C15.0968 16.543 14.9858 16.1285 14.7765 15.764L14.2571 14.8609C13.6487 13.8035 13.6487 12.4896 14.2571 11.4321L14.7765 10.5291C14.9858 10.1651 15.0968 9.75002 15.0968 9.32938V8.28689C15.0968 7.06567 15.7513 5.9282 16.805 5.31759L17.7048 4.79635C18.0675 4.58626 18.3701 4.28259 18.5799 3.91809L19.0993 3.01504C19.7077 1.95758 20.8411 1.30065 22.0579 1.30065H23.0967C23.5158 1.30065 23.9289 1.18929 24.2921 0.979202L25.1919 0.457959C26.2455 -0.152653 27.5547 -0.152653 28.6083 0.457959L29.5082 0.979202C29.8713 1.18929 30.2844 1.30065 30.7036 1.30065H31.7423C32.9591 1.30065 34.0925 1.95758 34.7009 3.01504L35.2203 3.91809C35.4296 4.28212 35.7322 4.58579 36.0954 4.79635L36.9952 5.31759C38.0489 5.9282 38.7035 7.06567 38.7035 8.28689V9.32938C38.7035 9.75002 38.8144 10.1646 39.0238 10.5291L39.5431 11.4321C40.1515 12.4896 40.1515 13.8035 39.5431 14.8609L39.0238 15.764C38.8144 16.128 38.7035 16.543 38.7035 16.9637V18.0066C38.7035 19.2278 38.0489 20.3653 36.9952 20.9759L36.0954 21.4972C35.7327 21.7073 35.4301 22.0109 35.2203 22.3754L34.7009 23.2785C34.0925 24.3359 32.9591 24.9929 31.7423 24.9929H30.7036C30.2844 24.9929 29.8709 25.1042 29.5082 25.3143L28.6083 25.8356C28.0815 26.1406 27.4908 26.2936 26.9001 26.2936ZM22.0579 2.3305C21.2066 2.3305 20.4131 2.78998 19.9874 3.5302L19.4681 4.43325C19.1687 4.95356 18.7361 5.38777 18.2177 5.68817L17.3178 6.20941C16.5807 6.6366 16.1225 7.43297 16.1225 8.28736V9.32985C16.1225 9.93063 15.9639 10.5235 15.6646 11.0442L15.1452 11.9473C14.7196 12.687 14.7196 13.6065 15.1452 14.3467L15.6646 15.2497C15.9639 15.7701 16.1225 16.3629 16.1225 16.9641V18.0071C16.1225 18.8615 16.5803 19.6578 17.3178 20.085L18.2177 20.6063C18.7361 20.9067 19.1687 21.3409 19.4681 21.8612L19.9874 22.7642C20.4131 23.5045 21.2066 23.9639 22.0579 23.9639H23.0967C23.6958 23.9639 24.2865 24.1226 24.8049 24.4234L25.7047 24.9447C26.4418 25.3719 27.3579 25.3719 28.0955 24.9447L28.9953 24.4234C29.5138 24.123 30.1045 23.9639 30.7036 23.9639H31.7423C32.5936 23.9639 33.3871 23.5045 33.8128 22.7642L34.3322 21.8612C34.6315 21.3409 35.0641 20.9067 35.5826 20.6063L36.4824 20.085C37.2199 19.6578 37.6778 18.8615 37.6778 18.0071V16.9641C37.6778 16.3633 37.8358 15.7705 38.1356 15.2497L38.655 14.3467C39.0806 13.6069 39.0806 12.6875 38.655 11.9473L38.1356 11.0442C37.8363 10.5239 37.6778 9.9311 37.6778 9.32985V8.28736C37.6778 7.43297 37.2199 6.6366 36.4824 6.20941L35.5826 5.68817C35.0641 5.38777 34.6315 4.95356 34.3322 4.43325L33.8128 3.5302C33.3871 2.79045 32.5936 2.3305 31.7423 2.3305H30.7036C30.1049 2.3305 29.5142 2.17142 28.9953 1.87102L28.0955 1.34978C27.3584 0.922586 26.4423 0.922586 25.7047 1.34978L24.8049 1.87102C24.2865 2.17142 23.6958 2.3305 23.0967 2.3305H22.0579Z'
          fill='#573377'
        />
        <path
          d='M26.9014 21.296C31.3861 21.296 35.0216 17.6473 35.0216 13.1465C35.0216 8.6457 31.3861 4.99707 26.9014 4.99707C22.4168 4.99707 18.7812 8.6457 18.7812 13.1465C18.7812 17.6473 22.4168 21.296 26.9014 21.296Z'
          fill='#9389A2'
        />
        <path
          d='M26.901 17.7324C29.4244 17.7324 31.47 15.6794 31.47 13.147C31.47 10.6145 29.4244 8.56152 26.901 8.56152C24.3776 8.56152 22.332 10.6145 22.332 13.147C22.332 15.6794 24.3776 17.7324 26.901 17.7324Z'
          fill='#E3DBEF'
        />
        <path
          d='M28.4668 13.0151C27.6751 13.0151 27.0312 12.369 27.0312 11.5745C27.0312 10.78 27.6751 10.1338 28.4668 10.1338C29.2584 10.1338 29.9022 10.78 29.9022 11.5745C29.9022 12.369 29.2584 13.0151 28.4668 13.0151ZM28.4668 10.976C28.1381 10.976 27.8704 11.2446 27.8704 11.5745C27.8704 11.9043 28.1381 12.1729 28.4668 12.1729C28.7954 12.1729 29.063 11.9043 29.063 11.5745C29.063 11.2446 28.7954 10.976 28.4668 10.976Z'
          fill='#9389A2'
        />
        <path
          d='M24.7671 16.0563C24.9664 16.0563 25.128 15.8942 25.128 15.6942C25.128 15.4942 24.9664 15.332 24.7671 15.332C24.5678 15.332 24.4062 15.4942 24.4062 15.6942C24.4062 15.8942 24.5678 16.0563 24.7671 16.0563Z'
          fill='#9389A2'
        />
        <path
          d='M26.814 16.6882C27.0133 16.6882 27.1748 16.526 27.1748 16.326C27.1748 16.126 27.0133 15.9639 26.814 15.9639C26.6147 15.9639 26.4531 16.126 26.4531 16.326C26.4531 16.526 26.6147 16.6882 26.814 16.6882Z'
          fill='#9389A2'
        />
        <path
          d='M23.8237 14.3444C24.023 14.3444 24.1846 14.1823 24.1846 13.9823C24.1846 13.7823 24.023 13.6201 23.8237 13.6201C23.6245 13.6201 23.4629 13.7823 23.4629 13.9823C23.4629 14.1823 23.6245 14.3444 23.8237 14.3444Z'
          fill='#9389A2'
        />
        <path
          d='M4.94293 36.4908C4.77509 36.4908 4.61005 36.408 4.51214 36.2559C4.35829 36.0173 4.42589 35.6986 4.66367 35.5442C4.94573 35.3608 5.69775 34.7062 5.79053 33.8907C5.99799 32.064 6.71924 29.7591 8.97575 29.1504C11.1372 28.5674 11.5381 28.3446 11.9414 28.0466C12.1694 27.8781 12.4906 27.9268 12.6584 28.1556C12.8263 28.3844 12.7778 28.7068 12.5498 28.8752C11.9829 29.294 11.3982 29.5631 9.24197 30.1447C7.87734 30.5124 7.05865 31.8123 6.80969 34.0072C6.67728 35.1732 5.74903 36.065 5.22127 36.408C5.13502 36.4641 5.03851 36.4908 4.94293 36.4908Z'
          fill='#9389A2'
        />
        <path
          d='M14.314 39.9996C14.1462 39.9996 13.9811 39.9168 13.8832 39.7647C13.7294 39.5261 13.797 39.2074 14.0348 39.053C14.3168 38.8696 15.0688 38.215 15.1616 37.3995C15.3691 35.5728 16.0903 33.2679 18.3468 32.6591C20.5083 32.0761 20.9092 31.8534 21.3125 31.5554C21.5405 31.3869 21.8617 31.4356 22.0295 31.6644C22.1974 31.8932 22.1489 32.2156 21.9209 32.384C21.354 32.8028 20.7693 33.0718 18.6131 33.6534C17.2484 34.0212 16.4297 35.321 16.1808 37.516C16.0484 38.682 15.1201 39.5738 14.5924 39.9168C14.5061 39.9729 14.4096 39.9996 14.314 39.9996Z'
          fill='#9389A2'
        />
        <path
          d='M0.513246 29.4254C0.345406 29.4254 0.180363 29.3426 0.0824565 29.1905C-0.0713968 28.9519 -0.00379462 28.6332 0.233979 28.4788C0.516043 28.2954 1.26806 27.6408 1.36084 26.8252C1.56831 24.9986 2.28955 22.6937 4.54607 22.0849C6.70747 21.5019 7.10843 21.2792 7.51171 20.9811C7.73969 20.8127 8.06092 20.8614 8.22876 21.0902C8.3966 21.319 8.34811 21.6414 8.12013 21.8098C7.5532 22.2286 6.96856 22.4976 4.81228 23.0792C3.44765 23.447 2.62896 24.7468 2.38 26.9418C2.24759 28.1078 1.31934 28.9996 0.79158 29.3426C0.705329 29.3987 0.608821 29.4254 0.513246 29.4254Z'
          fill='#9389A2'
        />
        <path
          d='M15.2612 28.4438C14.4225 29.33 13.0527 29.3193 12.2014 28.4204C11.3506 27.5216 11.3403 26.0748 12.1795 25.1891C13.0182 24.3033 15.4594 23.1823 16.3107 24.0811C17.1616 24.9799 16.1 27.5581 15.2612 28.4438Z'
          fill='#573377'
        />
        <path
          d='M24.6323 31.9526C23.7936 32.8388 22.4238 32.828 21.5725 31.9292C20.7217 31.0304 20.7114 29.5836 21.5506 28.6979C22.3893 27.8121 24.8305 26.691 25.6818 27.5899C26.5327 28.4887 25.4711 31.0669 24.6323 31.9526Z'
          fill='#573377'
        />
        <path
          d='M10.8316 21.3784C9.99282 22.2646 8.62306 22.2538 7.77174 21.355C6.92088 20.4561 6.91063 19.0094 7.74983 18.1237C8.58856 17.2379 11.0297 16.1168 11.881 17.0157C12.7319 17.9145 11.6703 20.4926 10.8316 21.3784Z'
          fill='#573377'
        />
      </g>
      <defs>
        <clipPath id='clip0_1434_47245'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const HeartTargetIcon = () => {
  return (
    <svg
      width='31'
      height='46'
      viewBox='0 0 31 46'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.25 31.1377V45.9976L15.9558 45.5345C16.4655 45.2004 26.7998 38.3458 29.7266 31.1377H15.25Z'
        fill='#A9CDC7'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.5384 45.5355C14.0301 45.2014 3.69578 38.3468 0.767578 31.1387H15.2456V35.2188C16.1194 35.2358 16.942 35.7629 17.2961 36.6258C17.7723 37.7862 17.2213 39.1144 16.0653 39.5924C15.7968 39.7035 15.5194 39.7589 15.2456 39.764V46L14.5384 45.5355Z'
        fill='#E0BCBC'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.34813 18.5176C11.0056 18.5176 13.4932 19.764 15.246 21.9074H15.2473V31.1384H10.895C10.8816 32.019 10.3558 32.8492 9.4931 33.2059C8.33708 33.684 7.01387 33.1308 6.53763 31.9704C6.42579 31.6979 6.37061 31.4162 6.3666 31.1384H0.767961C0.28177 29.9433 0 28.7398 0 27.5544C0 21.6218 4.19892 18.5176 8.34813 18.5176Z'
        fill='#FCF0E6'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.4913 27.5544C30.4913 28.7398 30.2082 29.9447 29.7234 31.1384H15.2467V28.669C15.1134 28.6714 14.978 28.6619 14.8417 28.6398C13.6075 28.4391 12.769 27.2722 12.9689 26.0333C13.1515 24.9019 14.137 24.1017 15.2467 24.1244V21.9074C17.005 19.7598 19.4899 18.5176 22.1418 18.5176C26.291 18.5176 30.4913 21.6218 30.4913 27.5544Z'
        fill='#C5BFCE'
      />
      <path
        d='M16.4114 5.79256C16.4114 8.99109 15.3326 11.5851 15.3326 11.5851C15.3326 11.5851 14.2539 8.99109 14.2539 5.79256C14.2539 2.59404 15.3326 0 15.3326 0C15.3326 0 16.4114 2.59404 16.4114 5.79256Z'
        fill='#E0BCBC'
      />
      <path
        d='M24.4494 9.90132C22.1953 12.164 19.6055 13.2316 19.6055 13.2316C19.6055 13.2316 20.669 10.632 22.9232 8.3693C25.1773 6.10662 27.7671 5.03906 27.7671 5.03906C27.7671 5.03906 26.7036 7.63865 24.4494 9.90132Z'
        fill='#E0BCBC'
      />
      <path
        d='M6.17317 10.0429C3.91901 7.78025 2.85547 5.18066 2.85547 5.18066C2.85547 5.18066 5.44527 6.24823 7.69943 8.5109C9.95359 10.7736 11.0171 13.3732 11.0171 13.3732C11.0171 13.3732 8.42733 12.3056 6.17317 10.0429Z'
        fill='#E0BCBC'
      />
    </svg>
  )
}

export const SuccessIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12Z'
        fill='#1E7C33'
      />
      <path
        d='M7.07227 12.7043L9.88812 15.5201L16.9278 8.48047'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const PsychologyIcon = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='40' height='40' rx='6' fill='#FCF0E6' />
      <path
        d='M20.408 15.5965C20.0464 15.1885 19.8403 14.712 19.7315 14.1885C19.6746 13.9147 19.7003 13.6383 19.6815 13.368C19.6085 13.3298 19.5764 13.3805 19.5452 13.4147C19.0569 13.9511 18.4382 14.264 17.724 14.4134C17.7025 14.4178 17.6827 14.4285 17.6612 14.4325C17.4702 14.4667 17.4156 14.4165 17.451 14.2316C17.5538 13.6987 17.786 13.2218 18.1151 12.7854C18.2477 12.6089 18.4143 12.4636 18.5878 12.292C18.4799 12.2565 18.3927 12.2685 18.3083 12.2694C17.6107 12.2792 16.9833 12.0716 16.4082 11.7C16.3899 11.688 16.3724 11.6756 16.3545 11.6627C16.2279 11.5707 16.2219 11.5245 16.344 11.4392C16.4628 11.3565 16.5868 11.2787 16.7153 11.2116C17.2284 10.9449 17.7768 10.8125 18.3606 10.816C18.4235 10.816 18.4896 10.8312 18.5525 10.796C18.5424 10.7218 18.4799 10.6889 18.435 10.6476C17.9058 10.1614 17.5969 9.56183 17.4569 8.87472C17.4487 8.83339 17.4427 8.78983 17.4464 8.7485C17.4523 8.68183 17.49 8.64761 17.5648 8.65783C17.9609 8.71072 18.3349 8.82761 18.6851 9.01427C19.0022 9.18361 19.2836 9.39738 19.531 9.65383C19.5686 9.69294 19.597 9.74894 19.6875 9.75472C19.6875 9.64227 19.6884 9.53161 19.6875 9.42138C19.6815 8.8365 19.8605 8.30361 20.173 7.80939C20.2263 7.72494 20.2648 7.63072 20.3401 7.56006C20.4273 7.47828 20.4544 7.4765 20.5273 7.5765C20.7968 7.94583 20.9978 8.34628 21.0955 8.78983C21.157 9.06716 21.1942 9.34805 21.1878 9.63338C21.1873 9.66005 21.1804 9.68938 21.2263 9.72627C21.3773 9.60449 21.515 9.45961 21.6715 9.33694C22.1461 8.9645 22.6922 8.75916 23.2843 8.6525C23.3912 8.63339 23.422 8.67072 23.4068 8.78627C23.3508 9.21516 23.2031 9.61294 22.9662 9.97827C22.7794 10.2658 22.5821 10.5458 22.2929 10.7618C22.3645 10.844 22.4499 10.8147 22.5224 10.8152C23.2416 10.816 23.8901 11.0289 24.4803 11.4196C24.5106 11.4396 24.5432 11.4569 24.5712 11.4792C24.6217 11.5187 24.6217 11.564 24.5753 11.6054C24.5432 11.6338 24.5056 11.6569 24.4698 11.6814C23.8942 12.0703 23.2581 12.2743 22.5536 12.2703C22.4756 12.2698 22.3935 12.2503 22.3049 12.2965C22.315 12.3814 22.3889 12.4236 22.4426 12.4738C22.9713 12.9712 23.2792 13.5774 23.4009 14.2774C23.4279 14.4338 23.4087 14.4663 23.259 14.4369C22.8341 14.3534 22.4182 14.2414 22.0456 14.0138C21.7968 13.8618 21.5632 13.6911 21.3617 13.4818C21.319 13.4378 21.2851 13.3783 21.2139 13.3676C21.1699 13.4036 21.1882 13.4494 21.1896 13.488C21.2075 13.972 21.0827 14.4294 20.9124 14.8783C20.8794 14.9649 20.8307 15.044 20.7775 15.1218C20.6701 15.2787 20.6141 15.4507 20.6164 15.6436C20.621 16.0134 20.6136 16.3831 20.6141 16.7525C20.6141 16.8214 20.5921 16.896 20.6485 16.9569C20.6738 16.9987 20.6494 17.0271 20.6145 17.04C20.5714 17.056 20.5485 17.0223 20.5338 16.9889C20.5044 16.9218 20.5053 16.8503 20.5053 16.7791C20.5039 16.4667 20.5035 16.1538 20.5053 15.8414C20.5058 15.7458 20.5021 15.6556 20.4076 15.5974L20.408 15.5965Z'
        fill='#DFBBBB'
      />
      <path
        d='M20.4083 15.5974C20.4739 15.6103 20.4913 15.5218 20.5776 15.5298V17.0325C20.6272 17.008 20.646 16.9876 20.6492 16.9569C20.8277 16.6774 21.0815 16.4978 21.4129 16.424C21.5662 16.3898 21.607 16.4263 21.569 16.5729C21.456 17.008 21.1825 17.304 20.7318 17.4191C20.5753 17.4591 20.5198 17.528 20.5051 17.6774C20.4794 17.9405 20.4707 18.2036 20.4968 18.4645C20.5684 19.1791 20.6056 19.8951 20.5923 20.6129C20.5914 20.6667 20.5712 20.7276 20.6235 20.7734C20.6717 20.7569 20.6827 20.7134 20.7011 20.676C21.0228 20.0276 21.5524 19.66 22.2909 19.5827C23.3364 19.4729 24.2699 19.7156 25.0501 20.4236C25.3512 20.6965 25.5665 21.0209 25.6647 21.4129C25.7335 21.6876 25.7083 21.9631 25.6752 22.2387C25.666 22.2658 25.6596 22.2933 25.6605 22.3213C25.6592 22.3391 25.6674 22.3511 25.6867 22.3547C25.7051 22.3516 25.7225 22.3485 25.7404 22.3458C26.1039 22.1613 26.4839 22.0493 26.9006 22.0729C27.612 22.1129 28.2224 22.38 28.6662 22.9116C29.1913 23.54 29.1982 24.2533 28.8916 24.9836C28.8677 25.0405 28.8099 25.0849 28.8191 25.1498C28.9531 25.1498 29.0834 25.1502 29.2138 25.1498C30.0257 25.1462 30.5581 25.7009 30.5044 26.4911C30.4832 26.7987 30.358 27.0667 30.1854 27.3196C30.1464 27.3769 30.084 27.4222 30.0743 27.496C30.1087 27.5498 30.1661 27.5364 30.2138 27.5471C30.6971 27.6533 31.1226 27.8671 31.4824 28.1969C31.9932 28.6653 32.1593 29.2573 32.1373 29.9195C32.1203 30.4231 31.9909 30.8871 31.6825 31.2982C31.6655 31.3209 31.654 31.3471 31.6412 31.3724C31.6384 31.3778 31.6421 31.3858 31.6449 31.4151C31.7798 31.4338 31.9244 31.4329 32.0643 31.4631C32.2943 31.5129 32.4893 31.616 32.6463 31.7853C32.7753 31.9244 32.818 32.0795 32.7321 32.2564C32.6514 32.4235 32.515 32.4995 32.3273 32.4955C32.2833 32.4947 32.2392 32.4955 32.1951 32.4955C28.4652 32.4955 24.7353 32.4955 21.0054 32.4955C20.8736 32.4955 20.7405 32.5027 20.6157 32.4489C20.5597 32.4178 20.5166 32.3742 20.4817 32.3218C20.4569 32.2973 20.4642 32.2587 20.4385 32.2351C20.3954 32.1547 20.4174 32.068 20.4174 31.9844C20.4161 29.0484 20.4165 26.112 20.4151 23.176C20.4151 23.092 20.4349 23.0053 20.3968 22.9236C20.4128 22.5205 20.4119 22.1169 20.3977 21.7138C20.4275 21.22 20.428 20.7258 20.3977 20.232C20.4138 20.1649 20.4078 20.0987 20.3913 20.0325C20.3614 19.9987 20.3757 19.9578 20.3725 19.92C20.3725 19.8911 20.3725 19.8622 20.3725 19.8334C20.3734 19.808 20.3702 19.7827 20.377 19.7578C20.3683 19.7822 20.3725 19.808 20.3711 19.8334C20.3711 19.8627 20.3711 19.8916 20.3711 19.9209C20.3656 19.9578 20.3867 20.0014 20.3431 20.0289L20.3458 20.0276C20.2958 20.1391 20.3578 20.2618 20.3087 20.3734C20.2944 20.4102 20.288 20.4471 20.3009 20.4858C20.2531 20.6014 20.3132 20.7276 20.2637 20.8427C20.249 20.8782 20.2416 20.9138 20.2568 20.9507C20.21 21.0676 20.2687 21.1951 20.2196 21.312C20.2059 21.348 20.1985 21.3849 20.2127 21.4227C20.1641 21.568 20.2251 21.7218 20.176 21.8667C20.1609 21.9196 20.1544 21.9729 20.1696 22.0271C20.132 22.1089 20.1517 22.1956 20.1512 22.2796C20.1499 25.4862 20.1503 28.6924 20.1489 31.8991C20.1489 31.9831 20.1701 32.0698 20.1287 32.1511C20.1173 32.1578 20.115 32.1662 20.1228 32.1773C20.1086 32.2107 20.1113 32.2511 20.0806 32.2782L20.0819 32.2755C20.0581 32.2995 20.07 32.3467 20.0255 32.3573L20.0314 32.3515C20.0287 32.3804 20.0122 32.3964 19.9823 32.3995L19.9883 32.3933C19.9778 32.4364 19.9277 32.4235 19.9048 32.4493C19.779 32.496 19.6478 32.5004 19.5151 32.5004C15.7921 32.4987 12.0686 32.4978 8.34552 32.4964C8.28677 32.4964 8.22757 32.4978 8.16928 32.4924C8.00268 32.4769 7.87693 32.4013 7.81359 32.2467C7.75255 32.0969 7.76632 31.9547 7.87234 31.8253C8.08346 31.5689 8.37122 31.4635 8.69662 31.4298C8.7673 31.4227 8.84073 31.4409 8.93115 31.4018C8.37811 30.6622 8.25511 29.856 8.54517 28.9964C8.84945 28.0951 9.59526 27.7133 10.4737 27.5133C10.4691 27.4133 10.4003 27.3724 10.3613 27.3156C10.0363 26.84 9.92754 26.3418 10.1832 25.8027C10.3764 25.396 10.7096 25.1862 11.1658 25.1547C11.3485 25.1418 11.5316 25.1476 11.7262 25.1787C11.728 25.0907 11.6757 25.0285 11.6477 24.9609C11.3939 24.3476 11.387 23.7418 11.7129 23.1502C11.957 22.7067 12.3687 22.4453 12.8281 22.2565C13.5028 21.9782 14.1706 21.9925 14.8127 22.3645C14.8374 22.3791 14.8645 22.3902 14.8907 22.4027C14.8971 22.4058 14.9049 22.4053 14.9123 22.4067C14.9384 22.3556 14.9072 22.3107 14.8962 22.2636C14.742 21.6085 14.915 21.0311 15.3795 20.5485C15.9417 19.9645 16.6489 19.6409 17.4723 19.5702C17.8023 19.5418 18.1332 19.5569 18.4595 19.6169C19.17 19.7476 19.6354 20.1605 19.9071 20.7978C19.9387 20.8725 19.9429 20.9631 20.0264 21.0347C20.0856 20.716 20.0943 20.412 20.1196 20.1102C20.2187 18.92 20.327 17.7302 20.3738 16.5365C20.3862 16.224 20.3959 15.9116 20.4064 15.5991L20.4083 15.5974Z'
        fill='#7D1546'
      />
      <path
        d='M20.1293 32.1509C20.1293 30.0331 20.1284 27.9149 20.1293 25.7971C20.1293 24.7096 20.1302 23.622 20.1344 22.5349C20.1348 22.3656 20.1201 22.194 20.1702 22.0273C20.1715 22.29 20.1734 22.5527 20.1734 22.8153C20.1734 25.8393 20.1738 28.8633 20.172 31.8873C20.172 31.9753 20.2083 32.0731 20.1298 32.1513L20.1293 32.1509Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.4012 22.9223C20.4379 22.997 20.4209 23.0761 20.4209 23.1534C20.4246 26.053 20.4269 28.9525 20.4301 31.8516C20.4301 31.9792 20.4384 32.1072 20.4429 32.2347C20.381 32.1863 20.3989 32.1183 20.3989 32.0565C20.3989 29.0259 20.3989 25.9952 20.3998 22.9645C20.3998 22.9503 20.4012 22.9361 20.4021 22.9219L20.4012 22.9223Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.3984 20.2309C20.4535 20.6042 20.4205 20.9798 20.4209 21.354C20.4209 21.4727 20.4393 21.5949 20.3989 21.7122C20.3989 21.2185 20.3989 20.7247 20.3989 20.2305L20.3984 20.2309Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.1752 21.8659C20.1715 21.7165 20.1614 21.5672 20.2119 21.4219C20.1991 21.5699 20.2606 21.7237 20.1752 21.8659Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.2217 21.3101C20.2189 21.1883 20.2079 21.0657 20.2588 20.9492C20.2483 21.0697 20.3047 21.1968 20.2217 21.3101Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.2643 20.8413C20.2611 20.7208 20.2529 20.5999 20.3015 20.4844C20.2914 20.6035 20.3469 20.7293 20.2643 20.8413Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.3081 20.3731C20.3053 20.2562 20.2925 20.1385 20.3452 20.0273C20.3342 20.1429 20.3888 20.2647 20.3081 20.3731Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.4805 32.3223C20.525 32.3645 20.5695 32.4067 20.6145 32.4494C20.53 32.4463 20.4855 32.404 20.4805 32.3223Z'
        fill='#FCF9F5'
      />
      <path
        d='M25.6353 22.3321C25.6445 22.2987 25.6468 22.2627 25.6771 22.2383C25.6881 22.2801 25.6973 22.3232 25.7422 22.3454C25.7257 22.3601 25.7092 22.3747 25.6927 22.3889C25.6486 22.3934 25.6247 22.3792 25.6353 22.3321Z'
        fill='#E9D8DC'
      />
      <path
        d='M20.3911 19.9038C20.392 19.9461 20.3925 19.9883 20.3934 20.031C20.3773 20.0296 20.3613 20.0283 20.3452 20.0274C20.3337 19.9852 20.3425 19.9443 20.3544 19.9038C20.3668 19.883 20.3792 19.8843 20.3911 19.9038Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.084 32.2767C20.0863 32.2384 20.0945 32.2024 20.1262 32.1758C20.1299 32.2162 20.1271 32.2544 20.084 32.2767Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.4395 32.2344C20.4674 32.257 20.4817 32.2855 20.4826 32.3206C20.4477 32.3015 20.4399 32.2695 20.4395 32.2344Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.0273 32.3572C20.0361 32.3234 20.0508 32.2936 20.0838 32.2754C20.0838 32.3149 20.076 32.3492 20.0273 32.3572Z'
        fill='#FCF9F5'
      />
      <path
        d='M19.9062 32.4466C19.9255 32.416 19.9544 32.3995 19.9898 32.3906C19.982 32.4373 19.9466 32.4453 19.9062 32.4466Z'
        fill='#FCF9F5'
      />
      <path
        d='M19.9844 32.3976C19.9908 32.3718 20.0073 32.3563 20.0335 32.3496C20.0298 32.3776 20.0133 32.3936 19.9844 32.3976Z'
        fill='#FCF9F5'
      />
      <path
        d='M20.4039 12.2747C19.9835 12.2659 19.6755 11.9441 19.6838 11.5223C19.692 11.113 20.0293 10.8059 20.4557 10.8188C20.8683 10.8312 21.2001 11.173 21.1868 11.5725C21.1735 11.969 20.8224 12.2836 20.4039 12.2747Z'
        fill='#7D1546'
      />
      <path
        d='M12.2895 28.0888C12.5694 28.2284 12.7787 28.4466 12.9774 28.675C13.1381 28.8599 13.2776 29.0603 13.4011 29.2706C13.4153 29.295 13.4258 29.3221 13.4414 29.3461C13.4708 29.3915 13.5062 29.4266 13.5658 29.387C13.6232 29.3488 13.6076 29.3043 13.5773 29.2586C13.5612 29.2346 13.5447 29.2115 13.5305 29.1866C13.2886 28.7666 12.9719 28.4057 12.6002 28.0888C12.5961 27.9692 12.5538 27.8688 12.4836 27.7657C12.3133 27.5155 12.2188 27.2452 12.3211 26.9377C12.4776 26.4679 12.7627 26.2715 13.2758 26.291C13.3336 26.2932 13.3914 26.3119 13.4525 26.2932C13.4887 26.2315 13.4364 26.1866 13.4148 26.1386C12.9875 25.1799 13.6673 24.3608 14.5195 24.1639C14.9941 24.0541 15.4191 24.1328 15.7885 24.4617C15.9446 24.6004 16.1135 24.6106 16.3815 24.5377C16.1328 24.4728 15.9207 24.3781 15.7922 24.1595C15.7073 24.0146 15.6963 23.8626 15.7202 23.7053C15.7307 23.6355 15.7509 23.5604 15.8556 23.575C15.99 23.6613 16.124 23.7475 16.259 23.8333C16.303 23.8613 16.3517 23.8901 16.3916 23.8306C16.4302 23.7728 16.3843 23.7381 16.3425 23.7088C16.1883 23.6013 16.0148 23.519 15.8923 23.3719C15.8675 23.1897 16.0029 23.0786 16.1139 22.9799C16.7156 22.4453 17.4321 22.2537 18.2274 22.4061C18.8461 22.5248 19.2257 22.9688 19.3051 23.5364C19.2899 23.4675 19.2638 23.3341 19.284 23.1995C19.2922 23.143 19.2697 23.0417 19.3955 23.0737C19.5042 23.2835 19.4588 23.5061 19.4409 23.7221C19.4249 23.9133 19.4125 24.1039 19.4125 24.2959C19.4125 26.4897 19.4125 28.6835 19.4125 30.8777C19.4125 31.0048 19.4249 31.1337 19.384 31.2581C19.2605 31.4546 19.0581 31.4848 18.8484 31.4866C18.2614 31.4919 17.6744 31.4883 17.0874 31.4883C16.1043 31.4883 15.1208 31.4888 14.1377 31.4883C13.6356 31.4883 13.3184 31.291 13.1785 30.895C13.0422 30.5083 13.1656 30.1652 13.5585 29.8595C13.2152 29.8848 12.9903 30.0488 12.8861 30.3515C12.7801 30.659 12.8352 30.9399 13.0775 31.1768C13.1473 31.2448 13.2826 31.2977 13.2464 31.4039C13.2046 31.5252 13.0587 31.4861 12.955 31.487C12.4267 31.4915 11.8984 31.4892 11.3702 31.4888C11.3482 31.4888 11.3261 31.4888 11.3041 31.4879C11.0071 31.4763 10.8103 31.3386 10.8029 31.1377C10.796 30.9452 10.9911 30.7755 11.2692 30.7328C11.4173 30.71 11.4517 30.6335 11.3725 30.5035C10.8511 29.6475 11.1467 28.5732 12.0164 28.1599C12.1027 28.119 12.1894 28.0821 12.289 28.0897L12.2895 28.0888Z'
        fill='#FCEDE6'
      />
      <path
        d='M27.9349 28.1013C27.5829 28.4164 27.2694 28.7618 27.0358 29.1698C27.0078 29.2191 26.9826 29.2702 26.9629 29.3231C26.9518 29.352 26.9725 29.3769 26.9996 29.3929C27.0303 29.4115 27.0611 29.3995 27.0781 29.3782C27.118 29.3275 27.1524 29.2729 27.1864 29.2187C27.3924 28.8889 27.6251 28.58 27.9258 28.3235C28.0244 28.2391 28.1236 28.1547 28.2438 28.0978C28.3076 28.056 28.3714 28.0778 28.432 28.1027C28.8657 28.28 29.1856 28.5644 29.3329 29.0084C29.511 29.5449 29.4752 30.0587 29.1576 30.5431C29.1273 30.5898 29.0809 30.6311 29.086 30.6987C29.1801 30.7444 29.2866 30.7178 29.3852 30.7444C29.6087 30.8058 29.7579 30.9671 29.7464 31.1453C29.7345 31.3275 29.5697 31.4747 29.3297 31.4809C28.7207 31.4964 28.1116 31.4889 27.5021 31.4844C27.4365 31.484 27.3566 31.4835 27.3241 31.4222C27.2837 31.3462 27.3548 31.292 27.3984 31.2369C27.4163 31.2142 27.4379 31.1947 27.4585 31.1747C27.6866 30.9507 27.8046 30.692 27.6807 30.3818C27.5577 30.0747 27.3346 29.8764 26.9757 29.8578C27.001 29.872 26.9633 29.856 26.9775 29.864C27.3709 30.0835 27.4792 30.424 27.3957 30.8293C27.3241 31.1755 26.9592 31.4635 26.5897 31.4831C26.3111 31.4978 26.0321 31.4875 25.7531 31.4875C24.4464 31.488 23.1398 31.4875 21.8336 31.4875C21.6348 31.4875 21.4334 31.4947 21.275 31.3462C21.2227 31.2973 21.2434 31.444 21.1855 31.3764C21.119 31.3053 21.1194 31.2187 21.1327 31.1347C21.1718 30.8871 21.1598 30.6387 21.1603 30.3902C21.1612 28.544 21.1607 26.6973 21.1603 24.8511C21.1603 24.5884 21.1649 24.3262 21.1263 24.0645C21.1075 23.9387 21.107 23.8093 21.1383 23.6836C21.2053 23.5742 21.2484 23.4551 21.2911 23.3347C21.51 22.7089 21.9947 22.3813 22.6771 22.3591C23.2958 22.3387 23.8447 22.5022 24.3326 22.8685C24.4446 22.9525 24.5299 23.0569 24.6066 23.1698C24.6571 23.244 24.6855 23.3222 24.6314 23.408C24.5506 23.5005 24.4423 23.5591 24.3413 23.6267C24.2995 23.6547 24.2555 23.6796 24.2151 23.7089C24.1742 23.7382 24.1261 23.7707 24.1637 23.8285C24.1999 23.8845 24.2491 23.8662 24.295 23.836C24.3849 23.7769 24.4744 23.7173 24.5653 23.6591C24.6135 23.6285 24.6635 23.6 24.7126 23.5707C24.8613 23.5809 24.8507 23.6991 24.859 23.7907C24.8893 24.1342 24.6098 24.4316 24.1371 24.5356C24.3927 24.6062 24.6098 24.6138 24.7865 24.4551C25.407 23.8973 26.2675 24.1169 26.8105 24.5547C27.3103 24.9578 27.3823 25.6636 27.1341 26.1467C27.1047 26.2036 27.0726 26.2596 27.0271 26.3449C27.2185 26.2964 27.3906 26.2724 27.5636 26.3093C28.1869 26.4409 28.4554 27.0978 28.1226 27.6818C28.046 27.8164 27.934 27.936 27.9372 28.1031L27.9349 28.1013Z'
        fill='#FCEDE6'
      />
      <path
        d='M21.1869 23.6162C21.2787 25.9695 21.209 28.3237 21.2301 30.6771C21.2315 30.8393 21.2397 31.0011 21.1934 31.1624C21.1736 31.2313 21.1603 31.3184 21.2287 31.3833C21.4458 31.5811 21.7134 31.5757 21.9878 31.5753C24.709 31.5717 27.4301 31.5731 30.1517 31.5731C30.2688 31.5731 30.3872 31.5815 30.5024 31.5544C30.6355 31.5233 30.7282 31.4455 30.7456 31.3108C30.7635 31.17 30.6772 31.0851 30.5528 31.0331C30.4441 30.9873 30.3284 30.9673 30.2109 30.9575C29.8736 30.9291 29.8644 30.9126 30.0553 30.6291C30.3413 30.2037 30.4262 29.7357 30.3527 29.242C30.2623 28.6326 29.8846 28.2366 29.3238 27.9802C29.2008 27.9237 29.0254 27.93 28.9851 27.754C29.3302 27.6206 29.6873 27.6162 30.0462 27.6744C30.5818 27.7611 31.0485 27.9846 31.4308 28.3642C31.776 28.7069 31.9224 29.1335 31.9765 29.594C32.038 30.118 31.9306 30.6113 31.6475 31.0664C31.5598 31.2077 31.457 31.3353 31.3285 31.4442C31.2918 31.4748 31.2321 31.502 31.256 31.562C31.2844 31.6326 31.3523 31.6104 31.4088 31.6051C31.5625 31.5904 31.7168 31.5833 31.8705 31.5948C32.1128 31.6131 32.3253 31.6988 32.5002 31.8655C32.5911 31.9522 32.6351 32.0531 32.592 32.174C32.5475 32.2993 32.4387 32.3415 32.3148 32.3464C32.1977 32.3513 32.0802 32.3424 31.9628 32.3424C28.3434 32.3424 24.7241 32.3424 21.1052 32.3424C21.0392 32.3424 20.9731 32.3446 20.907 32.3411C20.661 32.3282 20.5866 32.2544 20.5784 32.01C20.5738 31.8748 20.5742 31.7397 20.5742 31.6051C20.5751 29.3802 20.5733 27.1553 20.5793 24.9304C20.582 23.8433 20.5986 22.7558 20.6119 21.6686C20.6178 21.1611 20.7716 20.7033 21.1273 20.3211C21.4238 20.0024 21.8001 19.8109 22.2334 19.7531C23.317 19.6078 24.2748 19.8704 25.0463 20.6455C25.6209 21.2229 25.7081 22.0246 25.2914 22.6833C25.1679 22.7353 25.1376 22.6335 25.0977 22.5655C24.7103 21.9064 24.0944 21.6073 23.3472 21.4944C23.0283 21.4464 22.718 21.4669 22.4133 21.5455C21.6858 21.734 21.4242 22.2824 21.2939 22.9309C21.248 23.1589 21.2911 23.3984 21.1879 23.6171L21.1869 23.6162Z'
        fill='#FDFBF7'
      />
      <path
        d='M19.3357 31.2998C19.3366 29.1736 19.3412 27.0469 19.3357 24.9207C19.3343 24.374 19.36 23.8287 19.3807 23.2834C19.3834 23.2087 19.4078 23.1252 19.3407 23.0603C19.276 23.0123 19.2646 22.9389 19.2531 22.8705C19.0511 21.6807 18.1034 21.2892 16.9936 21.5309C16.3135 21.6789 15.7669 21.9909 15.4314 22.602C15.4024 22.6549 15.3772 22.7243 15.2909 22.7154C14.9375 22.2105 14.9297 21.6794 15.172 21.1345C15.2992 20.8483 15.503 20.6127 15.7513 20.4189C16.542 19.8025 17.4476 19.5994 18.4371 19.7718C19.0704 19.882 19.5014 20.2576 19.7469 20.8305C19.9773 21.3674 20.0296 21.9296 19.986 22.5038C19.9778 22.61 19.9691 22.7163 19.9691 22.8229C19.9681 25.8167 19.9686 28.81 19.9677 31.8038C19.9677 31.9105 19.9681 32.0176 19.9553 32.1233C19.9392 32.2553 19.8819 32.3096 19.7442 32.3287C19.6574 32.3407 19.5684 32.3402 19.4807 32.3402C15.8458 32.3407 12.2104 32.3402 8.57548 32.3411C8.46533 32.3411 8.35518 32.3509 8.24549 32.3465C8.12295 32.3411 8.01372 32.306 7.96599 32.178C7.92009 32.0549 7.96232 31.9571 8.05181 31.8691C8.22484 31.6994 8.4355 31.6114 8.67875 31.5936C8.8403 31.582 9.00185 31.5869 9.16249 31.6069C9.21389 31.6136 9.27034 31.6233 9.29467 31.5642C9.31394 31.5176 9.27723 31.4869 9.2451 31.4558C8.4993 30.7376 8.46625 29.8789 8.72464 28.9647C8.74759 28.8838 8.79165 28.8065 8.83617 28.734C9.34515 27.9087 10.5623 27.4229 11.5853 27.7522C11.5729 27.8949 11.4417 27.8994 11.3467 27.934C10.9047 28.0962 10.543 28.3478 10.3397 28.774C10.0285 29.4256 10.1373 30.0456 10.5058 30.6416C10.5247 30.6718 10.5522 30.6967 10.5733 30.7256C10.6109 30.778 10.6578 30.834 10.6197 30.8998C10.5871 30.9558 10.5201 30.9536 10.4613 30.9505C10.3273 30.9438 10.197 30.9616 10.0717 31.0051C9.92389 31.0567 9.80548 31.1425 9.81879 31.3127C9.83256 31.4887 9.97163 31.5402 10.1254 31.5642C10.2052 31.5767 10.2865 31.5727 10.3672 31.5727C13.149 31.5727 15.9302 31.5709 18.712 31.5762C18.9745 31.5767 19.1893 31.522 19.3366 31.3002L19.3357 31.2998Z'
        fill='#FDFBF7'
      />
      <path
        d='M11.6717 27.5872C11.3895 27.5485 11.1113 27.4765 10.8222 27.4974C10.768 27.5014 10.7208 27.485 10.6845 27.445C10.3233 27.0467 10.1104 26.6059 10.2627 26.061C10.411 25.5303 10.8823 25.2254 11.445 25.2992C11.6189 25.3219 11.7929 25.3472 11.9609 25.401C12.0141 25.4179 12.0807 25.4512 12.1233 25.393C12.1692 25.3303 12.1041 25.2899 12.0678 25.2494C11.8576 25.0134 11.7149 24.7459 11.657 24.4379C11.5547 23.8961 11.6759 23.4063 12.0398 22.9828C12.6034 22.3272 13.6062 22.0525 14.3892 22.3352C14.7398 22.4619 15.0414 22.6561 15.2438 22.9716C15.32 23.1903 15.3305 23.421 15.3755 23.6454C15.37 23.6952 15.3548 23.7392 15.3025 23.761C15.1979 23.7756 15.1231 23.7081 15.04 23.6672C14.3121 23.3067 13.3708 23.5085 12.8852 24.1436C12.5281 24.6107 12.5272 25.1152 12.7576 25.6356C12.7985 25.7285 12.9205 25.8205 12.8434 25.9219C12.7709 26.0179 12.6392 25.9619 12.5323 25.9476C12.1706 25.8996 11.8562 25.9819 11.6396 26.2819C11.406 26.6059 11.4395 26.9494 11.5914 27.2965C11.6313 27.3881 11.7397 27.4663 11.6708 27.5872H11.6717Z'
        fill='#FDFBF7'
      />
      <path
        d='M25.3322 22.9381C25.8026 22.3186 26.6315 22.0728 27.4383 22.3141C27.8546 22.4386 28.2098 22.6608 28.5067 22.9652C28.834 23.3008 28.9327 23.7199 28.9239 24.1652C28.9184 24.4439 28.8611 24.7155 28.7206 24.9648C28.6568 25.0781 28.5797 25.1808 28.4792 25.2661C28.4397 25.2999 28.3934 25.3377 28.4287 25.391C28.4618 25.4403 28.5205 25.4221 28.5701 25.4097C28.7188 25.3715 28.8666 25.3332 29.0203 25.3132C29.9231 25.1963 30.5142 25.8555 30.3003 26.7168C30.2338 26.9848 30.0842 27.2119 29.8969 27.4172C29.8515 27.467 29.801 27.5048 29.7271 27.4995C29.4453 27.4795 29.1741 27.5475 28.8992 27.587C28.8156 27.4803 28.9033 27.3995 28.9464 27.315C29.0781 27.0559 29.1222 26.7923 29.029 26.5101C28.8964 26.1061 28.5586 25.903 28.0661 25.9408C27.7954 25.9615 27.7128 25.8483 27.8183 25.6012C28.2213 24.6586 27.6714 23.7168 26.6058 23.5101C26.1803 23.4275 25.7902 23.4875 25.4249 23.711C25.3937 23.7301 25.3624 23.7484 25.3294 23.7644C25.1935 23.8301 25.1481 23.7728 25.1756 23.6475C25.222 23.4386 25.2445 23.2266 25.283 23.0168C25.3124 22.9981 25.3009 22.9555 25.3312 22.9372L25.3322 22.9381Z'
        fill='#FDFBF7'
      />
      <path
        d='M19.3334 31.2991C19.282 31.5422 19.1627 31.6351 18.885 31.6364C18.2829 31.6386 17.6812 31.6373 17.079 31.6373C14.8035 31.6373 12.528 31.6364 10.2521 31.6364C10.1424 31.6364 10.0345 31.6395 9.92943 31.5902C9.80459 31.5315 9.73391 31.4466 9.72886 31.3111C9.72381 31.1791 9.77384 31.0711 9.89179 31.0062C10.0735 30.9062 10.2686 30.8537 10.4802 30.8933C10.5164 30.8999 10.5509 30.9119 10.5853 30.8893C10.5977 30.8591 10.5871 30.8328 10.5651 30.8128C10.3113 30.5822 10.2176 30.2782 10.1428 29.9639C10.0157 29.4302 10.1043 28.9368 10.4315 28.4875C10.6514 28.1857 10.9602 28.0035 11.3104 27.8755C11.4036 27.8413 11.516 27.8417 11.5826 27.752C11.8387 27.8222 12.0865 27.908 12.2866 28.088C12.2141 28.1648 12.1072 28.1782 12.0172 28.2226C11.483 28.4862 11.2255 28.92 11.1851 29.4848C11.1535 29.9271 11.2737 30.3275 11.5702 30.6719C11.584 30.6879 11.5931 30.7075 11.6028 30.7262C11.6055 30.7315 11.6028 30.7395 11.6028 30.7608C11.527 30.8031 11.438 30.7808 11.3545 30.7826C11.2099 30.7853 11.0768 30.8204 10.9685 30.9128C10.7753 31.0777 10.8382 31.2635 11.0153 31.3662C11.0786 31.4026 11.147 31.4248 11.2237 31.4248C11.8841 31.4235 12.5446 31.4239 13.2032 31.4239C13.2357 31.3493 13.1747 31.3302 13.1371 31.3071C12.618 30.9835 12.6827 30.2768 13.0664 29.9622C13.2261 29.8311 13.4951 29.7599 13.7195 29.8137C13.6617 29.8573 13.6162 29.8946 13.5676 29.9275C13.0187 30.3008 13.0705 31.0346 13.6497 31.3524C13.7534 31.4093 13.8682 31.4253 13.9884 31.4253C15.6108 31.4235 17.2328 31.4213 18.8552 31.4279C19.0337 31.4288 19.1765 31.3511 19.3334 31.3004V31.2991Z'
        fill='#DFBBBB'
      />
      <path
        d='M28.9868 27.752C29.0795 27.8551 29.2195 27.8688 29.3388 27.9142C29.9713 28.1533 30.455 28.7751 30.4472 29.4848C30.4417 29.9782 30.3283 30.4253 30.0007 30.8115C29.9814 30.8342 29.969 30.8582 29.9878 30.9017C30.1801 30.8608 30.3715 30.8937 30.5578 30.9564C30.7561 31.0231 30.8575 31.1582 30.8355 31.3159C30.8102 31.4982 30.6634 31.6222 30.4546 31.6359C30.4178 31.6382 30.3811 31.6368 30.3444 31.6368C27.458 31.6368 24.5717 31.6355 21.6853 31.6395C21.471 31.6395 21.3117 31.5857 21.2305 31.3826C21.2328 31.3546 21.2351 31.3266 21.2396 31.2675C21.4737 31.4711 21.7463 31.4235 22.0093 31.4239C23.4986 31.4253 24.9884 31.4186 26.4777 31.4288C26.8573 31.4315 27.1157 31.2608 27.2777 30.9648C27.442 30.6648 27.3837 30.3595 27.173 30.0853C27.0835 29.9688 26.9445 29.9155 26.821 29.8315C27.229 29.7151 27.4902 29.9306 27.6682 30.1964C27.8 30.3937 27.8353 30.6111 27.7605 30.8479C27.6875 31.0799 27.4943 31.2151 27.3451 31.3826C27.3718 31.4457 27.4232 31.4226 27.4617 31.4226C28.0707 31.4244 28.6798 31.4226 29.2888 31.4248C29.4118 31.4253 29.5206 31.4022 29.6101 31.3155C29.7198 31.2088 29.7271 31.0684 29.6294 30.9533C29.5284 30.8351 29.3939 30.7893 29.2415 30.7848C29.1415 30.7817 29.041 30.7844 28.9272 30.7844C29.8478 29.6097 29.2177 28.3342 28.2438 28.0982C28.4604 27.9195 28.7128 27.8137 28.9873 27.7524L28.9868 27.752Z'
        fill='#DFBBBB'
      />
      <path
        d='M25.2852 23.0156C25.3857 23.1841 25.2737 23.3472 25.2687 23.513C25.2664 23.5881 25.232 23.6623 25.2085 23.7494C25.2714 23.7556 25.3063 23.7138 25.3421 23.6903C25.8671 23.341 26.4211 23.3343 26.9902 23.5658C27.2982 23.6912 27.5676 23.8716 27.758 24.1467C27.9751 24.4601 28.0536 24.8054 28.0013 25.1765C27.966 25.4303 27.882 25.6698 27.7209 25.8952C27.8094 25.9307 27.8751 25.9054 27.9444 25.8938C28.4667 25.8081 28.8678 25.9743 29.0486 26.3765C29.2065 26.7276 29.1684 27.0654 28.9766 27.3925C28.9408 27.4538 28.8857 27.5058 28.9008 27.5849C28.5598 27.7236 28.2308 27.8827 27.9352 28.1005C27.8618 28.0018 27.8792 27.9196 27.9563 27.8223C28.1147 27.6218 28.2023 27.3983 28.2023 27.1338C28.2019 26.6156 27.719 26.2569 27.2023 26.3623C27.1164 26.3796 27.0315 26.3894 26.925 26.4018C26.982 26.2987 27.0343 26.2098 27.0811 26.1178C27.2633 25.7592 27.2422 25.3938 27.115 25.0263C27.054 24.8503 26.9159 24.729 26.7791 24.6116C26.4505 24.329 26.0691 24.1556 25.6234 24.1747C25.3435 24.1867 25.0805 24.2654 24.8662 24.4667C24.6101 24.7076 24.2581 24.7112 24.002 24.4903C24.0524 24.4481 24.1126 24.4725 24.1667 24.4672C24.5353 24.4316 24.8249 24.1165 24.8024 23.7752C24.7969 23.6947 24.7817 23.6205 24.7101 23.5685C24.902 23.3841 25.0938 23.2001 25.2852 23.0156Z'
        fill='#DFBBBB'
      />
      <path
        d='M15.3286 23.658C15.2538 23.4349 15.2194 23.2073 15.2423 22.9727C15.4332 23.186 15.6361 23.3878 15.855 23.5744C15.6935 23.706 15.7458 23.8838 15.7931 24.026C15.8807 24.2891 16.0964 24.4327 16.3828 24.4691C16.4306 24.4753 16.4843 24.4513 16.5306 24.4953C16.5058 24.5722 16.4365 24.6082 16.3686 24.6202C16.1336 24.6611 15.9064 24.67 15.7127 24.4864C15.4259 24.2144 15.0831 24.1438 14.6838 24.1944C14.2221 24.2531 13.8733 24.474 13.5942 24.8091C13.3556 25.0953 13.306 25.4353 13.3666 25.794C13.401 25.998 13.4928 26.1802 13.5979 26.3535C13.5313 26.4073 13.4772 26.3762 13.4207 26.3669C13.1853 26.3278 12.9572 26.3344 12.7378 26.4486C12.4578 26.594 12.2031 27.1269 12.4165 27.538C12.4689 27.6393 12.5193 27.7402 12.5969 27.8286C12.7066 27.9535 12.7011 27.958 12.5978 28.0886C12.3151 27.8753 11.9906 27.7344 11.6689 27.5891C11.5932 27.4069 11.4885 27.2389 11.4371 27.0429C11.2774 26.4326 11.7488 25.7269 12.5896 25.8998C12.6685 25.9158 12.7438 25.9251 12.836 25.9122C12.7332 25.71 12.6029 25.5335 12.5726 25.3189C12.4845 24.7007 12.574 24.2162 13.1954 23.7713C13.6667 23.434 14.1936 23.3589 14.7558 23.4895C14.9504 23.5349 15.1193 23.6367 15.2813 23.7482C15.2988 23.7544 15.3213 23.7749 15.3332 23.7611C15.3607 23.7291 15.3534 23.6918 15.3281 23.6584L15.3286 23.658Z'
        fill='#DFBBBB'
      />
      <path
        d='M15.2891 22.7161C15.3685 22.6388 15.3988 22.5334 15.4561 22.4428C15.765 21.9565 16.2175 21.6708 16.7775 21.5237C16.9757 21.4717 17.1772 21.4352 17.3796 21.4143C18.0047 21.3503 18.6927 21.5352 19.0585 22.1508C19.2241 22.4299 19.3045 22.7401 19.3393 23.0605C19.3393 23.2588 19.3393 23.457 19.3393 23.6717C19.2723 23.6148 19.2645 23.5521 19.2498 23.493C19.0874 22.8374 18.5789 22.4219 17.8432 22.4165C17.2318 22.4121 16.6921 22.5774 16.2221 22.953C16.0798 23.0668 15.9761 23.213 15.8908 23.3708C15.6319 23.2023 15.4368 22.9792 15.2895 22.7157L15.2891 22.7161Z'
        fill='#DFBBBB'
      />
      <path
        d='M21.1888 23.6162C21.1791 23.2237 21.2227 22.8393 21.3563 22.4651C21.5431 21.9424 21.8947 21.5882 22.4587 21.4704C22.7345 21.4126 23.014 21.3931 23.3059 21.4264C23.7263 21.4744 24.1036 21.6086 24.4561 21.818C24.7595 21.9984 25.01 22.2344 25.161 22.5566C25.1872 22.6126 25.2069 22.6815 25.2923 22.6824C25.1275 22.9726 24.9095 23.2171 24.6291 23.4082C24.6273 23.21 24.4901 23.0748 24.3565 22.9664C23.7479 22.4722 23.0398 22.3073 22.2678 22.4744C21.8171 22.5717 21.5201 22.8686 21.3669 23.2922C21.3306 23.3917 21.2879 23.4895 21.2732 23.5962C21.2654 23.6513 21.2214 23.626 21.1888 23.6166V23.6162Z'
        fill='#DFBBBB'
      />
      <path
        d='M25.6345 22.332C25.6538 22.3511 25.6726 22.3703 25.6919 22.3889C25.6758 22.4227 25.6414 22.4551 25.6129 22.4329C25.5716 22.4009 25.5973 22.3605 25.6345 22.332Z'
        fill='#C08EA3'
      />
      <path
        d='M25.3318 22.9375C25.3341 22.9748 25.3199 23.0024 25.2836 23.0175C25.28 22.9797 25.2997 22.9548 25.3318 22.9375Z'
        fill='#DFBBBB'
      />
      <path
        d='M20.3922 19.9031H20.3738H20.3555C20.3555 19.8747 20.3555 19.8462 20.3555 19.8182C20.3683 19.7969 20.3803 19.7982 20.3926 19.8182C20.3926 19.8467 20.3926 19.8751 20.3926 19.9031H20.3922Z'
        fill='#E4D0D5'
      />
      <path
        d='M20.3915 19.8197L20.3731 19.8188H20.3548C20.3483 19.7926 20.3502 19.7539 20.3736 19.7539C20.3961 19.7539 20.3984 19.7935 20.3919 19.8197H20.3915Z'
        fill='#CBA1B2'
      />
      <path
        d='M16.8149 26.7081C16.1577 26.5516 15.5977 26.6663 15.1893 27.2125C14.79 27.7463 14.8102 28.2898 15.187 28.8423C14.7716 28.7485 14.3893 28.2121 14.3526 27.7596C14.2906 26.9983 14.8239 26.4561 15.3471 26.2934C15.9181 26.1161 16.5675 26.3472 16.8149 26.7076V26.7081Z'
        fill='#DFBBBB'
      />
      <path
        d='M25.4048 28.817C25.7219 28.237 25.7499 27.6983 25.3414 27.1775C24.9376 26.6628 24.3951 26.5672 23.7617 26.6997C24.0229 26.3144 24.6893 26.1432 25.201 26.3001C25.8692 26.505 26.2291 27.1139 26.2043 27.6281C26.1804 28.1197 25.9009 28.7166 25.4052 28.817H25.4048Z'
        fill='#DFBBBB'
      />
      <path
        d='M15.3281 23.6586C15.3634 23.7218 15.3983 23.7849 15.4396 23.8591C15.3464 23.852 15.3166 23.7969 15.2812 23.748C15.317 23.728 15.3253 23.6946 15.3281 23.6582V23.6586Z'
        fill='#EFDDDB'
      />
    </svg>
  )
}

export const VisaIcon = () => {
  return (
    <svg
      width='31'
      height='10'
      viewBox='0 0 31 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_446_268)'>
        <path
          d='M0 0.43306L0.121094 0.10685H4.10669C4.82599 0.10685 5.44195 0.62571 5.56466 1.33722L6.4987 6.74438L9.17326 0.10685H11.7897L7.70964 9.90125H5.08029L3.10807 2.21143C3.10807 2.21143 2.94661 1.00211 0 0.43306Z'
          fill='#1A2ADF'
        />
        <path
          d='M12.8513 0.10685H15.3668L13.2791 9.90125H10.7628L12.8513 0.10685Z'
          fill='#1A2ADF'
        />
        <path
          d='M22.5638 0.430629L22.1601 2.45426C22.1601 2.45426 21.0299 1.96859 19.8997 1.96859C18.7695 1.96859 18.466 2.91727 18.931 3.34467C19.8997 4.23506 22.1601 4.88263 22.1601 6.42059C22.1601 7.79666 21.595 9.17274 19.7383 9.73936C17.8815 10.306 15.6211 9.8203 14.9753 9.49652L15.5 7.36199C15.5 7.36199 16.6706 8.0395 17.72 8.0395C18.7695 8.0395 19.5768 7.71572 19.4961 6.90626C19.4154 6.09681 16.0247 5.28736 16.0247 3.26372C16.0247 1.24008 18.4466 -0.945444 22.5638 0.430629Z'
          fill='#1A2ADF'
        />
        <path
          d='M29.0044 0.10685H26.9983C26.4558 0.10685 25.9665 0.43225 25.755 0.932493L21.968 9.90125H24.6708L25.2287 8.36328H28.4578L28.746 9.90125H31.0008L29.0044 0.10685ZM25.8737 6.42059L27.2461 2.77805L28.0122 6.42059H25.8737Z'
          fill='#1A2ADF'
        />
      </g>
      <defs>
        <clipPath id='clip0_446_268'>
          <rect width='31' height='10' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const MastercardIcon = () => {
  return (
    <svg
      width='25'
      height='10'
      viewBox='0 0 27 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='7.5' cy='7.5' r='7.5' fill='#EB001B' />
      <circle cx='18.75' cy='7.5' r='7.5' fill='#F79E1B' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.125 12.4595C14.2919 11.1373 15 9.40062 15 7.49853C15 5.59645 14.2919 3.85974 13.125 2.53761C11.9581 3.85974 11.25 5.59645 11.25 7.49853C11.25 9.40062 11.9581 11.1373 13.125 12.4595Z'
        fill='#FF5F00'
      />
    </svg>
  )
}

export const AmexIcon = () => {
  return (
    <svg
      width='20'
      height='10'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_457_11882)'>
        <path
          d='M4.0912 9.39883H6.4049C6.40838 9.47378 6.41302 9.53042 6.41302 9.58706C6.41041 10.5886 6.40635 11.5905 6.40403 12.5921C6.402 13.3857 6.40142 14.1793 6.40084 14.9729C6.40084 15.173 6.40171 15.1739 6.60039 15.1742C8.8819 15.1748 11.1637 15.1742 13.4452 15.1774C13.5627 15.1774 13.6424 15.1388 13.7196 15.0519C14.0273 14.7054 14.3417 14.3646 14.6541 14.0224C14.673 14.0018 14.6962 13.9853 14.7281 13.9574C14.9007 14.147 15.0695 14.3306 15.2362 14.5163C15.3946 14.6923 15.5553 14.8669 15.7058 15.0493C15.7841 15.1443 15.8723 15.18 15.9933 15.1794C16.6264 15.1756 17.2599 15.1777 17.8931 15.1777C17.9215 15.1777 17.9499 15.1777 17.9876 15.1777V17.9898C17.9316 17.993 17.8849 17.9983 17.8382 17.9983C12.0472 17.9991 6.25611 17.9994 0.464746 17.9997C0.358299 17.9997 0.251562 17.9913 0.145985 17.9994C0.0369275 18.0078 -0.00106857 17.9637 0.000961751 17.8594C0.00618259 17.5933 0.00850296 17.327 0.00850296 17.0609C0.00879301 11.7404 0.00850296 6.41994 0.00850296 1.09918C0.00850296 0.741891 0.00850296 0.384598 0.00850296 0.00232386C0.137284 0.00232386 0.261424 0.00232386 0.385273 0.00232386C6.20506 0.00174289 12.0251 0.00145241 17.8455 0C17.9372 0 17.9992 0.00203338 17.9989 0.12665C17.9952 1.01262 17.9981 1.89859 17.9984 2.78456C17.9984 2.81245 17.992 2.84033 17.9868 2.88361C17.9302 2.88361 17.8786 2.88361 17.8266 2.88361C17.063 2.88361 16.299 2.88942 15.5353 2.87897C15.3699 2.87664 15.3148 2.9391 15.267 3.08317C15.1106 3.55376 14.9378 4.01911 14.7609 4.51496C14.6573 4.22651 14.5627 3.96508 14.4696 3.70306C14.3838 3.46196 14.2939 3.22232 14.2176 2.97831C14.1874 2.88216 14.1274 2.88245 14.0523 2.88245C13.6172 2.88332 13.1821 2.88245 12.7471 2.88245C12.1235 2.88245 11.4999 2.88652 10.8763 2.87984C10.7454 2.87839 10.7135 2.92021 10.7147 3.04512C10.7205 3.65978 10.7173 4.27473 10.7173 4.88939C10.7173 4.91612 10.7173 4.94284 10.7173 4.96956C10.7089 4.9716 10.7005 4.97334 10.6924 4.97537C10.5766 4.71278 10.4612 4.45018 10.3449 4.18788C10.1648 3.78178 9.98552 3.37511 9.80048 2.97105C9.78249 2.93212 9.72593 2.88565 9.68707 2.88565C8.77371 2.88303 7.86035 2.88652 6.947 2.88884C6.94236 2.88884 6.93772 2.89146 6.96817 2.88245C6.00609 5.06078 5.05357 7.21789 4.09091 9.39796L4.0912 9.39883Z'
          fill='#3375B9'
        />
        <path
          d='M14.7654 6.77803C14.8211 6.63743 14.8658 6.53315 14.904 6.42654C15.2138 5.56323 15.5253 4.70079 15.8281 3.83515C15.8815 3.68265 15.9473 3.61816 16.1228 3.62252C16.6881 3.63704 17.2537 3.62804 17.8193 3.62804C17.8712 3.62804 17.9231 3.62804 17.9948 3.62804C17.9948 3.73871 17.9948 3.8337 17.9948 3.92898C17.9956 5.44907 17.9948 6.96916 18.0003 8.48925C18.0009 8.62142 17.9606 8.65367 17.8367 8.65105C17.4936 8.6435 17.1505 8.64379 16.8073 8.64815C16.6965 8.6496 16.6585 8.61823 16.6591 8.50058C16.6646 7.45979 16.664 6.41899 16.6646 5.37819C16.6646 5.31313 16.658 5.24806 16.6202 5.17689C16.5811 5.27536 16.5393 5.37296 16.5031 5.4726C16.1379 6.47476 15.7722 7.47693 15.4102 8.48054C15.3626 8.61271 15.2942 8.66151 15.1456 8.65221C14.8663 8.63479 14.5853 8.64234 14.3051 8.6496C14.1966 8.6525 14.1403 8.61707 14.1029 8.51424C13.7325 7.49261 13.3584 6.47244 12.9854 5.45168C12.9503 5.35554 12.9161 5.25939 12.8813 5.16324C12.8688 5.16556 12.8563 5.16788 12.8438 5.17021C12.836 5.19461 12.8212 5.2193 12.8215 5.2437C12.8227 6.32807 12.8238 7.41215 12.8296 8.49652C12.8302 8.60835 12.7998 8.64815 12.6834 8.64757C11.8087 8.64466 10.9336 8.64699 10.0588 8.65076C9.97122 8.65105 9.93235 8.61619 9.90103 8.53718C9.794 8.26791 9.68175 8.00037 9.56312 7.73603C9.54543 7.69624 9.48452 7.65063 9.44333 7.65034C8.71822 7.64511 7.9931 7.64453 7.26828 7.65034C7.22332 7.65063 7.15719 7.70379 7.13746 7.74823C7.02174 8.00851 6.92109 8.27517 6.80478 8.53486C6.78303 8.58337 6.71284 8.64031 6.66382 8.64118C6.21947 8.65105 5.77483 8.6496 5.33018 8.65076C5.32264 8.65076 5.31539 8.64031 5.29712 8.62665C5.40067 8.38759 5.50392 8.14532 5.61037 7.90422C5.84038 7.38368 6.0727 6.86401 6.303 6.34346C6.6293 5.60593 6.95502 4.86782 7.28046 4.12999C7.33905 3.99753 7.39619 3.8642 7.45101 3.73C7.47943 3.66057 7.51772 3.62659 7.60154 3.62746C8.11869 3.63153 8.63585 3.62659 9.153 3.63269C9.19999 3.63327 9.27047 3.68004 9.28961 3.72303C9.67305 4.58343 10.0492 5.44704 10.4295 6.3089C10.6868 6.89248 10.9484 7.47402 11.2074 8.05673C11.2741 8.20661 11.3376 8.35767 11.404 8.50755C11.4191 8.54125 11.4409 8.57204 11.4928 8.59818V3.63966C11.556 3.63385 11.5972 3.62717 11.6384 3.62717C12.262 3.62659 12.8856 3.63007 13.5089 3.62455C13.6145 3.62368 13.647 3.669 13.6777 3.75585C14.0214 4.72984 14.3686 5.70266 14.7152 6.67549C14.7228 6.69698 14.7352 6.71673 14.766 6.77832L14.7654 6.77803ZM8.35508 4.83615C8.32114 4.89716 8.3107 4.91197 8.30403 4.92824C8.10042 5.42206 7.89826 5.91675 7.69261 6.40969C7.64128 6.53257 7.70161 6.55406 7.80341 6.55406C8.17061 6.55348 8.53781 6.55465 8.90501 6.55319C8.9459 6.55319 8.9868 6.53983 9.05815 6.52763C8.8235 5.96264 8.59669 5.41741 8.35537 4.83644L8.35508 4.83615Z'
          fill='#3375B9'
        />
        <path
          d='M11.4626 13.303V14.412H7.22824V9.41602H11.4641V10.5306C11.4241 10.5323 11.3869 10.5355 11.3495 10.5355C10.4556 10.5381 9.56167 10.5411 8.66774 10.5413C8.58566 10.5413 8.55694 10.5701 8.55897 10.652C8.56332 10.8408 8.56739 11.0299 8.55839 11.2182C8.55259 11.3407 8.59697 11.3759 8.71531 11.3747C9.30991 11.3701 9.90421 11.3733 10.4988 11.3724C10.7598 11.3721 11.0209 11.3718 11.2816 11.3654C11.3646 11.3634 11.409 11.38 11.4081 11.4738C11.4052 11.798 11.4069 12.1221 11.4069 12.4658H8.56013C8.56013 12.7298 8.55607 12.975 8.56594 13.2196C8.5671 13.2472 8.6457 13.2925 8.6892 13.2937C8.94503 13.3012 9.20143 13.2989 9.45754 13.2986C10.0858 13.2983 10.7143 13.2971 11.3426 13.2969C11.3759 13.2969 11.4096 13.3 11.4626 13.3027V13.303Z'
          fill='#3375B9'
        />
        <path
          d='M11.5273 9.40293C12.1144 9.40293 12.6649 9.4009 13.2154 9.40671C13.2626 9.40729 13.3198 9.45028 13.3552 9.48892C13.7981 9.97286 14.2384 10.4597 14.6781 10.9466C14.7004 10.9712 14.7129 11.0046 14.7407 11.0532C14.9142 10.8641 15.0601 10.706 15.2054 10.5471C15.5279 10.1945 15.8487 9.84011 16.1744 9.49037C16.2124 9.44941 16.2768 9.4099 16.3296 9.40932C16.8705 9.40351 17.4112 9.40584 17.98 9.40584C17.1832 10.2427 16.4012 11.0642 15.6036 11.9017C16.3882 12.7362 17.1696 13.567 17.9739 14.4225C17.8326 14.4225 17.7239 14.4225 17.6151 14.4225C17.1899 14.4225 16.7644 14.4265 16.3392 14.4181C16.2681 14.4166 16.1791 14.3783 16.1309 14.3266C15.6871 13.8493 15.2506 13.3654 14.8118 12.8835C14.7868 12.8562 14.7581 12.8321 14.7204 12.7961C14.542 12.9921 14.3715 13.1806 14.1998 13.3683C13.9002 13.6963 13.6017 14.0251 13.2983 14.3493C13.2635 14.3864 13.2012 14.4172 13.1513 14.4178C12.6295 14.4233 12.1074 14.4222 11.5856 14.4222C11.5781 14.4222 11.5702 14.4143 11.5467 14.4013C11.7608 14.1747 11.9714 13.9516 12.1819 13.7288C12.7293 13.1499 13.2774 12.5718 13.8207 11.9891C13.8439 11.9644 13.8398 11.877 13.8149 11.8502C13.2612 11.2574 12.7017 10.6697 12.1457 10.0792C11.9447 9.86567 11.7495 9.64636 11.527 9.40264L11.5273 9.40293Z'
          fill='#3375B9'
        />
        <path
          d='M17.9916 10.4866V13.333C17.5411 12.8523 17.104 12.386 16.6542 11.9056C17.0942 11.4388 17.5295 10.9769 17.9916 10.4866Z'
          fill='#3375B9'
        />
        <path
          d='M8.35506 4.83647C8.59638 5.41744 8.8232 5.96267 9.05785 6.52766C8.9865 6.54015 8.9456 6.55322 8.9047 6.55322C8.5375 6.55467 8.1703 6.55351 7.80311 6.55409C7.7013 6.55409 7.64126 6.5326 7.69231 6.40972C7.89795 5.91677 8.10011 5.42208 8.30373 4.92826C8.3104 4.912 8.32084 4.89718 8.35477 4.83618L8.35506 4.83647Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_457_11882'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const StripeIcon = () => {
  return (
    <svg
      width='99'
      height='21'
      viewBox='0 0 99 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.502'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M94.0084 21H4.9916C2.23457 21 0 18.8305 0 16.1538V4.84615C0 2.16946 2.23457 0 4.9916 0H94.0084C96.7654 0 99 2.16946 99 4.84615V16.1538C99 18.8305 96.7654 21 94.0084 21ZM9.25775 7.182H7.1305V13.0305H8.25111V10.9305H9.25775C10.484 10.9305 11.3592 10.1656 11.3592 9.06069C11.3592 7.95577 10.484 7.182 9.25775 7.182ZM14.1786 8.67865C12.8567 8.67865 11.9199 9.59619 11.9199 10.9055C11.9199 12.2058 12.8567 13.1323 14.1786 13.1323C15.5006 13.1323 16.429 12.2058 16.429 10.9055C16.429 9.59619 15.5006 8.67865 14.1786 8.67865ZM22.4089 8.78042L21.5246 11.6703L20.6403 8.78042H19.6253L18.7409 11.6703L17.8566 8.78042H16.736L18.2418 13.0305H19.2484L20.1328 10.1406L21.0263 13.0305H22.0329L23.5296 8.78042H22.4089ZM25.9996 8.67865C24.7475 8.67865 23.8374 9.58811 23.8374 10.8715C23.8374 12.197 24.765 13.1323 26.0869 13.1323C26.5769 13.1323 27.0761 13.0216 27.5752 12.8011V11.8908C27.1202 12.1461 26.6734 12.2907 26.2708 12.2907C25.5353 12.2907 25.0104 11.8488 24.9397 11.2027H27.908C27.9255 11.0581 27.9255 10.9224 27.9255 10.8029C27.9255 9.55419 27.146 8.67865 25.9996 8.67865ZM31.3838 8.72065C31.2615 8.68673 31.1392 8.67865 31.0161 8.67865C30.6401 8.67865 30.2549 8.86523 29.9396 9.20527V8.78042H28.819V13.0305H29.9396V10.1915C30.2283 9.83446 30.6226 9.639 30.9903 9.639C31.1218 9.639 31.2615 9.65596 31.3838 9.68988V8.72065ZM33.9495 8.67865C32.6975 8.67865 31.7873 9.58811 31.7873 10.8715C31.7873 12.197 32.7158 13.1323 34.0377 13.1323C34.5277 13.1323 35.0269 13.0216 35.526 12.8011V11.8908C35.0701 12.1461 34.6242 12.2907 34.2207 12.2907C33.4861 12.2907 32.9603 11.8488 32.8905 11.2027H35.858C35.8754 11.0581 35.8754 10.9224 35.8754 10.8029C35.8754 9.55419 35.0967 8.67865 33.9495 8.67865ZM40.6915 6.91869H39.5617V9.06958C39.2206 8.81435 38.8355 8.67865 38.4503 8.67865C37.2856 8.67865 36.4719 9.59619 36.4719 10.9055C36.4719 12.2139 37.2856 13.1323 38.4503 13.1323C38.8355 13.1323 39.2206 12.9966 39.5617 12.7325V13.0305H40.6915V6.91869ZM46.3303 8.67865C45.9543 8.67865 45.5691 8.81435 45.2189 9.06958V6.91869H44.0983V13.0305H45.2189V12.7325C45.5691 12.9966 45.9543 13.1323 46.3303 13.1323C47.5034 13.1323 48.3087 12.2139 48.3087 10.9055C48.3087 9.59619 47.5034 8.67865 46.3303 8.67865ZM51.8377 8.78042L50.7787 11.5686L49.7279 8.78042H48.5807L50.2529 12.877L49.4126 14.8914H50.4983L52.985 8.78042H51.8377ZM60.8218 8.30954C61.5397 8.30954 62.4524 8.52277 63.1712 8.89996V6.73938C62.3883 6.4365 61.6063 6.32019 60.8234 6.32019C58.9075 6.32019 57.6305 7.29185 57.6305 8.91531C57.6305 11.4539 61.2211 11.042 61.2211 12.1364C61.2211 12.5604 60.8417 12.6977 60.3151 12.6977C59.5323 12.6977 58.5223 12.3835 57.7295 11.9652V14.1548C58.608 14.5215 59.4982 14.675 60.3126 14.675C62.2768 14.675 63.6304 13.7332 63.6304 12.0823C63.6304 9.34742 60.019 9.8385 60.019 8.80627C60.019 8.44846 60.3268 8.30954 60.8218 8.30954ZM68.3682 6.47285H66.5746L66.5729 4.48108L64.2668 4.95762L64.256 12.3149C64.256 13.6726 65.3084 14.675 66.7102 14.675C67.4822 14.675 68.0529 14.5393 68.3674 14.3713V12.5047C68.0654 12.6218 66.5746 13.0426 66.5746 11.6913V8.42827H68.3682V6.47285ZM73.4389 6.47365C73.1244 6.36381 72.0204 6.1635 71.4672 7.1505L71.3191 6.47285H69.2767V14.511H71.6377V9.0615C72.196 8.34992 73.1385 8.48723 73.4389 8.58173V6.47365ZM76.537 3.41654L74.166 3.906V5.77419L76.537 5.28473V3.41654ZM76.537 6.47285H74.166V14.511H76.537V6.47285ZM81.6334 6.32019C80.7075 6.32019 80.1093 6.74342 79.7832 7.03904L79.6601 6.47285H77.5802L77.5811 17.178L79.9429 16.6902L79.9479 14.095C80.2873 14.3365 80.7923 14.675 81.6193 14.675C83.3089 14.675 84.8547 13.3552 84.8547 10.441C84.8547 7.77081 83.2923 6.32019 81.6334 6.32019ZM89.0576 6.32019C86.8105 6.32019 85.4428 8.17465 85.4428 10.5105C85.4428 13.276 87.0551 14.675 89.3562 14.675C90.4852 14.675 91.3329 14.4262 91.9743 14.0805V12.2333C91.3304 12.5483 90.5917 12.7405 89.6541 12.7405C88.7331 12.7405 87.922 12.4239 87.8163 11.3489H92.441C92.4519 11.2253 92.4727 10.7447 92.4727 10.5226C92.4727 8.17385 91.3013 6.32019 89.0576 6.32019ZM89.0426 8.19C89.6225 8.19 90.2381 8.62373 90.2381 9.65596H87.7955C87.7955 8.62292 88.4519 8.19 89.0426 8.19ZM81.0685 12.6493C80.5145 12.6493 80.1842 12.4554 79.9546 12.2139L79.9404 8.80627C80.1867 8.54377 80.5269 8.35154 81.0685 8.35154C81.9329 8.35154 82.5277 9.29169 82.5277 10.4911C82.5277 11.7261 81.942 12.6493 81.0685 12.6493ZM46.0941 12.197C45.7879 12.197 45.4809 12.0693 45.2189 11.8149V9.996C45.4809 9.74077 45.7879 9.61315 46.0941 9.61315C46.7247 9.61315 47.1623 10.1406 47.1623 10.9055C47.1623 11.6703 46.7247 12.197 46.0941 12.197ZM38.6957 12.197C38.0559 12.197 37.6183 11.6703 37.6183 10.9055C37.6183 10.1406 38.0559 9.61315 38.6957 9.61315C39.0018 9.61315 39.308 9.74077 39.5617 9.996V11.8149C39.308 12.0693 39.0018 12.197 38.6957 12.197ZM33.9063 9.51946C34.4046 9.51946 34.764 9.91927 34.7989 10.4976H32.8905C32.9429 9.91119 33.363 9.51946 33.9063 9.51946ZM25.9555 9.51946C26.4546 9.51946 26.814 9.91927 26.849 10.4976H24.9397C24.9929 9.91119 25.413 9.51946 25.9555 9.51946ZM14.1786 12.2228C13.5222 12.2228 13.0672 11.6873 13.0672 10.9055C13.0672 10.1236 13.5222 9.58812 14.1786 9.58812C14.8267 9.58812 15.2818 10.1236 15.2818 10.9055C15.2818 11.6873 14.8267 12.2228 14.1786 12.2228ZM9.10051 10.0469H8.25111V8.06642H9.10051C9.74859 8.06642 10.2037 8.46623 10.2037 9.06069C10.2037 9.64708 9.74859 10.0469 9.10051 10.0469Z'
        fill='#424770'
        fillOpacity='0.5'
      />
    </svg>
  )
}

export const ResultsIcon = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='40' height='40' rx='7' fill='#E8E1F3' />
      <path
        d='M19.4931 11.9392L24.5003 13.4912L21.0628 24.5815C20.6343 25.9642 19.1659 26.7377 17.7832 26.3091C16.4005 25.8805 15.627 24.4122 16.0556 23.0295L19.4931 11.9392Z'
        stroke='#948D9F'
        strokeWidth='1.5'
      />
      <path
        d='M16.059 23.0296L17.2525 19.179L23.0357 18.2274L21.0662 24.5816C20.6376 25.9643 19.1693 26.7378 17.7866 26.3092C16.4039 25.8806 15.6304 24.4123 16.059 23.0296Z'
        stroke='#948D9F'
        strokeWidth='1.5'
      />
      <path
        d='M25.4388 12.9969L18.9988 11.0008'
        stroke='#948D9F'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}

export const MyResultsIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M9.93183 2.93842L16.0165 4.82439L11.9667 17.8899C11.4459 19.5701 9.66165 20.51 7.98143 19.9892C6.30121 19.4684 5.3613 17.6841 5.8821 16.0039L9.93183 2.93842Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <path
        d='M5.88665 16.0033L7.30279 11.4345L14.3304 10.2781L11.9713 17.8893C11.4505 19.5695 9.6662 20.5094 7.98597 19.9886C6.30575 19.4678 5.36585 17.6835 5.88665 16.0033Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <path
        d='M16.9549 4.33006L9.4375 2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}

export const PrescriptionIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' fill='white' />
      <path
        d='M8.80078 12.7996H16.0008'
        stroke='currentColor'
        strokeWidth='2'
      />
      <path
        d='M8.80078 16.6997H16.0008'
        stroke='currentColor'
        strokeWidth='2'
      />
      <path
        d='M13.6006 7.8999V2.8999L19.0006 8.2999V8.8999H14.6006C14.0483 8.8999 13.6006 8.45219 13.6006 7.8999Z'
        fill='currentColor'
      />
      <path
        d='M5.5 19.5999V3.8999C5.5 3.34762 5.94772 2.8999 6.5 2.8999H13.1858C13.451 2.8999 13.7054 3.00526 13.8929 3.1928L18.7071 8.00701C18.8946 8.19455 19 8.4489 19 8.71412V19.5999C19 20.1522 18.5523 20.5999 18 20.5999H6.5C5.94772 20.5999 5.5 20.1522 5.5 19.5999Z'
        stroke='currentColor'
        strokeWidth='2'
      />
    </svg>
  )
}

export const DownloadIcon = () => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.4 16H16.6C16.8209 16 17 16.1791 17 16.4V17.6C17 17.8209 16.8209 18 16.6 18H7.4C7.17909 18 7 17.8209 7 17.6V16.4C7 16.1791 7.17909 16 7.4 16Z'
        fill='#424242'
      />
      <path
        d='M14.5 12.5154L12.282 14.7198C12.126 14.8748 11.874 14.8748 11.718 14.7198L9.5 12.5154L7.68795 10.7145C7.43477 10.4629 7.61296 10.0308 7.96992 10.0308H8.95949C9.1804 10.0308 9.35949 9.85171 9.35949 9.6308V5.4C9.35949 5.17909 9.53857 5 9.75949 5H14.2405C14.4614 5 14.6405 5.17909 14.6405 5.4V9.6308C14.6405 9.85172 14.8196 10.0308 15.0405 10.0308H16.0301C16.387 10.0308 16.5652 10.4629 16.312 10.7145L14.5 12.5154Z'
        fill='#424242'
      />
    </svg>
  )
}

export const RecipeIcon = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='40' height='40' rx='7' fill='#E6EDE6' />
      <path
        d='M14 12V11.25C13.5858 11.25 13.25 11.5858 13.25 12H14ZM24 12H24.75C24.75 11.5858 24.4142 11.25 24 11.25V12ZM26 28V28.75C26.4142 28.75 26.75 28.4142 26.75 28H26ZM26 27.8293H26.75C26.75 27.5114 26.5496 27.2281 26.2499 27.1222L26 27.8293ZM14 12.75H24V11.25H14V12.75ZM14.75 25V12H13.25V25H14.75ZM17 27.25C15.7574 27.25 14.75 26.2426 14.75 25H13.25C13.25 27.0711 14.9289 28.75 17 28.75V27.25ZM26 27.25H17V28.75H26V27.25ZM25.25 27.8293V28H26.75V27.8293H25.25ZM26.2499 27.1222C25.375 26.8129 24.75 25.9785 24.75 25H23.25C23.25 26.6339 24.2946 28.022 25.7501 28.5364L26.2499 27.1222ZM24.75 25V12H23.25V25H24.75Z'
        fill='#7F9F7F'
      />
      <path
        d='M16 16H22'
        stroke='#7F9F7F'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M16 18H22'
        stroke='#7F9F7F'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M16 20H22'
        stroke='#7F9F7F'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  )
}

export const DotTimeLine = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='currentColor'
    >
      <circle cx='10' cy='10' r='10' fill='#C5BFCE' />
      <circle
        cx='9.99993'
        cy='9.99944'
        r='5.71429'
        fill='currentColor'
        color='currentColor'
      />
    </svg>
  )
}

export const DotTimeLinePast = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 57 58'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.5 51.1667C40.7423 51.1667 50.6667 41.2423 50.6667 29C50.6667 16.7577 40.7423 6.83333 28.5 6.83333C16.2577 6.83333 6.33333 16.7577 6.33333 29C6.33333 41.2423 16.2577 51.1667 28.5 51.1667ZM28.5 57.5C44.2401 57.5 57 44.7401 57 29C57 13.2599 44.2401 0.5 28.5 0.5C12.7599 0.5 0 13.2599 0 29C0 44.7401 12.7599 57.5 28.5 57.5Z'
      fill='#989899'
      fillOpacity='0.5'
    />
    <circle
      cx='28.5003'
      cy='29.0003'
      r='15.8333'
      fill='#989899'
      fillOpacity='0.5'
    />
  </svg>
)

export const DotTimeLineActive = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 58 58'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29 51.1667C41.2423 51.1667 51.1667 41.2423 51.1667 29C51.1667 16.7577 41.2423 6.83333 29 6.83333C16.7577 6.83333 6.83333 16.7577 6.83333 29C6.83333 41.2423 16.7577 51.1667 29 51.1667ZM29 57.5C44.7401 57.5 57.5 44.7401 57.5 29C57.5 13.2599 44.7401 0.5 29 0.5C13.2599 0.5 0.5 13.2599 0.5 29C0.5 44.7401 13.2599 57.5 29 57.5Z'
      fill='#2A8929'
    />
    <circle cx='29.0003' cy='29.0003' r='15.8333' fill='#2A8929' />
  </svg>
)

export const DotTimeLineInactive = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 58 58'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29 51.1667C41.2423 51.1667 51.1667 41.2423 51.1667 29C51.1667 16.7577 41.2423 6.83333 29 6.83333C16.7577 6.83333 6.83333 16.7577 6.83333 29C6.83333 41.2423 16.7577 51.1667 29 51.1667ZM29 57.5C44.7401 57.5 57.5 44.7401 57.5 29C57.5 13.2599 44.7401 0.5 29 0.5C13.2599 0.5 0.5 13.2599 0.5 29C0.5 44.7401 13.2599 57.5 29 57.5Z'
      fill='#989899'
      fillOpacity='0.5'
    />
  </svg>
)

export const DotTimeLineFinalScheduled = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 63 62'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='31.5' cy='31' r='31' fill='#2A8929' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M44.9142 21.5858C45.6953 22.3668 45.6953 23.6332 44.9142 24.4142L28.9142 40.4142C28.1332 41.1953 26.8668 41.1953 26.0858 40.4142L18.0858 32.4142C17.3047 31.6332 17.3047 30.3668 18.0858 29.5858C18.8668 28.8047 20.1332 28.8047 20.9142 29.5858L27.5 36.1716L42.0858 21.5858C42.8668 20.8047 44.1332 20.8047 44.9142 21.5858Z'
      fill='white'
    />
  </svg>
)

export const iconTimeLine = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='currentColor'
    >
      <path d='M13.8 3.40909H13.6C13.3791 3.40909 13.2 3.23 13.2 3.00909V2.65C13.2 2.42909 13.0209 2.25 12.8 2.25H12.4C12.1791 2.25 12 2.42909 12 2.65V3.00909C12 3.23 11.8209 3.40909 11.6 3.40909H6.4C6.17909 3.40909 6 3.23 6 3.00909V2.65C6 2.42909 5.82091 2.25 5.6 2.25H5.2C4.97909 2.25 4.8 2.42909 4.8 2.65V3.00909C4.8 3.23 4.62091 3.40909 4.4 3.40909H4.2C3.54 3.40909 3 3.93068 3 4.56818V13.8409C3 14.4784 3.54 15 4.2 15H13.8C14.46 15 15 14.4784 15 13.8409V4.56818C15 3.93068 14.46 3.40909 13.8 3.40909ZM13.8 13.4409C13.8 13.6618 13.6209 13.8409 13.4 13.8409H4.6C4.37909 13.8409 4.2 13.6618 4.2 13.4409V7.86591C4.2 7.64499 4.37909 7.46591 4.6 7.46591H13.4C13.6209 7.46591 13.8 7.64499 13.8 7.86591V13.4409ZM13.8 5.90682C13.8 6.12773 13.6209 6.30682 13.4 6.30682H4.6C4.37909 6.30682 4.2 6.12773 4.2 5.90682V4.96818C4.2 4.74727 4.37909 4.56818 4.6 4.56818H13.4C13.6209 4.56818 13.8 4.74727 13.8 4.96818V5.90682Z' />
    </svg>
  )
}

export const IconMembership = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='13'
      viewBox='0 0 14 13'
      fill='none'
    >
      <g filter='url(#filter0_d_5565_12740)'>
        <path
          d='M2.5144 4.39888L4.31787 1.7168H6.99995H9.68203L11.4855 4.39888L7.0462 9.7168L2.5144 4.39888Z'
          fill='#E6F3FF'
        />
        <path
          d='M7.04644 9.71636L2.51465 4.39844H5.24297L7.04644 9.71636Z'
          fill='#C4D9F9'
        />
        <path
          d='M7.04675 9.71636L11.4861 4.39844H8.75776L7.04675 9.71636Z'
          fill='#C4D9F9'
        />
        <path
          d='M5.24248 4.39888L4.31763 1.7168H6.99971L5.24248 4.39888Z'
          fill='#C4D9F9'
        />
        <path
          d='M8.75776 4.39888L9.68262 1.7168H7.00054L8.75776 4.39888Z'
          fill='#C4D9F9'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_5565_12740'
          x='0.514404'
          y='0.716797'
          width='12.9717'
          height='12'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='1' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.341176 0 0 0 0 0.2 0 0 0 0 0.466667 0 0 0 0.51 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_5565_12740'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_5565_12740'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

export const IconPlay = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='18'
    viewBox='0 0 14 18'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.60423 4.61263C2.47096 4.5312 2.29995 4.62711 2.29995 4.78329V12.2172C2.29995 12.3734 2.47098 12.4693 2.60425 12.3878L8.68652 8.67057C8.81413 8.59257 8.81412 8.40723 8.68651 8.32925L2.60423 4.61263ZM0.699951 4.78329C0.699951 3.37765 2.23906 2.51442 3.4385 3.24735L9.52077 6.96397C10.6693 7.6658 10.6694 9.33387 9.52089 10.0358L3.43862 13.753C2.23919 14.4861 0.699951 13.6229 0.699951 12.2172V4.78329Z'
      fill='#573377'
    />
  </svg>
)

export const NextIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 5L15.75 11.75L9 18.5'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const CorazonPlenna = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='354'
    height='498'
    viewBox='0 0 354 498'
    fill='none'
  >
    <path
      opacity='0.04'
      d='M280.682 177.117C289.039 158.209 296.681 139.68 305.323 121.578C320.197 90.4734 337.628 60.8577 362.881 36.2891C376.875 22.6636 392.669 11.7976 411.605 5.62933C445.633 -5.46404 475.378 1.89762 501.129 24.6557C523.335 44.2834 533.611 69.9959 536.63 98.6004C541.066 140.766 531.255 181.158 516.869 220.732C503.394 257.815 485.032 292.701 464.547 326.604C460.649 333.056 455.23 334.944 449.75 331.942C444.271 328.941 443.352 322.947 447.255 316.363C469.677 278.616 489.912 239.884 503.18 198.141C512.58 168.558 518.884 138.489 516.979 107.419C515.832 88.7021 511.1 70.9292 500.637 55.0357C476.544 18.3376 434.25 9.97627 396.61 34.5535C374.034 49.2879 358.163 69.9143 344.303 92.153C324.852 123.372 310.601 156.885 297.972 191.072C297.608 192.183 297.486 193.352 297.612 194.504C297.738 195.657 298.11 196.768 298.704 197.766C338.48 250.144 356.035 309.796 357.736 374.683C357.777 376.014 357.869 377.341 358.005 379.618C371.856 380.084 385.602 380.818 399.364 380.948C449.442 381.413 499.017 376.486 547.921 364.898C549.078 364.615 550.251 364.403 551.433 364.263C557.559 363.651 562.272 366.874 563.145 372.3C564.017 377.726 560.674 382.29 554.618 383.715C492.393 398.411 429.433 403.35 365.836 399.808C363.473 399.679 361.101 399.593 358.733 399.526C358.207 399.615 357.693 399.767 357.204 399.979C356.117 407.593 355.207 415.41 353.843 423.146C350.553 441.961 345.211 460.185 334.017 476.306C319.827 496.78 297.959 503.169 277.795 492.544C264.786 485.689 257.57 474.096 252.875 460.888C244.631 437.684 243.007 413.437 243.348 389.062C243.43 383.305 241.481 381.385 236.011 379.983C189.229 368.279 143.857 352.811 101.206 330.729C71.8708 315.532 45.3599 296.698 26.3779 269.665C4.66725 238.845 -3.53395 204.338 2.22533 166.995C10.8539 111.079 57.1736 76.6882 114.865 82.8164C142.508 85.7567 167.475 95.9885 191.3 109.124C222.655 126.432 250.586 148.155 276.099 172.828C277.511 174.198 278.942 175.483 280.682 177.117ZM243.318 362.333C243.652 359.022 243.87 357.503 243.951 355.97C246.437 305.214 255.672 254.893 271.426 206.271C273.22 200.794 272.091 197.527 268.328 193.724C243.466 168.629 216.09 146.589 185.194 128.91C162.5 115.918 138.678 105.454 111.983 102.515C67.7558 97.6552 32.5062 122.344 23.2892 164.912C18.0104 189.325 21.4139 212.893 30.5997 235.72C40.7048 260.706 59.098 279.046 80.7454 294.636C109.046 315.021 141.05 328.535 173.93 340.166C196.502 348.075 219.541 354.781 243.318 362.333ZM289.146 219.042C288.582 220.013 288.086 221.02 287.662 222.055C274.054 267.59 266.093 314.476 263.951 361.704C263.798 365.038 264.952 366.526 268.367 367.048C289.978 370.366 311.55 373.774 333.156 377.113C334.616 377.187 336.082 377.136 337.537 376.96C336.516 319.741 321.564 267.312 289.146 219.042ZM263.428 387.077C263.843 396.478 263.952 405.658 264.616 414.793C265.745 430.391 267.733 445.884 274.704 460.184C279.25 469.618 285.923 477.11 297.648 477.526C308.603 477.914 314.179 470.169 319.106 462.265C328.166 447.747 332.166 431.588 334.74 415.104C335.607 409.47 336.108 403.783 336.758 398.346L263.428 387.077Z'
      fill='#F9F8F7'
      stroke='#F9F8F7'
      strokeWidth='0.5'
      strokeMiterlimit='10'
    />
  </svg>
)

export const IconHomeMembershipPlus = () => (
  <svg
    width='37'
    height='47'
    viewBox='0 0 37 47'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M18.5 46.8164C8.28273 46.8164 -3.6205e-07 38.5337 -8.08661e-07 28.3164L-2.04641e-06 9.15527e-05L37 8.99354e-05L37 28.3164C37 38.5337 28.7173 46.8164 18.5 46.8164Z'
      fill='#5D3881'
    />
    <g filter='url(#filter0_i_531_46363)'>
      <circle
        cx='18.5007'
        cy='30.5815'
        r='13.2143'
        fill='url(#paint0_linear_531_46363)'
      />
    </g>
    <g filter='url(#filter1_d_531_46363)'>
      <path
        d='M11.0916 29.5884L14.0705 25.1582H18.5007H22.9309L25.9099 29.5884L18.5771 38.3725L11.0916 29.5884Z'
        fill='#E6F3FF'
      />
      <path
        d='M18.5773 38.3729L11.0918 29.5889H15.5984L18.5773 38.3729Z'
        fill='#C4D9F9'
      />
      <path
        d='M18.5781 38.3729L25.9109 29.5889H21.4043L18.5781 38.3729Z'
        fill='#C4D9F9'
      />
      <path
        d='M15.598 29.5884L14.0703 25.1582H18.5005L15.598 29.5884Z'
        fill='#C4D9F9'
      />
      <path
        d='M21.4042 29.5884L22.9319 25.1582H18.5017L21.4042 29.5884Z'
        fill='#C4D9F9'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_531_46363'
        x='5.28638'
        y='17.3672'
        width='27.4285'
        height='27.4287'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_531_46363'
        />
      </filter>
      <filter
        id='filter1_d_531_46363'
        x='9.09155'
        y='24.1582'
        width='18.8193'
        height='17.2148'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.341176 0 0 0 0 0.2 0 0 0 0 0.466667 0 0 0 0.51 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_531_46363'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_531_46363'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_531_46363'
        x1='18.5007'
        y1='17.3672'
        x2='18.5007'
        y2='59.4543'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9274B4' />
        <stop offset='0.645453' stopColor='#CFB0F2' />
      </linearGradient>
    </defs>
  </svg>
)

export const IconMembershipDetail = () => (
  <svg
    width='123'
    height='124'
    viewBox='0 0 123 124'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='13.6663'
      y='12.9854'
      width='95.6664'
      height='95.2867'
      rx='5'
      fill='#EAE6FF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.4999 0.974609C20.4492 12.2083 11.2906 21.2994 0.000211716 21.2994H3.35629e-06L0 21.3079V21.3163H0.000211716C11.2907 21.3163 20.4493 30.4075 20.4999 41.6413C20.5505 30.4075 29.7092 21.3163 40.9997 21.3163H40.9999V21.3079C40.9999 21.3051 40.9999 21.3022 40.9999 21.2994C40.9998 21.2994 40.9997 21.2994 40.9997 21.2994C29.7093 21.2994 20.5506 12.2083 20.4999 0.974609Z'
      fill='url(#paint0_linear_713_74829)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M93.3877 84.1533C93.3541 87.7881 90.4599 90.742 86.8391 90.8897C90.4599 91.0373 93.3541 93.9913 93.3877 97.626C93.4213 93.9913 96.3155 91.0373 99.9363 90.8897C96.3155 90.742 93.4213 87.7881 93.3877 84.1533Z'
      fill='url(#paint1_linear_713_74829)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M92.6283 109.881C92.589 112.326 90.6078 114.301 88.1536 114.344C90.6078 114.386 92.589 116.361 92.6283 118.806C92.6676 116.361 94.6489 114.386 97.1032 114.344C94.6489 114.301 92.6676 112.326 92.6283 109.881Z'
      fill='url(#paint2_linear_713_74829)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.8896 28.127C31.8893 28.127 31.889 28.127 31.8888 28.127H31.8879C31.8854 31.4659 29.1674 34.1719 25.8147 34.1723L25.8147 34.1769V34.1815C29.1674 34.1819 31.8854 36.8879 31.8879 40.2269H31.8888H31.8896C31.8921 36.8879 34.6101 34.1819 37.9628 34.1815L37.9628 34.1769C37.9628 34.1754 37.9628 34.1739 37.9628 34.1723C34.6101 34.1719 31.8921 31.4659 31.8896 28.127Z'
      fill='url(#paint3_linear_713_74829)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M103.259 84.2061C103.184 95.0014 94.3745 103.73 83.5185 103.73H83.5181L83.5181 103.739V103.74H83.5185C94.3746 103.74 103.184 112.468 103.259 123.264C103.334 112.468 112.143 103.74 122.999 103.74H122.999V103.739C122.999 103.736 122.999 103.733 122.999 103.73C122.999 103.73 122.999 103.73 122.999 103.73C112.143 103.73 103.334 95.0014 103.259 84.2061Z'
      fill='url(#paint4_linear_713_74829)'
    />
    <g filter='url(#filter0_i_713_74829)'>
      <ellipse
        cx='60.74'
        cy='59.8881'
        rx='25.8147'
        ry='25.7123'
        fill='url(#paint5_linear_713_74829)'
      />
    </g>
    <g filter='url(#filter1_d_713_74829)'>
      <path
        d='M46.2659 57.9562L52.0854 49.3359H60.74H69.3947L75.2142 57.9562L60.8892 75.0482L46.2659 57.9562Z'
        fill='#E6F3FF'
      />
      <path
        d='M60.8897 75.048L46.2664 57.9561H55.0702L60.8897 75.048Z'
        fill='#C4D9F9'
      />
      <path
        d='M60.8908 75.048L75.2158 57.9561H66.412L60.8908 75.048Z'
        fill='#C4D9F9'
      />
      <path
        d='M55.0693 57.9562L52.085 49.3359H60.7396L55.0693 57.9562Z'
        fill='#C4D9F9'
      />
      <path
        d='M66.4124 57.9562L69.3967 49.3359H60.7421L66.4124 57.9562Z'
        fill='#C4D9F9'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_713_74829'
        x='34.9253'
        y='34.1758'
        width='52.6294'
        height='52.4248'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_713_74829'
        />
      </filter>
      <filter
        id='filter1_d_713_74829'
        x='44.2659'
        y='48.3359'
        width='32.95'
        height='29.7119'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.341176 0 0 0 0 0.2 0 0 0 0 0.466667 0 0 0 0.51 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_713_74829'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_713_74829'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_713_74829'
        x1='6.83331'
        y1='10.0117'
        x2='36.9816'
        y2='37.3674'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCCD56' />
        <stop offset='1' stopColor='#FCA656' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_713_74829'
        x1='89.022'
        y1='87.1473'
        x2='98.9683'
        y2='95.8494'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCCD56' />
        <stop offset='1' stopColor='#FCA656' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_713_74829'
        x1='89.6452'
        y1='111.864'
        x2='96.2585'
        y2='117.832'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCCD56' />
        <stop offset='1' stopColor='#FCA656' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_713_74829'
        x1='27.8394'
        y1='30.8158'
        x2='36.8059'
        y2='38.9179'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCCD56' />
        <stop offset='1' stopColor='#FCA656' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_713_74829'
        x1='90.0983'
        y1='92.8855'
        x2='119.061'
        y2='119.235'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCCD56' />
        <stop offset='1' stopColor='#FCA656' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_713_74829'
        x1='60.74'
        y1='34.1758'
        x2='60.74'
        y2='116.069'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9274B4' />
        <stop offset='0.645453' stopColor='#CFB0F2' />
      </linearGradient>
    </defs>
  </svg>
)

export const IconCheck = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
  >
    <circle cx='12' cy='12.9746' r='9' fill='#F9F8F7' />
    <path
      d='M9 12.9746L11 14.9746L15 10.9746'
      stroke='#573377'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const IconArrow = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_2_5634)'>
      <rect width='24' height='24' rx='6' fill='white' />
      <path
        d='M8.25 18.5L15 11.75L8.25 5'
        stroke='#424242'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_2_5634'>
        <rect width='24' height='24' rx='6' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const IconPluss = () => (
  <svg
    width='27'
    height='28'
    viewBox='0 0 27 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_i_713_74874)'>
      <circle
        cx='13.5007'
        cy='14.1889'
        r='13.2143'
        fill='url(#paint0_linear_713_74874)'
      />
    </g>
    <g filter='url(#filter1_d_713_74874)'>
      <path
        d='M6.09155 13.1958L9.0705 8.76562H13.5007H17.9309L20.9099 13.1958L13.5771 21.9799L6.09155 13.1958Z'
        fill='#E6F3FF'
      />
      <path
        d='M13.5773 21.9804L6.0918 13.1963H10.5984L13.5773 21.9804Z'
        fill='#C4D9F9'
      />
      <path
        d='M13.5781 21.9804L20.9109 13.1963H16.4043L13.5781 21.9804Z'
        fill='#C4D9F9'
      />
      <path
        d='M10.598 13.1958L9.07031 8.76562H13.5005L10.598 13.1958Z'
        fill='#C4D9F9'
      />
      <path
        d='M16.4042 13.1958L17.9319 8.76562H13.5017L16.4042 13.1958Z'
        fill='#C4D9F9'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_713_74874'
        x='0.286377'
        y='0.974609'
        width='27.4285'
        height='27.4287'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_713_74874'
        />
      </filter>
      <filter
        id='filter1_d_713_74874'
        x='4.09155'
        y='7.76562'
        width='18.8193'
        height='17.2148'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.341176 0 0 0 0 0.2 0 0 0 0 0.466667 0 0 0 0.51 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_713_74874'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_713_74874'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_713_74874'
        x1='13.5007'
        y1='0.974609'
        x2='13.5007'
        y2='43.0617'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9274B4' />
        <stop offset='0.645453' stopColor='#CFB0F2' />
      </linearGradient>
    </defs>
  </svg>
)

export const IconBasic = () => (
  <svg
    width='27'
    height='29'
    viewBox='0 0 27 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_i_713_74883)'>
      <circle
        cx='13.5007'
        cy='14.1889'
        r='13.2143'
        fill='url(#paint0_linear_713_74883)'
      />
    </g>
    <g filter='url(#filter1_d_713_74883)'>
      <path
        d='M13.5003 20.9746L7.96073 15.387C7.47388 14.9165 7.15255 14.3097 7.04231 13.6527C6.93208 12.9957 7.03853 12.3218 7.34658 11.7265C7.57887 11.2774 7.91819 10.888 8.33659 10.5905C8.75499 10.293 9.24049 10.096 9.75308 10.0155C10.2657 9.93509 10.7907 9.97361 11.2849 10.1279C11.7791 10.2822 12.2283 10.5478 12.5955 10.9029L13.5003 11.7774L14.405 10.9029C14.7722 10.5478 15.2214 10.2822 15.7156 10.1279C16.2098 9.97361 16.7348 9.93509 17.2474 10.0155C17.76 10.096 18.2455 10.293 18.6639 10.5905C19.0823 10.888 19.4216 11.2774 19.6539 11.7265C19.9616 12.3215 20.0678 12.995 19.9577 13.6517C19.8476 14.3083 19.5267 14.9149 19.0404 15.3853L13.5003 20.9746Z'
        fill='url(#paint1_linear_713_74883)'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_713_74883'
        x='0.286377'
        y='0.974609'
        width='27.4285'
        height='27.4287'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_713_74883'
        />
      </filter>
      <filter
        id='filter1_d_713_74883'
        x='3'
        y='9.97461'
        width='21'
        height='19'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_713_74883'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_713_74883'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_713_74883'
        x1='13.5007'
        y1='0.974609'
        x2='13.5007'
        y2='43.0617'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9274B4' />
        <stop offset='0.645453' stopColor='#CFB0F2' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_713_74883'
        x1='13.5'
        y1='9.97461'
        x2='13.5'
        y2='20.9746'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#401C66' />
        <stop offset='1' stopColor='#573377' />
      </linearGradient>
    </defs>
  </svg>
)

export const TagMembershipBasic = () => (
  <svg
    width='49'
    height='62'
    viewBox='0 0 49 62'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M24.5 62C10.969 62 -4.79471e-07 51.031 -1.07093e-06 37.5L-2.71011e-06 3.8147e-06L49 1.67284e-06L49 37.5C49 51.031 38.031 62 24.5 62Z'
      fill='#EAE6FF'
    />
    <g filter='url(#filter0_i_2_13051)'>
      <circle cx='24.5' cy='39.5' r='17.5' fill='url(#paint0_linear_2_13051)' />
    </g>
    <g filter='url(#filter1_d_2_13051)'>
      <path
        d='M24.5004 48L16.4042 39.8726C15.6926 39.1882 15.223 38.3056 15.0618 37.35C14.9007 36.3943 15.0563 35.414 15.5065 34.5483C15.846 33.8949 16.342 33.3286 16.9535 32.8959C17.565 32.4632 18.2746 32.1765 19.0237 32.0595C19.7729 31.9425 20.5402 31.9985 21.2625 32.223C21.9848 32.4474 22.6413 32.8338 23.178 33.3503L24.5004 34.6222L25.8227 33.3503C26.3594 32.8338 27.016 32.4474 27.7382 32.223C28.4605 31.9985 29.2278 31.9425 29.977 32.0595C30.7262 32.1765 31.4358 32.4632 32.0473 32.8959C32.6588 33.3286 33.1547 33.8949 33.4942 34.5483C33.9438 35.4137 34.0992 36.3934 33.9382 37.3485C33.7773 38.3036 33.3082 39.1858 32.5974 39.8701L24.5004 48Z'
        fill='url(#paint1_linear_2_13051)'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_2_13051'
        x='7'
        y='22'
        width='36'
        height='36'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_2_13051'
        />
      </filter>
      <filter
        id='filter1_d_2_13051'
        x='11'
        y='32'
        width='27'
        height='24'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='2' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_2_13051'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_2_13051'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_2_13051'
        x1='24.5'
        y1='22'
        x2='24.5'
        y2='77.737'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9274B4' />
        <stop offset='0.645453' stopColor='#CFB0F2' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2_13051'
        x1='24.5'
        y1='32'
        x2='24.5'
        y2='48'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#401C66' />
        <stop offset='1' stopColor='#573377' />
      </linearGradient>
    </defs>
  </svg>
)

export const TagMembershipPlus = () => (
  <svg
    width='49'
    height='62'
    viewBox='0 0 49 62'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M24.5 62C10.969 62 -4.79471e-07 51.031 -1.07093e-06 37.5L-2.71011e-06 3.8147e-06L49 1.67284e-06L49 37.5C49 51.031 38.031 62 24.5 62Z'
      fill='#5D3881'
    />
    <g filter='url(#filter0_i_346_37838)'>
      <circle
        cx='24.5'
        cy='39.5'
        r='17.5'
        fill='url(#paint0_linear_346_37838)'
      />
    </g>
    <g filter='url(#filter1_d_346_37838)'>
      <path
        d='M14.6875 38.1854L18.6326 32.3184H24.4996H30.3667L34.3118 38.1854L24.6008 49.8184L14.6875 38.1854Z'
        fill='#E6F3FF'
      />
      <path
        d='M24.6008 49.8185L14.6875 38.1855H20.6557L24.6008 49.8185Z'
        fill='#C4D9F9'
      />
      <path
        d='M24.6014 49.8185L34.3125 38.1855H28.3443L24.6014 49.8185Z'
        fill='#C4D9F9'
      />
      <path
        d='M20.655 38.1854L18.6318 32.3184H24.4989L20.655 38.1854Z'
        fill='#C4D9F9'
      />
      <path
        d='M28.345 38.1854L30.3682 32.3184H24.5011L28.345 38.1854Z'
        fill='#C4D9F9'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_346_37838'
        x='7'
        y='22'
        width='36'
        height='36'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dx='1' dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'
        />
        <feBlend
          mode='normal'
          in2='shape'
          result='effect1_innerShadow_346_37838'
        />
      </filter>
      <filter
        id='filter1_d_346_37838'
        x='12.6875'
        y='31.3184'
        width='23.625'
        height='21.5'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.341176 0 0 0 0 0.2 0 0 0 0 0.466667 0 0 0 0.51 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_346_37838'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_346_37838'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_346_37838'
        x1='24.5'
        y1='22'
        x2='24.5'
        y2='77.737'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#9274B4' />
        <stop offset='0.645453' stopColor='#CFB0F2' />
      </linearGradient>
    </defs>
  </svg>
)

export const UrgencyIcon = () => (
  <svg
    width='111'
    height='111'
    viewBox='0 0 111 111'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='55.4999' cy='55.5' r='44.5461' fill='white' fillOpacity='0.4' />
    <circle cx='55.5' cy='55.5' r='55.5' fill='white' fillOpacity='0.2' />
    <g filter='url(#filter0_d_1_7851)'>
      <circle cx='55.5001' cy='55.5' r='33.5921' fill='white' />
    </g>
    <path
      d='M66.4231 55.5774V61.8673H67.2244C67.5674 61.8673 67.8454 62.1452 67.8454 62.4883V66.789C67.8454 67.1321 67.5675 67.41 67.2244 67.41L43.324 67.4087C42.981 67.4087 42.7031 67.1308 42.7031 66.7877V62.487C42.7031 62.144 42.981 61.866 43.3241 61.866H44.1254V55.5761C44.1254 49.4291 49.1271 44.4273 55.2742 44.4273H55.366L55.3661 44.429C61.471 44.4785 66.4231 49.461 66.4231 55.5774ZM65.1811 55.5763C65.1811 50.1143 60.7376 45.6695 55.2743 45.6695C49.8123 45.6695 45.3675 50.113 45.3675 55.5763V61.8662H65.1811V55.5763ZM43.9451 63.1082V66.1669H66.6034V63.1082H43.9451Z'
      fill='#F25C5C'
      stroke='#F25C5C'
      strokeWidth='0.2'
    />
    <path
      d='M48.4795 44.1337L48.4794 44.1335L45.7469 40.0286C45.7469 40.0286 45.7469 40.0285 45.7468 40.0285C45.5558 39.7427 45.6337 39.3577 45.919 39.167L45.919 39.167L45.9193 39.1668C46.2045 38.9777 46.5897 39.0533 46.7794 39.3393C46.7795 39.3394 46.7795 39.3394 46.7795 39.3394L49.5119 43.4442C49.5119 43.4443 49.5119 43.4443 49.512 43.4443C49.7029 43.7302 49.625 44.1151 49.3397 44.3058L49.3394 44.3061C49.2342 44.3757 49.1146 44.4099 48.9963 44.4099C48.7961 44.4099 48.599 44.3122 48.4795 44.1337Z'
      fill='#F25C5C'
      stroke='#F25C5C'
      strokeWidth='0.2'
    />
    <path
      d='M43.6432 48.8965C43.7585 48.9913 43.8983 49.0362 44.0346 49.0363L43.6432 48.8965ZM43.6432 48.8965C43.6431 48.8964 43.643 48.8963 43.6429 48.8962L39.7728 45.754C39.7728 45.7539 39.7728 45.7539 39.7728 45.7539C39.5056 45.5379 39.4655 45.1466 39.6826 44.8798C39.6826 44.8798 39.6826 44.8798 39.6826 44.8798L39.7601 44.9429C39.9412 44.7202 40.2707 44.685 40.4921 44.8674M43.6432 48.8965L40.5554 44.7899L40.5552 44.7897L40.4921 44.8674M40.4921 44.8674L40.5557 44.7902M40.4921 44.8674L44.363 48.0102C44.587 48.1913 44.6209 48.5195 44.4385 48.7435L40.5557 44.7902M40.5557 44.7902L44.4258 47.9324C44.4259 47.9325 44.4259 47.9325 44.426 47.9326C44.6931 48.1486 44.7332 48.5399 44.5161 48.8066L44.5161 48.8067C44.3939 48.9567 44.2158 49.0359 44.0348 49.0363L40.5557 44.7902Z'
      fill='#F25C5C'
      stroke='#F25C5C'
      strokeWidth='0.2'
    />
    <path
      d='M55.2742 42.7961C54.9311 42.7961 54.6532 42.5182 54.6532 42.1751V37.1906C54.6532 36.8476 54.9311 36.5696 55.2742 36.5696C55.6173 36.5696 55.8952 36.8476 55.8952 37.1906V42.1751C55.8952 42.5182 55.6173 42.7961 55.2742 42.7961Z'
      fill='#F25C5C'
      stroke='#F25C5C'
      strokeWidth='0.2'
    />
    <path
      d='M61.2092 44.3048L61.2091 44.3048L62.0692 44.1322C61.9494 44.3126 61.7519 44.4087 61.5522 44.4087C61.4339 44.4087 61.3144 44.3744 61.2092 44.3048ZM64.8017 40.0273L62.0692 44.1321L61.1198 43.4985L61.0366 43.4431L61.0366 43.443C61.0367 43.443 61.0367 43.443 61.0367 43.443L63.7691 39.338L63.7693 39.3379C63.9598 39.0528 64.3447 38.9745 64.6295 39.1657C64.9151 39.3553 64.9925 39.7417 64.8017 40.0272C64.8017 40.0273 64.8017 40.0273 64.8017 40.0273Z'
      fill='#F25C5C'
      stroke='#F25C5C'
      strokeWidth='0.2'
    />
    <path
      d='M67.1215 48.7182L70.7729 45.7535L70.773 45.7535C71.0387 45.5375 71.0787 45.1464 70.8632 44.8797M67.1215 48.7182L70.7854 44.9426M67.1215 48.7182L67.1231 48.7182L66.9033 48.8964C66.7889 48.9892 66.6506 49.036 66.5121 49.036C66.3326 49.036 66.1522 48.9585 66.0292 48.806C65.8138 48.5393 65.8538 48.1483 66.1195 47.9323L66.1196 47.9323L69.9901 44.7897L67.1215 48.7182ZM70.8632 44.8797L70.7854 44.9426M70.8632 44.8797C70.8632 44.8798 70.8632 44.8798 70.8633 44.8798L70.7854 44.9426M70.8632 44.8797C70.6488 44.6141 70.2561 44.5721 69.9903 44.7895L69.9904 44.7894L70.0535 44.867C70.2762 44.6847 70.6057 44.7199 70.7854 44.9426'
      fill='#F25C5C'
      stroke='#F25C5C'
      strokeWidth='0.2'
    />
    <path
      d='M50.5083 52.5377H53.1604V49.8855C53.1604 49.5425 53.4383 49.2646 53.7814 49.2646H56.7667C57.1098 49.2646 57.3877 49.5425 57.3877 49.8855V52.5377H60.0398C60.3829 52.5377 60.6608 52.8156 60.6608 53.1586V56.144C60.6608 56.487 60.3829 56.7649 60.0398 56.7649H57.3877V59.4171C57.3877 59.7601 57.1098 60.038 56.7667 60.038H53.7814C53.4383 60.038 53.1604 59.7601 53.1604 59.4171V56.7649H50.5083C50.1652 56.7649 49.8873 56.487 49.8873 56.144V53.1586C49.8873 52.8156 50.1652 52.5377 50.5083 52.5377ZM51.1293 55.523H53.7814C54.1245 55.523 54.4024 55.8009 54.4024 56.144V58.7961H56.1457V56.144C56.1457 55.8009 56.4236 55.523 56.7667 55.523H59.4188V53.7797H56.7667C56.4236 53.7797 56.1457 53.5018 56.1457 53.1587V50.5066H54.4024V53.1587C54.4024 53.5018 54.1245 53.7797 53.7814 53.7797H51.1293V55.523Z'
      fill='#F25C5C'
      stroke='#F25C5C'
      strokeWidth='0.2'
    />
    <defs>
      <filter
        id='filter0_d_1_7851'
        x='11.908'
        y='13.9079'
        width='87.1843'
        height='87.1842'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='2' />
        <feGaussianBlur stdDeviation='5' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.772549 0 0 0 0 0.74902 0 0 0 0 0.807843 0 0 0 0.5 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_1_7851'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_1_7851'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)

export const BoxHideIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='archive'>
      <mask
        id='mask0_4621_5598'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect id='Bounding box' width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4621_5598)'>
        <path
          id='archive_2'
          d='M12 17.596L15.6538 13.9423L14.6 12.8885L12.75 14.7385V10.2885H11.25V14.7385L9.4 12.8885L8.34625 13.9423L12 17.596ZM5 7.90375V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V7.90375H5ZM5.38475 20.5C4.88592 20.5 4.44708 20.3106 4.06825 19.9318C3.68942 19.5529 3.5 19.1141 3.5 18.6152V7.00575C3.5 6.79175 3.53433 6.58758 3.603 6.39325C3.6715 6.19908 3.77433 6.01992 3.9115 5.85575L5.3155 4.15775C5.4795 3.94358 5.68458 3.78042 5.93075 3.66825C6.17692 3.55608 6.43717 3.5 6.7115 3.5H17.2693C17.5436 3.5 17.8054 3.55608 18.0548 3.66825C18.3041 3.78042 18.5108 3.94358 18.675 4.15775L20.0885 5.875C20.2257 6.03917 20.3285 6.21992 20.397 6.41725C20.4657 6.61475 20.5 6.82058 20.5 7.03475V18.6152C20.5 19.1141 20.3106 19.5529 19.9318 19.9318C19.5529 20.3106 19.1141 20.5 18.6152 20.5H5.38475ZM5.3905 6.404H18.6L17.5095 5.10575C17.4775 5.07375 17.4407 5.04808 17.399 5.02875C17.3573 5.00958 17.3141 5 17.2693 5H6.72125C6.67642 5 6.63308 5.00958 6.59125 5.02875C6.54958 5.04808 6.51275 5.07375 6.48075 5.10575L5.3905 6.404Z'
          fill='#1E7C33'
        />
      </g>
    </g>
  </svg>
)

export const VisibilityOff = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='rounded/Visibility_off'>
      <path
        id='Vector'
        d='M12 5.97505C15.79 5.97505 19.17 8.10505 20.82 11.475C20.23 12.695 19.4 13.745 18.41 14.595L19.82 16.005C21.21 14.775 22.31 13.235 23 11.475C21.27 7.08505 17 3.97505 12 3.97505C10.73 3.97505 9.51 4.17505 8.36 4.54505L10.01 6.19505C10.66 6.06505 11.32 5.97505 12 5.97505ZM10.93 7.11505L13 9.18505C13.57 9.43505 14.03 9.89505 14.28 10.465L16.35 12.535C16.43 12.195 16.49 11.835 16.49 11.465C16.5 8.98505 14.48 6.97505 12 6.97505C11.63 6.97505 11.28 7.02505 10.93 7.11505ZM2.71241 3.13766C2.32424 3.52858 2.32506 4.16011 2.71461 4.54966L4.69 6.52505C3.06 7.80505 1.77 9.50505 1 11.475C2.73 15.865 7 18.975 12 18.975C13.52 18.975 14.98 18.685 16.32 18.155L19.0349 20.8699C19.4243 21.2594 20.0557 21.2594 20.4451 20.8699C20.8344 20.4806 20.8345 19.8494 20.4453 19.4599L4.12961 3.13506C3.73814 2.74337 3.1026 2.7447 2.71241 3.13766ZM9.51 11.345L12.12 13.955C12.08 13.965 12.04 13.975 12 13.975C10.62 13.975 9.5 12.855 9.5 11.475C9.5 11.425 9.51 11.395 9.51 11.345ZM6.11 7.94505L7.86 9.69505C7.63 10.245 7.5 10.845 7.5 11.475C7.5 13.955 9.52 15.975 12 15.975C12.63 15.975 13.23 15.845 13.77 15.615L14.75 16.595C13.87 16.835 12.95 16.975 12 16.975C8.21 16.975 4.83 14.845 3.18 11.475C3.88 10.045 4.9 8.86505 6.11 7.94505Z'
        fill='#7C621E'
      />
    </g>
  </svg>
)

export const ArrowRight = () => (
  <svg
    width='21'
    height='20'
    viewBox='0 0 21 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Arrow Right'>
      <path
        id='Line'
        d='M11.0391 1.53918L19.5 10.0001L11.0391 18.4609'
        stroke='#1E7C33'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Line_2'
        d='M19.4999 10L1.5 10'
        stroke='#1E7C33'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
)

export const PinUbicationIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M7.66668 2C5.27096 2 3.33334 3.878 3.33334 6.2C3.33334 7.244 3.64287 8.222 4.2062 9.104C4.7943 10.028 5.56811 10.82 6.16239 11.744C6.45334 12.194 6.66382 12.614 6.88668 13.1C7.04763 13.43 7.17763 14 7.66668 14C8.15572 14 8.28572 13.43 8.44049 13.1C8.66953 12.614 8.87382 12.194 9.16477 11.744C9.75906 10.826 10.5329 10.034 11.121 9.104C11.6905 8.222 12 7.244 12 6.2C12 3.878 10.0624 2 7.66668 2ZM7.66668 7.85C6.81239 7.85 6.11906 7.178 6.11906 6.35C6.11906 5.522 6.81239 4.85 7.66668 4.85C8.52096 4.85 9.2143 5.522 9.2143 6.35C9.2143 7.178 8.52096 7.85 7.66668 7.85Z'
      fill='#707070'
    />
  </svg>
)

export const PlayCircleIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask
      id='mask0_5212_127735'
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='40'
      height='40'
    >
      <rect width='40' height='40' fill='#D9D9D9' />
    </mask>
    <g mask='url(#mask0_5212_127735)'>
      <path
        d='M17.8334 25.5642L25.2342 20.8217C25.5426 20.625 25.6967 20.3517 25.6967 20.0017C25.6967 19.6517 25.5426 19.3772 25.2342 19.1784L17.8334 14.4359C17.5051 14.2095 17.1696 14.1907 16.8271 14.3796C16.4846 14.5688 16.3134 14.8614 16.3134 15.2575V24.7425C16.3134 25.1386 16.4846 25.4313 16.8271 25.6204C17.1696 25.8093 17.5051 25.7906 17.8334 25.5642ZM20.0042 35.8334C17.8256 35.8334 15.7746 35.4178 13.8513 34.5867C11.928 33.7556 10.2489 32.6231 8.81422 31.1892C7.37977 29.755 6.24672 28.0767 5.41505 26.1542C4.58366 24.2317 4.16797 22.1813 4.16797 20.0029C4.16797 17.8129 4.58352 15.7545 5.41464 13.8275C6.24575 11.9006 7.37825 10.2245 8.81214 8.79919C10.2463 7.37391 11.9246 6.24544 13.8471 5.41377C15.7696 4.58238 17.8201 4.16669 19.9984 4.16669C22.1884 4.16669 24.2469 4.58224 26.1738 5.41335C28.1007 6.24446 29.7769 7.37238 31.2021 8.7971C32.6274 10.2218 33.7559 11.8972 34.5876 13.8234C35.4189 15.7495 35.8346 17.8074 35.8346 19.9971C35.8346 22.1757 35.4191 24.2267 34.588 26.15C33.7569 28.0734 32.6289 29.7524 31.2042 31.1871C29.7795 32.6215 28.1041 33.7546 26.178 34.5863C24.2519 35.4177 22.1939 35.8334 20.0042 35.8334ZM20.0013 33.7392C23.8288 33.7392 27.0756 32.4034 29.7417 29.7317C32.4076 27.06 33.7405 23.8161 33.7405 20C33.7405 16.1725 32.4076 12.9257 29.7417 10.2596C27.0756 7.59377 23.8288 6.26085 20.0013 6.26085C16.1852 6.26085 12.9413 7.59377 10.2696 10.2596C7.59797 12.9257 6.26214 16.1725 6.26214 20C6.26214 23.8161 7.59797 27.06 10.2696 29.7317C12.9413 32.4034 16.1852 33.7392 20.0013 33.7392Z'
        fill='currentColor'
      />
    </g>
  </svg>
)

export const ShapeLeftIcon = () => (
  <svg
    width='153'
    height='84'
    viewBox='0 0 153 84'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_5212_127756)'>
      <path
        opacity='0.32'
        d='M4.06279 81.1583C17.6119 78.1876 28.2834 68.4919 38.7005 59.0273C40.367 57.5132 42.027 56.005 43.6912 54.5312C67.5913 33.3673 96.0009 17.387 126.442 7.97597C128.151 7.44815 129.87 6.93909 131.59 6.42971C139.118 4.20014 146.667 1.96452 153.496 -1.87646C163.211 -7.34234 169.843 -17.4384 172.501 -28.1745C173.207 -31.0279 173.585 -33.7858 173.676 -36.475M4.06279 81.1583L149.227 -86.4795C155.361 -79.164 160.905 -71.3462 165.732 -63.0982C170.797 -54.4488 173.997 -45.893 173.676 -36.475M4.06279 81.1583C-17.5669 85.8987 -38.8528 71.8353 -54.409 55.9542M4.06279 81.1583L-54.409 55.9542M173.676 -36.475L173.177 -36.492C173.087 -33.8384 172.714 -31.1151 172.015 -28.2946C169.384 -17.6654 162.823 -7.69797 153.251 -2.31226C146.475 1.49838 138.994 3.71468 131.469 5.9437C129.744 6.45476 128.016 6.96648 126.294 7.49823L126.294 7.49828C95.7852 16.9303 67.313 32.9459 43.3598 54.1569C41.6849 55.6401 40.0185 57.1541 38.3484 58.6715C33.9789 62.6415 29.5837 66.6348 24.943 70.1619C18.539 75.0293 11.7155 78.9686 3.95575 80.6699C-17.4004 85.3503 -38.5137 71.4669 -54.0518 55.6043L-54.409 55.9542M173.676 -36.475L173.177 -36.492C173.493 -45.7788 170.34 -54.2389 165.301 -62.8457C160.488 -71.0685 154.96 -78.8635 148.844 -86.1582C136.575 -100.785 121.941 -113.374 105.803 -123.491L106.069 -123.914L105.803 -123.491C95.1365 -130.18 83.8029 -135.796 72.0254 -140.205L72.2007 -140.673L72.0254 -140.205C30.1355 -155.886 -16.708 -156.581 -59.804 -144.708C-78.7905 -139.476 -98.2104 -130.916 -108.525 -114.253C-119.862 -95.9277 -117.524 -72.2353 -112.182 -51.101L-112.667 -50.9785L-112.182 -51.101C-102.131 -11.3215 -82.6774 26.3833 -54.0518 55.6043L-54.409 55.9542'
        stroke='currentColor'
      />
      <path
        opacity='0.32'
        d='M93.7589 -19.9205C94.0326 -27.9493 91.3042 -35.2432 86.9866 -42.6168C82.8711 -49.6481 78.1449 -56.3129 72.9161 -62.5492C62.4265 -75.0536 49.9173 -85.8149 36.1237 -94.4624C27.0061 -100.18 17.3185 -104.981 7.25098 -108.749C-28.5527 -122.152 -68.5793 -122.743 -105.396 -112.6C-121.602 -108.134 -138.297 -100.8 -147.18 -86.4504C-156.943 -70.6695 -154.907 -50.3178 -150.348 -32.2847C-141.764 1.6895 -125.147 33.9031 -100.684 58.8753C-87.4219 72.4139 -69.2758 84.4029 -50.8365 80.3617C-37.438 77.4241 -27.3405 66.7723 -17.0533 57.6621C3.3215 39.62 27.5406 25.9968 53.4917 17.9739C61.3254 15.5544 69.403 13.5972 76.5548 9.5747C84.8371 4.91504 90.4912 -3.69187 92.7566 -12.8443C93.3588 -15.2769 93.6811 -17.6279 93.7589 -19.9205Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_5212_127756'>
        <rect width='153' height='84' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const ShapeRightIcon = () => (
  <svg
    width='128'
    height='47'
    viewBox='0 0 128 47'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_5212_127759)'>
      <path
        opacity='0.32'
        d='M124.014 5.58544C100.57 17.3401 74.6409 24.0272 48.4862 25.0699C47.018 25.128 45.5459 25.1692 44.0729 25.2104C37.6254 25.3906 31.1605 25.5713 24.9277 27.1785C16.0604 29.4661 8.66289 36.0807 4.28595 44.0429M124.014 5.58544L10.4495 95.2461C7.12504 88.1431 4.37468 80.7657 2.28399 73.1982M124.014 5.58544L124.238 6.0324C125.883 5.20746 127.527 4.35674 129.174 3.50441C133.48 1.27605 137.808 -0.963301 142.233 -2.78186C148.339 -5.29108 154.574 -6.97262 161.076 -6.6854C178.969 -5.89327 192.777 9.54859 201.761 25.4192L202.196 25.1729L201.761 25.4192C218.307 54.6474 225.785 88.6735 225.364 122.364L225.864 122.37L225.364 122.364C225.142 140.267 221.994 159.536 209.153 171.664C197.471 182.69 180.275 185.385 164.101 185.529C127.397 185.853 90.3737 175.413 60.4459 154.13L60.1561 154.537L60.4459 154.13C52.0317 148.146 44.2245 141.298 37.1728 133.739L36.8072 134.08L37.1728 133.739C26.5038 122.305 17.5503 109.228 10.9024 95.0341C7.58933 87.9556 4.84887 80.6045 2.76593 73.065L2.28399 73.1982M124.014 5.58544L124.238 6.03241C100.731 17.8189 74.7319 24.524 48.5062 25.5695L48.506 25.5695C47.0244 25.6282 45.5433 25.6697 44.0647 25.7111C37.6208 25.8917 31.2254 26.0709 25.0526 27.6626C16.3436 29.9094 9.04806 36.418 4.72412 44.2837L4.28595 44.0429M4.28595 44.0429C3.12251 46.159 2.23999 48.2687 1.59955 50.3843C-0.644216 57.7935 0.0897603 65.2618 2.28399 73.1982M4.28595 44.0429L4.7241 44.2838C3.57702 46.3702 2.70821 48.4477 2.07809 50.5292C-0.127619 57.8127 0.584883 65.1763 2.76592 73.0649L2.28399 73.1982'
        stroke='currentColor'
      />
      <path
        opacity='0.32'
        d='M43.9217 44.7317C42.1601 50.5486 42.7364 56.412 44.4591 62.6428C46.1005 68.5841 48.2598 74.3761 50.8699 79.9527C56.1072 91.1352 63.1602 101.436 71.5633 110.441C77.1175 116.395 83.2668 121.789 89.8946 126.502C113.465 143.265 142.615 151.481 171.506 151.226C184.223 151.113 197.856 148.998 207.142 140.234C217.349 130.595 219.818 115.319 219.992 101.248C220.324 74.7383 214.439 47.954 201.41 24.9381C194.347 12.4603 183.412 0.165551 169.144 -0.466079C158.777 -0.924069 149.323 4.89992 140.029 9.55996C121.624 18.7886 101.267 24.0386 80.7326 24.8573C74.5345 25.1027 68.248 24.9626 62.2368 26.5127C55.275 28.3087 49.4672 33.5019 46.0308 39.753C45.1174 41.4144 44.4245 43.0706 43.9217 44.7317Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_5212_127759'>
        <rect width='128' height='47' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const DocumentIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask
      id='mask0_5212_127725'
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='40'
      height='40'
    >
      <rect width='40' height='40' fill='#D9D9D9' />
    </mask>
    <g mask='url(#mask0_5212_127725)'>
      <path
        d='M14.7971 19.3804C14.4999 19.3804 14.2511 19.2797 14.0508 19.0784C13.8503 18.877 13.75 18.627 13.75 18.3284C13.75 18.0297 13.8503 17.7814 14.0508 17.5834C14.2511 17.3853 14.4999 17.2863 14.7971 17.2863H25.2029C25.5001 17.2863 25.7489 17.387 25.9492 17.5884C26.1497 17.7897 26.25 18.0397 26.25 18.3384C26.25 18.637 26.1497 18.8853 25.9492 19.0834C25.7489 19.2814 25.5001 19.3804 25.2029 19.3804H14.7971ZM14.7971 12.7138C14.4999 12.7138 14.2511 12.6131 14.0508 12.4117C13.8503 12.2103 13.75 11.9603 13.75 11.6617C13.75 11.3631 13.8503 11.1147 14.0508 10.9167C14.2511 10.7186 14.4999 10.6196 14.7971 10.6196H25.2029C25.5001 10.6196 25.7489 10.7203 25.9492 10.9217C26.1497 11.1231 26.25 11.3731 26.25 11.6717C26.25 11.9703 26.1497 12.2186 25.9492 12.4167C25.7489 12.6147 25.5001 12.7138 25.2029 12.7138H14.7971ZM9.59417 23.9529H22.5C23.2069 23.9529 23.8607 24.1086 24.4613 24.42C25.0618 24.7311 25.5765 25.1624 26.0054 25.7138L30.4058 31.4467V6.77377C30.4058 6.62405 30.3578 6.50113 30.2617 6.40502C30.1656 6.30891 30.0426 6.26085 29.8929 6.26085H10.1071C9.95736 6.26085 9.83444 6.30891 9.73833 6.40502C9.64222 6.50113 9.59417 6.62405 9.59417 6.77377V23.9529ZM10.1071 33.7392H29.5096L24.3538 26.9946C24.1296 26.6985 23.8567 26.4666 23.535 26.2988C23.2133 26.131 22.8683 26.0471 22.5 26.0471H9.59417V33.2263C9.59417 33.376 9.64222 33.4989 9.73833 33.595C9.83444 33.6911 9.95736 33.7392 10.1071 33.7392ZM29.8929 35.8334H10.1071C9.39069 35.8334 8.77708 35.5779 8.26625 35.0671C7.75542 34.5563 7.5 33.9427 7.5 33.2263V6.77377C7.5 6.05738 7.75542 5.44377 8.26625 4.93294C8.77708 4.4221 9.39069 4.16669 10.1071 4.16669H29.8929C30.6093 4.16669 31.2229 4.4221 31.7337 4.93294C32.2446 5.44377 32.5 6.05738 32.5 6.77377V33.2263C32.5 33.9427 32.2446 34.5563 31.7337 35.0671C31.2229 35.5779 30.6093 35.8334 29.8929 35.8334Z'
        fill='currentColor'
      />
    </g>
  </svg>
)

export const HistoryIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M8.4019 9.28184L6.1748 9.60042L6.49279 7.37272L12.2201 1.64539C12.4733 1.39223 12.8167 1.25 13.1747 1.25C13.5327 1.25 13.8761 1.39223 14.1292 1.64539C14.3824 1.89855 14.5246 2.24192 14.5246 2.59995C14.5246 2.95797 14.3824 3.30134 14.1292 3.5545L8.4019 9.28184Z'
        stroke='CurrentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.2746 9.34995V13.8497C12.2746 14.0884 12.1798 14.3173 12.011 14.4861C11.8422 14.6549 11.6133 14.7497 11.3746 14.7497H2.37506C2.13637 14.7497 1.90746 14.6549 1.73869 14.4861C1.56991 14.3173 1.4751 14.0884 1.4751 13.8497V4.85015C1.4751 4.61147 1.56991 4.38256 1.73869 4.21379C1.90746 4.04501 2.13637 3.9502 2.37506 3.9502H6.87485'
        stroke='CurrentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const LocationIcon2 = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask
        id='mask0_4005_9981'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4005_9981)'>
        <path
          d='M12.0011 19.5135C13.9575 17.7622 15.4545 16.0823 16.4924 14.474C17.5302 12.8657 18.0491 11.457 18.0491 10.248C18.0491 8.425 17.47 6.92633 16.3116 5.752C15.1533 4.57767 13.7165 3.9905 12.0011 3.9905C10.2858 3.9905 8.84896 4.57767 7.69062 5.752C6.53229 6.92633 5.95312 8.425 5.95312 10.248C5.95312 11.457 6.47204 12.8657 7.50988 14.474C8.54771 16.0823 10.0448 17.7622 12.0011 19.5135ZM12.0011 20.9403C11.8063 20.9403 11.6115 20.9067 11.4166 20.8395C11.2216 20.7722 11.0453 20.668 10.8876 20.527C9.99029 19.7 9.15054 18.8483 8.36838 17.972C7.58637 17.0958 6.90662 16.2199 6.32912 15.3443C5.75146 14.4686 5.29438 13.6007 4.95788 12.7405C4.62138 11.8802 4.45312 11.0493 4.45312 10.248C4.45312 7.94033 5.19954 6.07208 6.69237 4.64325C8.18537 3.21442 9.95496 2.5 12.0011 2.5C14.0473 2.5 15.8169 3.21442 17.3099 4.64325C18.8027 6.07208 19.5491 7.94033 19.5491 10.248C19.5491 11.0493 19.3809 11.8785 19.0444 12.7355C18.7079 13.5927 18.2525 14.4607 17.6781 15.3395C17.1036 16.2183 16.4254 17.0942 15.6434 17.9672C14.8614 18.8404 14.0216 19.6904 13.1241 20.5173C12.9688 20.6583 12.7922 20.764 12.5944 20.8345C12.3967 20.905 12.199 20.9403 12.0011 20.9403ZM12.0029 11.8652C12.5004 11.8652 12.9257 11.6881 13.2789 11.3338C13.6322 10.9794 13.8089 10.5535 13.8089 10.056C13.8089 9.5585 13.6317 9.13308 13.2774 8.77975C12.923 8.42658 12.497 8.25 11.9994 8.25C11.5019 8.25 11.0765 8.42717 10.7234 8.7815C10.37 9.13583 10.1934 9.56183 10.1934 10.0595C10.1934 10.557 10.3705 10.9823 10.7249 11.3355C11.0792 11.6887 11.5052 11.8652 12.0029 11.8652Z'
          fill='#707070'
        />
      </g>
    </svg>
  )
}

export const Map = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classes.modeColor}
    >
      <mask
        id='mask0_4005_9987'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4005_9987)'>
        <path d='M12.0977 16.4215L7.49996 15.0513L4.291 16.0965C4.17711 16.1338 4.07093 16.1429 3.97246 16.124C3.87413 16.1051 3.7817 16.0642 3.69517 16.0013C3.60864 15.9384 3.54058 15.8603 3.491 15.7672C3.44142 15.6741 3.41663 15.5722 3.41663 15.4615V5.50445C3.41663 5.29403 3.47461 5.10667 3.59058 4.94236C3.70642 4.77792 3.85093 4.66632 4.02413 4.60757L7.08975 3.57861C7.15183 3.55084 7.22052 3.53347 7.29579 3.52653C7.37107 3.51959 7.43913 3.51611 7.49996 3.51611C7.56079 3.51611 7.62885 3.51959 7.70413 3.52653C7.7794 3.53347 7.84808 3.55084 7.91017 3.57861L12.5 4.94882L15.7089 3.90361C15.8228 3.86639 15.929 3.85722 16.0275 3.87611C16.1258 3.895 16.2182 3.9359 16.3048 3.99882C16.3913 4.06174 16.4593 4.13979 16.5089 4.23299C16.5585 4.32604 16.5833 4.42792 16.5833 4.53861V14.5315C16.5833 14.7424 16.5248 14.9327 16.4079 15.1026C16.2908 15.2724 16.1361 15.3798 15.9439 15.4247L12.9023 16.4294C12.8381 16.4572 12.7695 16.4733 12.6964 16.4776C12.6234 16.4819 12.5577 16.484 12.4993 16.484C12.441 16.484 12.3755 16.4806 12.3029 16.4736C12.2302 16.4667 12.1618 16.4493 12.0977 16.4215ZM11.9583 15.2726V5.89757L8.04163 4.71153V14.0865L11.9583 15.2726ZM13.0416 15.2309L15.5 14.4167V5.0834L13.0416 5.89757V15.2309ZM4.49996 14.9167L6.95829 14.0865V4.7532L4.49996 5.5834V14.9167Z' />
      </g>
    </svg>
  )
}

export const PerfilDoctor = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classes.modeColor}
    >
      <path d='M16.2931 3.33662C16.2944 3.33782 16.2935 3.33999 16.2918 3.33999H14.7005C14.5164 3.33999 14.3672 3.48923 14.3672 3.67333V4.3557C14.3672 4.53979 14.5164 4.68903 14.7005 4.68903H15.7213C15.9054 4.68903 16.0547 4.83827 16.0547 5.02236V6.71258C16.0752 7.10389 16.0092 7.49496 15.8605 7.86209C15.7117 8.22923 15.4835 8.56478 15.1895 8.84841C14.8956 9.13203 14.542 9.35783 14.1503 9.51211C13.7586 9.66639 13.3369 9.74594 12.9108 9.74594C12.4847 9.74594 12.063 9.66639 11.6713 9.51211C11.2796 9.35783 10.9261 9.13203 10.6321 8.84841C10.3382 8.56478 10.1099 8.22923 9.96121 7.86209C9.8125 7.49496 9.74643 7.10389 9.767 6.71258V5.02236C9.767 4.83827 9.91624 4.68903 10.1003 4.68903H11.1211C11.3052 4.68903 11.4545 4.53979 11.4545 4.3557V3.67333C11.4545 3.48923 11.3052 3.33999 11.1211 3.33999H9.53221C9.21115 3.33999 8.90322 3.45725 8.67619 3.66597C8.44916 3.87469 8.32162 4.15778 8.32162 4.45295V6.67211C8.32183 7.6761 8.71118 8.64716 9.41977 9.4111C10.0658 10.1075 10.9385 10.5903 11.9047 10.7905C12.0666 10.824 12.1881 10.9631 12.1881 11.1285V12.4595C12.1671 13.1912 11.8451 13.8884 11.2872 14.4106C10.7293 14.9328 9.97688 15.2412 9.18149 15.2737C8.38611 15.3062 7.60687 15.0603 7.00077 14.5857C6.46532 14.1664 6.10016 13.596 5.95915 12.9674C5.92615 12.8203 6.01338 12.6782 6.14642 12.6073C6.56893 12.3821 6.90967 12.044 7.12128 11.6352C7.37026 11.1543 7.42402 10.6074 7.27286 10.0932C7.1217 9.579 6.77561 9.13144 6.29701 8.8313C5.8184 8.53116 5.23884 8.39821 4.66297 8.45644C4.08709 8.51468 3.55283 8.76027 3.15664 9.14888C2.76045 9.53749 2.52842 10.0435 2.50244 10.5756C2.47647 11.1077 2.65827 11.6308 3.015 12.0505C3.31729 12.4061 3.72833 12.6676 4.19229 12.8033C4.34021 12.8466 4.45183 12.973 4.46671 13.1263C4.50611 13.5324 4.59175 13.8269 4.80577 14.2442C5.0631 14.7459 5.42541 15.1961 5.87199 15.5691C6.31858 15.9421 6.8407 16.2305 7.40855 16.418C7.97639 16.6055 8.57883 16.6883 9.18149 16.6617C9.78415 16.6352 10.3752 16.4997 10.9209 16.2631C11.4667 16.0266 11.9564 15.6935 12.3621 15.2829C12.7678 14.8723 13.0816 14.3923 13.2855 13.8703C13.4894 13.3482 13.6262 12.7158 13.6262 12.4595V11.1285C13.6262 10.9632 13.7477 10.824 13.9097 10.7905C14.8766 10.5905 15.7502 10.108 16.3973 9.41165C17.1071 8.64786 17.498 7.67671 17.5 6.67211V4.4462C17.5 4.15103 17.3725 3.86795 17.1454 3.65923C16.9196 3.45159 16.6137 3.33447 16.2944 3.33326C16.2927 3.33325 16.2918 3.33542 16.2931 3.33662ZM3.95624 10.7192C3.95624 10.5431 4.01301 10.371 4.11942 10.2246C4.22584 10.0781 4.3771 9.96402 4.55406 9.89663C4.73102 9.82924 4.92577 9.81161 5.11364 9.84597C5.3015 9.88032 5.47405 9.96512 5.60949 10.0896C5.74493 10.2142 5.83718 10.3728 5.87455 10.5455C5.91191 10.7182 5.89272 10.8973 5.81942 11.0599C5.74612 11.2226 5.62201 11.3617 5.46275 11.4595C5.30348 11.5574 5.11621 11.6096 4.92466 11.6096C4.79754 11.6101 4.67165 11.5871 4.55442 11.5419C4.43719 11.4967 4.33103 11.4302 4.24234 11.3465C4.15194 11.2645 4.08014 11.1669 4.03102 11.0592C3.98191 10.9515 3.95649 10.836 3.95624 10.7192Z' />
    </svg>
  )
}

export const Disclaimer = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask
        id='mask0_4319_3595'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_4319_3595)'>
        <path
          d='M9.99582 13.7915C10.1482 13.7915 10.2772 13.7396 10.3829 13.6357C10.4887 13.5319 10.5417 13.4033 10.5417 13.2498V9.5415C10.5417 9.38803 10.4901 9.25935 10.3871 9.15546C10.284 9.05171 10.1564 8.99984 10.0042 8.99984C9.8518 8.99984 9.72277 9.05171 9.61707 9.15546C9.51124 9.25935 9.45832 9.38803 9.45832 9.5415V13.2498C9.45832 13.4033 9.50985 13.5319 9.61291 13.6357C9.71596 13.7396 9.8436 13.7915 9.99582 13.7915ZM9.99562 7.74025C10.1614 7.74025 10.3019 7.68414 10.4171 7.57192C10.5322 7.4597 10.5898 7.32067 10.5898 7.15484C10.5898 6.989 10.5337 6.84852 10.4214 6.73338C10.3092 6.61838 10.1702 6.56088 10.0044 6.56088C9.83853 6.56088 9.69805 6.61692 9.58291 6.729C9.46777 6.84123 9.4102 6.98025 9.4102 7.14609C9.4102 7.31192 9.46631 7.45241 9.57853 7.56755C9.69075 7.68268 9.82978 7.74025 9.99562 7.74025ZM10.0071 17.5832C8.96388 17.5832 7.98138 17.3858 7.05957 16.9911C6.13777 16.5964 5.33096 16.0532 4.63916 15.3617C3.94735 14.6702 3.40395 13.864 3.00895 12.9432C2.61409 12.0225 2.41666 11.0387 2.41666 9.99171C2.41666 8.94477 2.61402 7.96386 3.00874 7.049C3.40346 6.13414 3.94659 5.33081 4.63811 4.639C5.32964 3.9472 6.13582 3.4038 7.05666 3.0088C7.97735 2.61393 8.96117 2.4165 10.0081 2.4165C11.0551 2.4165 12.036 2.61386 12.9508 3.00859C13.8657 3.40331 14.669 3.94643 15.3608 4.63796C16.0526 5.32949 16.596 6.134 16.991 7.0515C17.3859 7.96914 17.5833 8.94956 17.5833 9.99275C17.5833 11.0359 17.386 12.0184 16.9912 12.9403C16.5965 13.8621 16.0534 14.6689 15.3619 15.3607C14.6703 16.0525 13.8658 16.5959 12.9483 16.9909C12.0307 17.3857 11.0503 17.5832 10.0071 17.5832ZM9.99999 16.4998C11.8055 16.4998 13.3403 15.8679 14.6042 14.604C15.868 13.3401 16.5 11.8054 16.5 9.99984C16.5 8.19428 15.868 6.65956 14.6042 5.39567C13.3403 4.13178 11.8055 3.49984 9.99999 3.49984C8.19443 3.49984 6.65971 4.13178 5.39582 5.39567C4.13193 6.65956 3.49999 8.19428 3.49999 9.99984C3.49999 11.8054 4.13193 13.3401 5.39582 14.604C6.65971 15.8679 8.19443 16.4998 9.99999 16.4998Z'
          fill='#424242'
        />
      </g>
    </svg>
  )
}

export const FaceIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4171_10295)">
        <circle cx="20" cy="20" r="20" fill="#FCF0F6" />
        <mask id="mask0_4171_10295" maskUnits="userSpaceOnUse" x="8" y="8" width="24" height="24">
          <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4171_10295)">
          <path d="M16.9996 24.2501C16.6496 24.2501 16.3538 24.1293 16.1121 23.8876C15.8704 23.646 15.7496 23.3501 15.7496 23.0001C15.7496 22.6501 15.8704 22.3543 16.1121 22.1126C16.3538 21.871 16.6496 21.7501 16.9996 21.7501C17.3496 21.7501 17.6454 21.871 17.8871 22.1126C18.1288 22.3543 18.2496 22.6501 18.2496 23.0001C18.2496 23.3501 18.1288 23.646 17.8871 23.8876C17.6454 24.1293 17.3496 24.2501 16.9996 24.2501ZM22.9996 24.2501C22.6496 24.2501 22.3538 24.1293 22.1121 23.8876C21.8704 23.646 21.7496 23.3501 21.7496 23.0001C21.7496 22.6501 21.8704 22.3543 22.1121 22.1126C22.3538 21.871 22.6496 21.7501 22.9996 21.7501C23.3496 21.7501 23.6454 21.871 23.8871 22.1126C24.1288 22.3543 24.2496 22.6501 24.2496 23.0001C24.2496 23.3501 24.1288 23.646 23.8871 23.8876C23.6454 24.1293 23.3496 24.2501 22.9996 24.2501ZM19.9996 30.0001C22.2329 30.0001 24.1246 29.2251 25.6746 27.6751C27.2246 26.1251 27.9996 24.2335 27.9996 22.0001C27.9996 21.6001 27.9746 21.2126 27.9246 20.8376C27.8746 20.4626 27.7829 20.1001 27.6496 19.7501C27.2996 19.8335 26.9496 19.896 26.5996 19.9376C26.2496 19.9793 25.8829 20.0001 25.4996 20.0001C23.9829 20.0001 22.5496 19.6751 21.1996 19.0251C19.8496 18.3751 18.6996 17.4668 17.7496 16.3001C17.2163 17.6001 16.4538 18.7293 15.4621 19.6876C14.4704 20.646 13.3163 21.3668 11.9996 21.8501V22.0001C11.9996 24.2335 12.7746 26.1251 14.3246 27.6751C15.8746 29.2251 17.7663 30.0001 19.9996 30.0001ZM18.1783 14.2214C18.936 15.6187 19.987 16.6812 21.3313 17.4089C22.6755 18.1364 24.0649 18.5001 25.4996 18.5001C25.7714 18.5001 26.0365 18.4861 26.2948 18.4579C26.5532 18.4297 26.815 18.3893 27.0803 18.3366C26.4123 17.0098 25.4448 15.9553 24.1776 15.1731C22.9103 14.3911 21.5176 14.0001 19.9996 14.0001C19.6638 14.0001 19.3506 14.0191 19.0601 14.0569C18.7698 14.0947 18.4758 14.1496 18.1783 14.2214ZM12.2803 20.0906C13.2202 19.6201 14.1125 18.9326 14.9573 18.0281C15.8022 17.1236 16.3477 16.0393 16.5938 14.7751C15.5002 15.2713 14.5758 15.9845 13.8208 16.9146C13.0657 17.8448 12.5522 18.9035 12.2803 20.0906ZM11.2996 18.3926C11.7149 17.2848 12.3281 16.2998 13.1391 15.4376C13.9499 14.5755 14.8996 13.9046 15.9881 13.4251C15.6663 13.0238 15.272 12.6988 14.8053 12.4501C14.3388 12.2015 13.8237 12.0771 13.2598 12.0771C12.2877 12.0771 11.466 12.413 10.7948 13.0846C10.1237 13.7561 9.78809 14.5786 9.78809 15.5521C9.78809 16.1441 9.92684 16.6851 10.2043 17.1749C10.482 17.6649 10.8471 18.0708 11.2996 18.3926ZM20.0013 31.5001C18.6873 31.5001 17.4523 31.2507 16.2961 30.7519C15.1399 30.2532 14.1343 29.5764 13.2791 28.7214C12.4239 27.8664 11.7468 26.861 11.2478 25.7051C10.749 24.5493 10.4996 23.3143 10.4996 22.0001C10.4996 21.627 10.5218 21.2571 10.5661 20.8906C10.6103 20.524 10.6798 20.1721 10.7746 19.8349C10.0259 19.4079 9.42434 18.8166 8.96984 18.0609C8.51534 17.3054 8.28809 16.4691 8.28809 15.5521C8.28809 14.1688 8.77142 12.9938 9.73809 12.0271C10.7048 11.0605 11.8798 10.5771 13.2631 10.5771C14.1273 10.5771 14.9222 10.7816 15.6478 11.1906C16.3733 11.5996 16.9611 12.1566 17.4111 12.8616C17.8188 12.7411 18.241 12.6508 18.6778 12.5906C19.1145 12.5303 19.5551 12.5001 19.9996 12.5001C21.3138 12.5001 22.5488 12.7495 23.7046 13.2481C24.8604 13.7468 25.8658 14.4236 26.7208 15.2784C27.5758 16.1332 28.2527 17.1385 28.7513 18.2941C29.2502 19.4498 29.4996 20.6846 29.4996 21.9984C29.4996 23.3124 29.2503 24.5475 28.7516 25.7036C28.2529 26.8598 27.5762 27.8655 26.7213 28.7206C25.8665 29.5758 24.8613 30.2529 23.7056 30.7519C22.5499 31.2507 21.3152 31.5001 20.0013 31.5001Z" fill="#707070" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4171_10295">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const CalendarClockIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <circle cx="20" cy="20" r="20" fill="#FCF0F6" />
      <mask id="mask0_4171_10306" maskUnits="userSpaceOnUse" x="8" y="8" width="24" height="24">
        <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4171_10306)">
        <path d="M13 16.8078H27V14.3078C27 14.2308 26.9679 14.1603 26.9038 14.0963C26.8398 14.0321 26.7693 14 26.6923 14H13.3078C13.2308 14 13.1603 14.0321 13.0963 14.0963C13.0321 14.1603 13 14.2308 13 14.3078V16.8078ZM13.3078 29.5C12.8026 29.5 12.375 29.325 12.025 28.975C11.675 28.625 11.5 28.1974 11.5 27.6923V14.3078C11.5 13.8026 11.675 13.375 12.025 13.025C12.375 12.675 12.8026 12.5 13.3078 12.5H14.6923V11.1538C14.6923 10.9346 14.7657 10.7516 14.9125 10.6048C15.0593 10.4581 15.2423 10.3848 15.4615 10.3848C15.6808 10.3848 15.8638 10.4581 16.0105 10.6048C16.1573 10.7516 16.2308 10.9346 16.2308 11.1538V12.5H23.8078V11.1348C23.8078 10.9219 23.8795 10.7437 24.023 10.6C24.1667 10.4565 24.3449 10.3848 24.5578 10.3848C24.7706 10.3848 24.9488 10.4565 25.0923 10.6C25.2359 10.7437 25.3078 10.9219 25.3078 11.1348V12.5H26.6923C27.1974 12.5 27.625 12.675 27.975 13.025C28.325 13.375 28.5 13.8026 28.5 14.3078V19.0213C28.5 19.2341 28.4282 19.4123 28.2845 19.5558C28.141 19.6994 27.9628 19.7713 27.75 19.7713C27.5372 19.7713 27.359 19.6994 27.2155 19.5558C27.0718 19.4123 27 19.2341 27 19.0213V18.3078H13V27.6923C13 27.7693 13.0321 27.8398 13.0963 27.9038C13.1603 27.9679 13.2308 28 13.3078 28H19.425C19.6378 28 19.8161 28.0718 19.9598 28.2155C20.1033 28.359 20.175 28.5372 20.175 28.75C20.175 28.9628 20.1033 29.141 19.9598 29.2845C19.8161 29.4282 19.6378 29.5 19.425 29.5H13.3078ZM26.1923 30.5C24.9436 30.5 23.8814 30.0622 23.0058 29.1865C22.1301 28.3108 21.6923 27.2487 21.6923 26C21.6923 24.7513 22.1301 23.6892 23.0058 22.8135C23.8814 21.9378 24.9436 21.5 26.1923 21.5C27.4411 21.5 28.5033 21.9378 29.3788 22.8135C30.2544 23.6892 30.6923 24.7513 30.6923 26C30.6923 27.2487 30.2544 28.3108 29.3788 29.1865C28.5033 30.0622 27.4411 30.5 26.1923 30.5ZM26.6348 25.8193V23.5C26.6348 23.3795 26.5911 23.2757 26.5038 23.1885C26.4166 23.1013 26.3128 23.0578 26.1923 23.0578C26.0718 23.0578 25.9679 23.1013 25.8808 23.1885C25.7936 23.2757 25.75 23.3795 25.75 23.5V25.8038C25.75 25.9243 25.7718 26.039 25.8155 26.148C25.859 26.257 25.9276 26.3583 26.0213 26.452L27.5463 27.977C27.6334 28.0642 27.7357 28.1094 27.853 28.1125C27.9702 28.1157 28.0756 28.0705 28.1693 27.977C28.2629 27.8834 28.3098 27.7795 28.3098 27.6655C28.3098 27.5513 28.2629 27.4474 28.1693 27.3538L26.6348 25.8193Z" fill="#707070" />
      </g>
    </svg>
  )
}
